//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://pinpoint-backend:8080";
    }

    /**
     * Get one note
     * @param salesPersonId sales person id
     * @param noteId note id
     * @return note data
     */
    v360_salesperson_notes_getOne(
        salesPersonId: number,
        noteId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/note/{noteId}";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_notes_getOne(_response);
            });
    }

    protected processV360_salesperson_notes_getOne(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Note modification
     * @param salesPersonId sales person id
     * @param noteId note id
     * @return note data
     */
    v360_salesperson_notes_modify(
        salesPersonId: number,
        noteId: number,
        body: EntityNote_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/note/{noteId}";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_notes_modify(_response);
            });
    }

    protected processV360_salesperson_notes_modify(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Delete note
     * @param salesPersonId sales person id
     * @param noteId note id
     * @return removed with success
     */
    v360_salesperson_notes_delete(
        salesPersonId: number,
        noteId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/note/{noteId}";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_notes_delete(_response);
            });
    }

    protected processV360_salesperson_notes_delete(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204 = _responseText;
            result204 = EntityNote_Public.fromJS(resultData204);
            return Promise.resolve<EntityNote_Public>(result204);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Get one note
     * @param intermediaryId intermediary id
     * @param noteId note id
     * @return note data
     */
    v360_intermediary_notes_getOne(
        intermediaryId: number,
        noteId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/note/{noteId}";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_notes_getOne(_response);
            });
    }

    protected processV360_intermediary_notes_getOne(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Note modification
     * @param intermediaryId intermediary id
     * @param noteId note id
     * @return note data
     */
    v360_intermediary_notes_modify(
        intermediaryId: number,
        noteId: number,
        body: EntityNote_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/note/{noteId}";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_notes_modify(_response);
            });
    }

    protected processV360_intermediary_notes_modify(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Delete note
     * @param intermediaryId intermediary id
     * @param noteId note id
     * @return removed with success
     */
    v360_intermediary_notes_delete(
        intermediaryId: number,
        noteId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/note/{noteId}";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (noteId === undefined || noteId === null) throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_notes_delete(_response);
            });
    }

    protected processV360_intermediary_notes_delete(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204 = _responseText;
            result204 = EntityNote_Public.fromJS(resultData204);
            return Promise.resolve<EntityNote_Public>(result204);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Get config for daily sales report
     * @return daily sales config
     */
    user_dailysales_config_get(cancelToken?: CancelToken | undefined): Promise<DailySalesConfig_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/daily-sales/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUser_dailysales_config_get(_response);
            });
    }

    protected processUser_dailysales_config_get(response: AxiosResponse): Promise<DailySalesConfig_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DailySalesConfig_Public.fromJS(resultData200);
            return Promise.resolve<DailySalesConfig_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailySalesConfig_Public>(null as any);
    }

    /**
     * Store config for daily sales report
     * @return no content
     */
    user_dailysales_config_put(body: DailySalesConfig_Public, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/v360/daily-sales/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUser_dailysales_config_put(_response);
            });
    }

    protected processUser_dailysales_config_put(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns one underwriter with given id
     * @return Underwriter data
     */
    uwr_getOneWithId(underwriterId: number, cancelToken?: CancelToken | undefined): Promise<Underwriter_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_getOneWithId(_response);
            });
    }

    protected processUwr_getOneWithId(response: AxiosResponse): Promise<Underwriter_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = Underwriter_Public.fromJS(resultData200);
            return Promise.resolve<Underwriter_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = Underwriter_Public.fromJS(resultData404);
            return throwException("Underwriter not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Underwriter_Public>(null as any);
    }

    /**
     * Update underwriter data
     * @return Underwriter data
     */
    uwr_modify(
        underwriterId: number,
        body: Underwriter_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<Underwriter_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_modify(_response);
            });
    }

    protected processUwr_modify(response: AxiosResponse): Promise<Underwriter_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = Underwriter_Public.fromJS(resultData200);
            return Promise.resolve<Underwriter_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = Underwriter_Public.fromJS(resultData404);
            return throwException("Underwriter not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Underwriter_Public>(null as any);
    }

    /**
     * Get one owcd entity
     * @param underwriterId underwriter id
     * @param owcdId owcd id
     * @return OK
     */
    uwr_owcd_getOne(
        underwriterId: number,
        owcdId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterOwcdData_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/owcd/{owcdId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (owcdId === undefined || owcdId === null) throw new Error("The parameter 'owcdId' must be defined.");
        url_ = url_.replace("{owcdId}", encodeURIComponent("" + owcdId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_owcd_getOne(_response);
            });
    }

    protected processUwr_owcd_getOne(response: AxiosResponse): Promise<UnderwriterOwcdData_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterOwcdData_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterOwcdData_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterOwcdData_Public>(null as any);
    }

    /**
     * Owcd data modification
     * @param underwriterId underwriter id
     * @param owcdId certificate id
     * @return OK
     */
    uwr_owcd_modify(
        underwriterId: number,
        owcdId: number,
        body: UnderwriterOwcdData_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterOwcdData_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/owcd/{owcdId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (owcdId === undefined || owcdId === null) throw new Error("The parameter 'owcdId' must be defined.");
        url_ = url_.replace("{owcdId}", encodeURIComponent("" + owcdId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_owcd_modify(_response);
            });
    }

    protected processUwr_owcd_modify(response: AxiosResponse): Promise<UnderwriterOwcdData_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterOwcdData_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterOwcdData_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterOwcdData_Public>(null as any);
    }

    /**
     * Owcd removal
     * @param underwriterId underwriter id
     * @param owcdId certificate id
     * @return Owcd entity has been removed
     */
    uwr_owcd_modify_1(underwriterId: number, owcdId: number, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/owcd/{owcdId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (owcdId === undefined || owcdId === null) throw new Error("The parameter 'owcdId' must be defined.");
        url_ = url_.replace("{owcdId}", encodeURIComponent("" + owcdId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_owcd_modify_1(_response);
            });
    }

    protected processUwr_owcd_modify_1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get one commission certificate
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return OK
     */
    uwr_commissionCertificate_getOne(
        underwriterId: number,
        certificateId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCommissionCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/commission-certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_commissionCertificate_getOne(_response);
            });
    }

    protected processUwr_commissionCertificate_getOne(
        response: AxiosResponse
    ): Promise<UnderwriterCommissionCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCommissionCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCommissionCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCommissionCertificate_Public>(null as any);
    }

    /**
     * Commission certificate modification
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return OK
     */
    uwr_commissionCertificate_modify(
        underwriterId: number,
        certificateId: number,
        body: UnderwriterCommissionCertificate_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCommissionCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/commission-certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_commissionCertificate_modify(_response);
            });
    }

    protected processUwr_commissionCertificate_modify(
        response: AxiosResponse
    ): Promise<UnderwriterCommissionCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCommissionCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCommissionCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCommissionCertificate_Public>(null as any);
    }

    /**
     * Commission certification removal
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return Certificate has been removed
     */
    uwr_commissionCertificate_modify_1(
        underwriterId: number,
        certificateId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/commission-certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_commissionCertificate_modify_1(_response);
            });
    }

    protected processUwr_commissionCertificate_modify_1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get one certificate
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return OK
     */
    uwr_certificate_getOne(
        underwriterId: number,
        certificateId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_certificate_getOne(_response);
            });
    }

    protected processUwr_certificate_getOne(response: AxiosResponse): Promise<UnderwriterCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCertificate_Public>(null as any);
    }

    /**
     * Certificate modification
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return OK
     */
    uwr_certificate_modify(
        underwriterId: number,
        certificateId: number,
        body: UnderwriterCertificate_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_certificate_modify(_response);
            });
    }

    protected processUwr_certificate_modify(response: AxiosResponse): Promise<UnderwriterCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCertificate_Public>(null as any);
    }

    /**
     * Certification removal
     * @param underwriterId underwriter id
     * @param certificateId certificate id
     * @return Certificate has been removed
     */
    uwr_certificate_modify_1(
        underwriterId: number,
        certificateId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/certificate/{certificateId}";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_certificate_modify_1(_response);
            });
    }

    protected processUwr_certificate_modify_1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns one team with given id
     * @return Underwriter team data
     */
    uwrTeam_getOneWithId(teamId: number, cancelToken?: CancelToken | undefined): Promise<UnderwriterTeam_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/team/{teamId}";
        if (teamId === undefined || teamId === null) throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwrTeam_getOneWithId(_response);
            });
    }

    protected processUwrTeam_getOneWithId(response: AxiosResponse): Promise<UnderwriterTeam_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterTeam_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterTeam_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = UnderwriterTeam_Public.fromJS(resultData404);
            return throwException("Team not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterTeam_Public>(null as any);
    }

    /**
     * Change team data
     * @return Underwriter team data
     */
    uwrTeam_modify(
        teamId: number,
        body: UnderwriterTeam_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterTeam_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/team/{teamId}";
        if (teamId === undefined || teamId === null) throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwrTeam_modify(_response);
            });
    }

    protected processUwrTeam_modify(response: AxiosResponse): Promise<UnderwriterTeam_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterTeam_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterTeam_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = UnderwriterTeam_Public.fromJS(resultData404);
            return throwException("Not found", status, _responseText, _headers, result404);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterTeam_Public>(null as any);
    }

    /**
     * Set status for the task
     * @param id id of the dashboard task
     * @param body request data
     * @return Updated task
     */
    dashboard_setStatus(
        id: number,
        body: DashboardTask_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/status";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_setStatus(_response);
            });
    }

    protected processDashboard_setStatus(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Set planned date for the task
     * @param id id of the dashboard task
     * @param body request data
     * @return Updated task
     */
    dashboard_setPlannedDate(
        id: number,
        body: DashboardTask_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/planned-date";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_setPlannedDate(_response);
            });
    }

    protected processDashboard_setPlannedDate(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Create new task comment
     * @param id id of the dashboard task
     * @param commentId id of comment
     * @return Updated task
     */
    dashboard_comment_modify(
        id: number,
        commentId: number,
        body: DashboardTaskComment_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/comment/{commentId}";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_comment_modify(_response);
            });
    }

    protected processDashboard_comment_modify(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id or comment with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Comment removal
     * @param id id of the dashboard task
     * @param commentId id of comment
     * @return Updated task (without removed comment)
     */
    dashboard_comment_remove(
        id: number,
        commentId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/comment/{commentId}";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_comment_remove(_response);
            });
    }

    protected processDashboard_comment_remove(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id or comment with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Change of the dynamic task attribute
     * @param id id of the dashboard task
     * @param attributeId task attribute id
     * @return Updated task
     */
    dashboard_attribute_change(
        id: number,
        attributeId: number,
        body: DashboardTaskAttribute_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/attribute/{attributeId}";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attributeId === undefined || attributeId === null)
            throw new Error("The parameter 'attributeId' must be defined.");
        url_ = url_.replace("{attributeId}", encodeURIComponent("" + attributeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_attribute_change(_response);
            });
    }

    protected processDashboard_attribute_change(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id or an attribute with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Task assignment operation
     * @param id id of the dashboard task
     * @param body request data
     * @return Updated task
     */
    dashboard_assigneeList(
        id: number,
        body: DashboardTask_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/assignee";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_assigneeList(_response);
            });
    }

    protected processDashboard_assigneeList(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Dashboard card operation
     * @return Card operation performed with success
     */
    dashboard_card_operation(body: CardEvent_Public, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/secured/card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_card_operation(_response);
            });
    }

    protected processDashboard_card_operation(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204 = _responseText;
            result204 = resultData204 !== undefined ? resultData204 : <any>null;

            return Promise.resolve<any>(result204);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get list of notes
     * @param salesPersonId sales person id
     * @param offset (optional) notes response offset, default 0
     * @param limit (optional) notes response limit
     * @param phrase (optional) phrase to limit sales person / intermediary - used for search without entity context
     * @param orderBy (optional) order by column
     * @param orderDirection (optional) order direction (asc, desc)
     * @param minFirstEditDate (optional) minimum first edit date
     * @param maxFirstEditDate (optional) maximum first edit date
     * @param minLastEditDate (optional) minimum last edit date
     * @param maxLastEditDate (optional) maximum last edit date
     * @param minContactDate (optional) minimum contact date
     * @param maxContactDate (optional) maximum contact date
     * @param noteTypeCode (optional) note type code (see NOTE_TYPE dictionary items)
     * @param noteTypeCodeList (optional) note type code list (see NOTE_TYPE dictionary items)
     * @param authorId (optional) reference to the primary author of the note
     * @param subjectCorpoCodeList (optional) list of the corporate subject list of the note (at least one much match)
     * @param subjectRetailCodeList (optional) list of the retail subject list of the note (at least one much match)
     * @return list of notes
     */
    v360_salesperson_notes_getList(
        salesPersonId: number,
        offset: string | undefined,
        limit: string | undefined,
        phrase: string | undefined,
        orderBy: string | undefined,
        orderDirection: string | undefined,
        minFirstEditDate: string | undefined,
        maxFirstEditDate: string | undefined,
        minLastEditDate: string | undefined,
        maxLastEditDate: string | undefined,
        minContactDate: string | undefined,
        maxContactDate: string | undefined,
        noteTypeCode: string | undefined,
        noteTypeCodeList: string | undefined,
        authorId: string | undefined,
        subjectCorpoCodeList: string | undefined,
        subjectRetailCodeList: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNoteSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/note?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (phrase === null) throw new Error("The parameter 'phrase' cannot be null.");
        else if (phrase !== undefined) url_ += "phrase=" + encodeURIComponent("" + phrase) + "&";
        if (orderBy === null) throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined) url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderDirection === null) throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (minFirstEditDate === null) throw new Error("The parameter 'minFirstEditDate' cannot be null.");
        else if (minFirstEditDate !== undefined)
            url_ += "minFirstEditDate=" + encodeURIComponent("" + minFirstEditDate) + "&";
        if (maxFirstEditDate === null) throw new Error("The parameter 'maxFirstEditDate' cannot be null.");
        else if (maxFirstEditDate !== undefined)
            url_ += "maxFirstEditDate=" + encodeURIComponent("" + maxFirstEditDate) + "&";
        if (minLastEditDate === null) throw new Error("The parameter 'minLastEditDate' cannot be null.");
        else if (minLastEditDate !== undefined)
            url_ += "minLastEditDate=" + encodeURIComponent("" + minLastEditDate) + "&";
        if (maxLastEditDate === null) throw new Error("The parameter 'maxLastEditDate' cannot be null.");
        else if (maxLastEditDate !== undefined)
            url_ += "maxLastEditDate=" + encodeURIComponent("" + maxLastEditDate) + "&";
        if (minContactDate === null) throw new Error("The parameter 'minContactDate' cannot be null.");
        else if (minContactDate !== undefined)
            url_ += "minContactDate=" + encodeURIComponent("" + minContactDate) + "&";
        if (maxContactDate === null) throw new Error("The parameter 'maxContactDate' cannot be null.");
        else if (maxContactDate !== undefined)
            url_ += "maxContactDate=" + encodeURIComponent("" + maxContactDate) + "&";
        if (noteTypeCode === null) throw new Error("The parameter 'noteTypeCode' cannot be null.");
        else if (noteTypeCode !== undefined) url_ += "noteTypeCode=" + encodeURIComponent("" + noteTypeCode) + "&";
        if (noteTypeCodeList === null) throw new Error("The parameter 'noteTypeCodeList' cannot be null.");
        else if (noteTypeCodeList !== undefined)
            url_ += "noteTypeCodeList=" + encodeURIComponent("" + noteTypeCodeList) + "&";
        if (authorId === null) throw new Error("The parameter 'authorId' cannot be null.");
        else if (authorId !== undefined) url_ += "authorId=" + encodeURIComponent("" + authorId) + "&";
        if (subjectCorpoCodeList === null) throw new Error("The parameter 'subjectCorpoCodeList' cannot be null.");
        else if (subjectCorpoCodeList !== undefined)
            url_ += "subjectCorpoCodeList=" + encodeURIComponent("" + subjectCorpoCodeList) + "&";
        if (subjectRetailCodeList === null) throw new Error("The parameter 'subjectRetailCodeList' cannot be null.");
        else if (subjectRetailCodeList !== undefined)
            url_ += "subjectRetailCodeList=" + encodeURIComponent("" + subjectRetailCodeList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_notes_getList(_response);
            });
    }

    protected processV360_salesperson_notes_getList(response: AxiosResponse): Promise<EntityNoteSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNoteSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<EntityNoteSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNoteSearchResult_Public>(null as any);
    }

    /**
     * Get list of notes
     * @param salesPersonId sales person id
     * @return created note
     */
    v360_salesperson_notes_create(
        salesPersonId: number,
        body: EntityNote_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/note";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_notes_create(_response);
            });
    }

    protected processV360_salesperson_notes_create(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Multi query report
     * @param salesPersonId sales person id
     * @return Multi query report response
     */
    v360_reports_salesperson_multiquery(
        salesPersonId: number,
        body: MultiReportRequest_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public[]> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/multi";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_multiquery(_response);
            });
    }

    protected processV360_reports_salesperson_multiquery(response: AxiosResponse): Promise<SalesReportHolder_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(SalesReportHolder_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesReportHolder_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public[]>(null as any);
    }

    /**
     * Multi query report
     * @param intermediaryId intermediary id
     * @return Multi query report response
     */
    v360_reports_intermediary_multiquery(
        intermediaryId: number,
        body: MultiReportRequest_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public[]> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/multi";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_multiquery(_response);
            });
    }

    protected processV360_reports_intermediary_multiquery(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(SalesReportHolder_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesReportHolder_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public[]>(null as any);
    }

    /**
     * Get list of notes
     * @param intermediaryId intermediary id
     * @param offset (optional) notes response offset, default 0
     * @param limit (optional) notes response limit
     * @param phrase (optional) phrase to limit sales person / intermediary - used for search without entity context
     * @param orderBy (optional) order by column
     * @param orderDirection (optional) order direction (asc, desc)
     * @param minFirstEditDate (optional) minimum first edit date
     * @param maxFirstEditDate (optional) maximum first edit date
     * @param minLastEditDate (optional) minimum last edit date
     * @param maxLastEditDate (optional) maximum last edit date
     * @param minContactDate (optional) minimum contact date
     * @param maxContactDate (optional) maximum contact date
     * @param noteTypeCode (optional) note type code (see NOTE_TYPE dictionary items)
     * @param noteTypeCodeList (optional) note type code list (see NOTE_TYPE dictionary items)
     * @param authorId (optional) reference to the primary author of the note
     * @param subjectCorpoCodeList (optional) list of the corporate subject list of the note (at least one much match)
     * @param subjectRetailCodeList (optional) list of the retail subject list of the note (at least one much match)
     * @return list of notes
     */
    v360_intermediary_notes_getList(
        intermediaryId: number,
        offset: string | undefined,
        limit: string | undefined,
        phrase: string | undefined,
        orderBy: string | undefined,
        orderDirection: string | undefined,
        minFirstEditDate: string | undefined,
        maxFirstEditDate: string | undefined,
        minLastEditDate: string | undefined,
        maxLastEditDate: string | undefined,
        minContactDate: string | undefined,
        maxContactDate: string | undefined,
        noteTypeCode: string | undefined,
        noteTypeCodeList: string | undefined,
        authorId: string | undefined,
        subjectCorpoCodeList: string | undefined,
        subjectRetailCodeList: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNoteSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/note?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (phrase === null) throw new Error("The parameter 'phrase' cannot be null.");
        else if (phrase !== undefined) url_ += "phrase=" + encodeURIComponent("" + phrase) + "&";
        if (orderBy === null) throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined) url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderDirection === null) throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (minFirstEditDate === null) throw new Error("The parameter 'minFirstEditDate' cannot be null.");
        else if (minFirstEditDate !== undefined)
            url_ += "minFirstEditDate=" + encodeURIComponent("" + minFirstEditDate) + "&";
        if (maxFirstEditDate === null) throw new Error("The parameter 'maxFirstEditDate' cannot be null.");
        else if (maxFirstEditDate !== undefined)
            url_ += "maxFirstEditDate=" + encodeURIComponent("" + maxFirstEditDate) + "&";
        if (minLastEditDate === null) throw new Error("The parameter 'minLastEditDate' cannot be null.");
        else if (minLastEditDate !== undefined)
            url_ += "minLastEditDate=" + encodeURIComponent("" + minLastEditDate) + "&";
        if (maxLastEditDate === null) throw new Error("The parameter 'maxLastEditDate' cannot be null.");
        else if (maxLastEditDate !== undefined)
            url_ += "maxLastEditDate=" + encodeURIComponent("" + maxLastEditDate) + "&";
        if (minContactDate === null) throw new Error("The parameter 'minContactDate' cannot be null.");
        else if (minContactDate !== undefined)
            url_ += "minContactDate=" + encodeURIComponent("" + minContactDate) + "&";
        if (maxContactDate === null) throw new Error("The parameter 'maxContactDate' cannot be null.");
        else if (maxContactDate !== undefined)
            url_ += "maxContactDate=" + encodeURIComponent("" + maxContactDate) + "&";
        if (noteTypeCode === null) throw new Error("The parameter 'noteTypeCode' cannot be null.");
        else if (noteTypeCode !== undefined) url_ += "noteTypeCode=" + encodeURIComponent("" + noteTypeCode) + "&";
        if (noteTypeCodeList === null) throw new Error("The parameter 'noteTypeCodeList' cannot be null.");
        else if (noteTypeCodeList !== undefined)
            url_ += "noteTypeCodeList=" + encodeURIComponent("" + noteTypeCodeList) + "&";
        if (authorId === null) throw new Error("The parameter 'authorId' cannot be null.");
        else if (authorId !== undefined) url_ += "authorId=" + encodeURIComponent("" + authorId) + "&";
        if (subjectCorpoCodeList === null) throw new Error("The parameter 'subjectCorpoCodeList' cannot be null.");
        else if (subjectCorpoCodeList !== undefined)
            url_ += "subjectCorpoCodeList=" + encodeURIComponent("" + subjectCorpoCodeList) + "&";
        if (subjectRetailCodeList === null) throw new Error("The parameter 'subjectRetailCodeList' cannot be null.");
        else if (subjectRetailCodeList !== undefined)
            url_ += "subjectRetailCodeList=" + encodeURIComponent("" + subjectRetailCodeList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_notes_getList(_response);
            });
    }

    protected processV360_intermediary_notes_getList(response: AxiosResponse): Promise<EntityNoteSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNoteSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<EntityNoteSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNoteSearchResult_Public>(null as any);
    }

    /**
     * Get list of notes
     * @param intermediaryId intermediary id
     * @return created note
     */
    v360_intermediary_notes_create(
        intermediaryId: number,
        body: EntityNote_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNote_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/note";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_notes_create(_response);
            });
    }

    protected processV360_intermediary_notes_create(response: AxiosResponse): Promise<EntityNote_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNote_Public.fromJS(resultData200);
            return Promise.resolve<EntityNote_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNote_Public>(null as any);
    }

    /**
     * Retrieve azure token
     * @return OK
     */
    user_azure_token(
        body: AzureAppTokenRequest_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<AzureAppToken_Public> {
        let url_ = this.baseUrl + "/api/secured/user/azure/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUser_azure_token(_response);
            });
    }

    protected processUser_azure_token(response: AxiosResponse): Promise<AzureAppToken_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AzureAppToken_Public.fromJS(resultData200);
            return Promise.resolve<AzureAppToken_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureAppToken_Public>(null as any);
    }

    /**
     * Search for underwriter
     * @param pesel (optional) underwriter pesel
     * @param underwriterNumber (optional) underwriter number
     * @param login (optional) underwriter login
     * @param name (optional) underwriter first / last name
     * @param branchCode (optional) underwriter assigned branch code
     * @param statusCode (optional) underwriter status code
     * @param orderByField (optional) order by column
     * @param orderIndex (optional) order direction (asc, desc)
     * @param limit (optional) response size, default and max is 200
     * @param offset (optional) search record offset
     * @return List of underwriter header data
     */
    uwr_search(
        pesel: string | undefined,
        underwriterNumber: string | undefined,
        login: string | undefined,
        name: string | undefined,
        branchCode: string | undefined,
        statusCode: string | undefined,
        orderByField: OrderByField | undefined,
        orderIndex: OrderIndex | undefined,
        limit: string | undefined,
        offset: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter?";
        if (pesel === null) throw new Error("The parameter 'pesel' cannot be null.");
        else if (pesel !== undefined) url_ += "pesel=" + encodeURIComponent("" + pesel) + "&";
        if (underwriterNumber === null) throw new Error("The parameter 'underwriterNumber' cannot be null.");
        else if (underwriterNumber !== undefined)
            url_ += "underwriterNumber=" + encodeURIComponent("" + underwriterNumber) + "&";
        if (login === null) throw new Error("The parameter 'login' cannot be null.");
        else if (login !== undefined) url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (branchCode === null) throw new Error("The parameter 'branchCode' cannot be null.");
        else if (branchCode !== undefined) url_ += "branchCode=" + encodeURIComponent("" + branchCode) + "&";
        if (statusCode === null) throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined) url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        if (orderByField === null) throw new Error("The parameter 'orderByField' cannot be null.");
        else if (orderByField !== undefined) url_ += "orderByField=" + encodeURIComponent("" + orderByField) + "&";
        if (orderIndex === null) throw new Error("The parameter 'orderIndex' cannot be null.");
        else if (orderIndex !== undefined) url_ += "orderIndex=" + encodeURIComponent("" + orderIndex) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_search(_response);
            });
    }

    protected processUwr_search(response: AxiosResponse): Promise<UnderwriterSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterSearchResult_Public>(null as any);
    }

    /**
     * Create new underwriter entity
     * @return Underwriter data
     */
    uwr_create(body: Underwriter_Public, cancelToken?: CancelToken | undefined): Promise<Underwriter_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_create(_response);
            });
    }

    protected processUwr_create(response: AxiosResponse): Promise<Underwriter_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = Underwriter_Public.fromJS(resultData200);
            return Promise.resolve<Underwriter_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Underwriter_Public>(null as any);
    }

    /**
     * Get owcd list for given underwriter
     * @param underwriterId underwriter id
     * @return OK
     */
    uwr_owcd_getList(
        underwriterId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterOwcdData_Public[]> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/owcd";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_owcd_getList(_response);
            });
    }

    protected processUwr_owcd_getList(response: AxiosResponse): Promise<UnderwriterOwcdData_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(UnderwriterOwcdData_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<UnderwriterOwcdData_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterOwcdData_Public[]>(null as any);
    }

    /**
     * Create owcd entity
     * @param underwriterId underwriter id
     * @return OK
     */
    uwr_owcd_create(
        underwriterId: number,
        body: UnderwriterOwcdData_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterOwcdData_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/owcd";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_owcd_create(_response);
            });
    }

    protected processUwr_owcd_create(response: AxiosResponse): Promise<UnderwriterOwcdData_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterOwcdData_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterOwcdData_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterOwcdData_Public>(null as any);
    }

    /**
     * Commission certification list for given underwriter
     * @param underwriterId underwriter id
     * @return OK
     */
    uwr_commissionCertificate_getList(
        underwriterId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCommissionCertificate_Public[]> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/commission-certificate";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_commissionCertificate_getList(_response);
            });
    }

    protected processUwr_commissionCertificate_getList(
        response: AxiosResponse
    ): Promise<UnderwriterCommissionCertificate_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(UnderwriterCommissionCertificate_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<UnderwriterCommissionCertificate_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCommissionCertificate_Public[]>(null as any);
    }

    /**
     * Create new commission certification entity for underwriter
     * @param underwriterId underwriter id
     * @return OK
     */
    create(
        underwriterId: number,
        body: UnderwriterCommissionCertificate_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCommissionCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/commission-certificate";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processCreate(_response);
            });
    }

    protected processCreate(response: AxiosResponse): Promise<UnderwriterCommissionCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCommissionCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCommissionCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCommissionCertificate_Public>(null as any);
    }

    /**
     * Certification list for given underwriter
     * @param underwriterId underwriter id
     * @return OK
     */
    uwr_certificate_getList(
        underwriterId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCertificate_Public[]> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/certificate";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_certificate_getList(_response);
            });
    }

    protected processUwr_certificate_getList(response: AxiosResponse): Promise<UnderwriterCertificate_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(UnderwriterCertificate_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<UnderwriterCertificate_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCertificate_Public[]>(null as any);
    }

    /**
     * Create new certification entity for underwriter
     * @param underwriterId underwriter id
     * @return OK
     */
    uwr_certificate_create(
        underwriterId: number,
        body: UnderwriterCertificate_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterCertificate_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/certificate";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_certificate_create(_response);
            });
    }

    protected processUwr_certificate_create(response: AxiosResponse): Promise<UnderwriterCertificate_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterCertificate_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterCertificate_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterCertificate_Public>(null as any);
    }

    /**
     * Returns list of underwriter teams
     * @param code (optional) team code
     * @param name (optional) team name
     * @param typeCode (optional) team type code
     * @param cityCode (optional) team city code
     * @param orderByField (optional) order by column
     * @param orderIndex (optional) order direction (asc, desc)
     * @param limit (optional) response size, default and max is 100
     * @param offset (optional) search record offset
     * @return Underwriter team search response
     */
    uwrTeam_search(
        code: string | undefined,
        name: string | undefined,
        typeCode: string | undefined,
        cityCode: string | undefined,
        orderByField: OrderByField2 | undefined,
        orderIndex: OrderIndex2 | undefined,
        limit: string | undefined,
        offset: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterTeamSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/team?";
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (typeCode === null) throw new Error("The parameter 'typeCode' cannot be null.");
        else if (typeCode !== undefined) url_ += "typeCode=" + encodeURIComponent("" + typeCode) + "&";
        if (cityCode === null) throw new Error("The parameter 'cityCode' cannot be null.");
        else if (cityCode !== undefined) url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        if (orderByField === null) throw new Error("The parameter 'orderByField' cannot be null.");
        else if (orderByField !== undefined) url_ += "orderByField=" + encodeURIComponent("" + orderByField) + "&";
        if (orderIndex === null) throw new Error("The parameter 'orderIndex' cannot be null.");
        else if (orderIndex !== undefined) url_ += "orderIndex=" + encodeURIComponent("" + orderIndex) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwrTeam_search(_response);
            });
    }

    protected processUwrTeam_search(response: AxiosResponse): Promise<UnderwriterTeamSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterTeamSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterTeamSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterTeamSearchResult_Public>(null as any);
    }

    /**
     * Create new underwriter team
     * @return Underwriter team data
     */
    uwrTeam_create(
        body: UnderwriterTeam_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterTeam_Public> {
        let url_ = this.baseUrl + "/api/secured/underwriter/team";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwrTeam_create(_response);
            });
    }

    protected processUwrTeam_create(response: AxiosResponse): Promise<UnderwriterTeam_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UnderwriterTeam_Public.fromJS(resultData200);
            return Promise.resolve<UnderwriterTeam_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterTeam_Public>(null as any);
    }

    /**
     * Get list available score cards (V3)
     * @return Score card period identity
     */
    scorecard_v3_periodList(
        periodType: PeriodType,
        cancelToken?: CancelToken | undefined
    ): Promise<ScorecardV3_Public[]> {
        let url_ = this.baseUrl + "/api/secured/report/score-card/v3?";
        if (periodType === undefined || periodType === null)
            throw new Error("The parameter 'periodType' must be defined and cannot be null.");
        else url_ += "periodType=" + encodeURIComponent("" + periodType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processScorecard_v3_periodList(_response);
            });
    }

    protected processScorecard_v3_periodList(response: AxiosResponse): Promise<ScorecardV3_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(ScorecardV3_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<ScorecardV3_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScorecardV3_Public[]>(null as any);
    }

    /**
     * Get list available score cards (V3)
     * @return Score card period identity
     */
    scorecard_v3_getReport(
        body: ScorecardReportV3Filter_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<ScorecardV3Report_Public> {
        let url_ = this.baseUrl + "/api/secured/report/score-card/v3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processScorecard_v3_getReport(_response);
            });
    }

    protected processScorecard_v3_getReport(response: AxiosResponse): Promise<ScorecardV3Report_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ScorecardV3Report_Public.fromJS(resultData200);
            return Promise.resolve<ScorecardV3Report_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScorecardV3Report_Public>(null as any);
    }

    /**
     * Get ranking report
     * @return Ranking report
     */
    ranking_v3_report(
        body: RankingV3ReportFilter_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<RankingV3Report_Public> {
        let url_ = this.baseUrl + "/api/secured/report/ranking/v3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processRanking_v3_report(_response);
            });
    }

    protected processRanking_v3_report(response: AxiosResponse): Promise<RankingV3Report_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RankingV3Report_Public.fromJS(resultData200);
            return Promise.resolve<RankingV3Report_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RankingV3Report_Public>(null as any);
    }

    /**
     * Create new task comment
     * @param id id of the dashboard task
     * @return Updated task
     */
    dashboard_comment_create(
        id: number,
        body: DashboardTaskComment_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/comment";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_comment_create(_response);
            });
    }

    protected processDashboard_comment_create(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * New dashboard attachment
     * @param id id of the dashboard task
     * @return Updated task
     */
    dashboard_attachment_add(
        id: number,
        body: SystemFile_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/attachment";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_attachment_add(_response);
            });
    }

    protected processDashboard_attachment_add(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * teams authorization
     * @return user is authenticated and authorized for application usage; Additionally server side cookie is returned with `X-Auth-Token`
     */
    auth_teams(authorization: string, cancelToken?: CancelToken | undefined): Promise<SystemUser_Public> {
        let url_ = this.baseUrl + "/api/public/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                Authorization: authorization !== undefined && authorization !== null ? "" + authorization : "",
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processAuth_teams(_response);
            });
    }

    protected processAuth_teams(response: AxiosResponse): Promise<SystemUser_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SystemUser_Public.fromJS(resultData200);
            return Promise.resolve<SystemUser_Public>(result200);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemUser_Public>(null as any);
    }

    /**
     * one time token authorization
     * @return user is authenticated and authorized for application usage; Additionally server side cookie is returned with `X-Auth-Token`
     */
    auth_internalToken(token: string, cancelToken?: CancelToken | undefined): Promise<SystemUser_Public> {
        let url_ = this.baseUrl + "/api/public/auth/token/{token}";
        if (token === undefined || token === null) throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processAuth_internalToken(_response);
            });
    }

    protected processAuth_internalToken(response: AxiosResponse): Promise<SystemUser_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SystemUser_Public.fromJS(resultData200);
            return Promise.resolve<SystemUser_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SystemUser_Public.fromJS(resultData404);
            return throwException("invalid token / token not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemUser_Public>(null as any);
    }

    /**
     * @return OK
     */
    auth(params: { [key: string]: string }, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/public/auth/azure?";
        if (params === undefined || params === null)
            throw new Error("The parameter 'params' must be defined and cannot be null.");
        else url_ += "params=" + encodeURIComponent("" + params) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processAuth(_response);
            });
    }

    protected processAuth(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search
     * @param filter filter
     * @return List of network entities
     */
    v360_search(
        filter: V360SearchFilter_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<V360SearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/search?";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_search(_response);
            });
    }

    protected processV360_search(response: AxiosResponse): Promise<V360SearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = V360SearchResult_Public.fromJS(resultData200);
            return Promise.resolve<V360SearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V360SearchResult_Public>(null as any);
    }

    /**
     * Get one sales person
     * @param salesPersonId sales person id
     * @return Sales person data
     */
    v360_salesperson_get(
        salesPersonId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesPersonV360_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_salesperson_get(_response);
            });
    }

    protected processV360_salesperson_get(response: AxiosResponse): Promise<SalesPersonV360_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesPersonV360_Public.fromJS(resultData200);
            return Promise.resolve<SalesPersonV360_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesPersonV360_Public.fromJS(resultData404);
            return throwException("Sales person is not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesPersonV360_Public>(null as any);
    }

    /**
     * Daily sales report for sales person
     * @return daily sales report result
     */
    salesperson_dailysales_today(
        salesPersonId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<DailySalesReport_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/salesperson/{salesPersonId}/daily-sales/today";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processSalesperson_dailysales_today(_response);
            });
    }

    protected processSalesperson_dailysales_today(response: AxiosResponse): Promise<DailySalesReport_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DailySalesReport_Public.fromJS(resultData200);
            return Promise.resolve<DailySalesReport_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailySalesReport_Public>(null as any);
    }

    /**
     * Sales report
     * @param salesPersonId sales person id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return sales report
     */
    v360_reports_salesperson_sales(
        salesPersonId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/sales?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_sales(_response);
            });
    }

    protected processV360_reports_salesperson_sales(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Product structure
     * @param salesPersonId sales person id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return product structure report
     */
    v360_reports_salesperson_productstructure(
        salesPersonId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/product-structure?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_productstructure(_response);
            });
    }

    protected processV360_reports_salesperson_productstructure(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Monthly sales
     * @param salesPersonId sales person id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return monthly sales report
     */
    v360_reports_salesperson_monthly(
        salesPersonId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/monthly?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_monthly(_response);
            });
    }

    protected processV360_reports_salesperson_monthly(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Cumulative sales
     * @param salesPersonId sales person id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return cumulative sales report
     */
    v360_reports_salesperson_cumulatvesales(
        salesPersonId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/cumulative?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_cumulatvesales(_response);
            });
    }

    protected processV360_reports_salesperson_cumulatvesales(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Reports configuration
     * @param salesPersonId sales person id
     * @return reports configuration object
     */
    v360_reports_salesperson_config(
        salesPersonId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportConfig_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/config";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_config(_response);
            });
    }

    protected processV360_reports_salesperson_config(response: AxiosResponse): Promise<SalesReportConfig_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportConfig_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportConfig_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportConfig_Public>(null as any);
    }

    /**
     * Reports configuration
     * @param salesPersonId sales person id
     * @return reports configuration object
     */
    v360_reports_salesperson_config_v2(
        salesPersonId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportConfigV2_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/config/v2";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_config_v2(_response);
            });
    }

    protected processV360_reports_salesperson_config_v2(response: AxiosResponse): Promise<SalesReportConfigV2_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportConfigV2_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportConfigV2_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportConfigV2_Public>(null as any);
    }

    /**
     * Activity report
     * @param salesPersonId sales person id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return activity report
     */
    v360_reports_salesperson_activity(
        salesPersonId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/sales-person/{salesPersonId}/activity?";
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined.");
        url_ = url_.replace("{salesPersonId}", encodeURIComponent("" + salesPersonId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_salesperson_activity(_response);
            });
    }

    protected processV360_reports_salesperson_activity(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Sales report
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return sales report
     */
    v360_reports_intermediary_sales(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/sales?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_sales(_response);
            });
    }

    protected processV360_reports_intermediary_sales(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Product structure
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return product structure report
     */
    v360_reports_intermediary_productstructure(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/product-structure?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_productstructure(_response);
            });
    }

    protected processV360_reports_intermediary_productstructure(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Other attributes report
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return other attributes report
     */
    v360_reports_intermediary_other(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/other?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_other(_response);
            });
    }

    protected processV360_reports_intermediary_other(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Monthly sales
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return monthly sales report
     */
    v360_reports_intermediary_monthlySales(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/monthly?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_monthlySales(_response);
            });
    }

    protected processV360_reports_intermediary_monthlySales(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Customer report
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return customer report
     */
    v360_reports_intermediary_customer(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/customer?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_customer(_response);
            });
    }

    protected processV360_reports_intermediary_customer(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Cumulative sales
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return cumulative sales report
     */
    v360_reports_intermediary_cumulatvesales(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/cumulative?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_cumulatvesales(_response);
            });
    }

    protected processV360_reports_intermediary_cumulatvesales(
        response: AxiosResponse
    ): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Reports configuration
     * @param intermediaryId intermediary id
     * @return reports configuration object
     */
    v360_reports_intermediary_config(
        intermediaryId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportConfig_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/config";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_config(_response);
            });
    }

    protected processV360_reports_intermediary_config(response: AxiosResponse): Promise<SalesReportConfig_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportConfig_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportConfig_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportConfig_Public>(null as any);
    }

    /**
     * Reports configuration
     * @param intermediaryId intermediary id
     * @return reports configuration object
     */
    v360_reports_intermediary_config_v2(
        intermediaryId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportConfigV2_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/config/v2";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_config_v2(_response);
            });
    }

    protected processV360_reports_intermediary_config_v2(response: AxiosResponse): Promise<SalesReportConfigV2_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportConfigV2_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportConfigV2_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportConfigV2_Public>(null as any);
    }

    /**
     * Claim ratio report
     * @param intermediaryId intermediary id
     * @param filter report filter
     * @return claim ratio report
     */
    v360_reports_intermediary_claimratio(
        intermediaryId: number,
        filter: ReportFilter_Public,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/claim-ratio?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_claimratio(_response);
            });
    }

    protected processV360_reports_intermediary_claimratio(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Activity report
     * @param intermediaryId intermediary id
     * @param intermediaryNumber (optional) intermediary number (only if  the report is in context of sales person
     * @param companyCode (optional) tenant code
     * @param segmentCodeList (optional) segment code list
     * @param yearCodeList (optional) year list (code list of available years)
     * @param reportMode (optional) report mode
     * @param reportScope (optional) report scope
     * @return activity report
     */
    v360_reports_intermediary_activity(
        intermediaryId: number,
        intermediaryNumber: string | undefined,
        companyCode: string | undefined,
        segmentCodeList: string | undefined,
        yearCodeList: string | undefined,
        reportMode: string | undefined,
        reportScope: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/sales-report/intermediary/{intermediaryId}/activity?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (intermediaryNumber === null) throw new Error("The parameter 'intermediaryNumber' cannot be null.");
        else if (intermediaryNumber !== undefined)
            url_ += "intermediaryNumber=" + encodeURIComponent("" + intermediaryNumber) + "&";
        if (companyCode === null) throw new Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined) url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (segmentCodeList === null) throw new Error("The parameter 'segmentCodeList' cannot be null.");
        else if (segmentCodeList !== undefined)
            url_ += "segmentCodeList=" + encodeURIComponent("" + segmentCodeList) + "&";
        if (yearCodeList === null) throw new Error("The parameter 'yearCodeList' cannot be null.");
        else if (yearCodeList !== undefined) url_ += "yearCodeList=" + encodeURIComponent("" + yearCodeList) + "&";
        if (reportMode === null) throw new Error("The parameter 'reportMode' cannot be null.");
        else if (reportMode !== undefined) url_ += "reportMode=" + encodeURIComponent("" + reportMode) + "&";
        if (reportScope === null) throw new Error("The parameter 'reportScope' cannot be null.");
        else if (reportScope !== undefined) url_ += "reportScope=" + encodeURIComponent("" + reportScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_reports_intermediary_activity(_response);
            });
    }

    protected processV360_reports_intermediary_activity(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = SalesReportHolder_Public.fromJS(resultData404);
            return throwException("if the report cant be generated", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * Get one intermediary
     * @param intermediaryId intermediary id
     * @return Intermediary data
     */
    v360_intermediary_get(
        intermediaryId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<IntermediaryV360_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_get(_response);
            });
    }

    protected processV360_intermediary_get(response: AxiosResponse): Promise<IntermediaryV360_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = IntermediaryV360_Public.fromJS(resultData200);
            return Promise.resolve<IntermediaryV360_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = IntermediaryV360_Public.fromJS(resultData404);
            return throwException("Intermediary is not found", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntermediaryV360_Public>(null as any);
    }

    /**
     * List of intermediary employees
     * @param intermediaryId intermediary id
     * @param phrase (optional) phrase search in scope of employee first name / last name
     * @param offset (optional) query offset, 0 is default value
     * @param limit (optional) response dataset row limitation, maximum is 200, default is 200
     * @return Intermediary employees list
     */
    v360_intermediary_employeeList(
        intermediaryId: number,
        phrase: string | undefined,
        offset: string | undefined,
        limit: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<V360IntermediaryEmployeeSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/employees?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        if (phrase === null) throw new Error("The parameter 'phrase' cannot be null.");
        else if (phrase !== undefined) url_ += "phrase=" + encodeURIComponent("" + phrase) + "&";
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processV360_intermediary_employeeList(_response);
            });
    }

    protected processV360_intermediary_employeeList(
        response: AxiosResponse
    ): Promise<V360IntermediaryEmployeeSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = V360IntermediaryEmployeeSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<V360IntermediaryEmployeeSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V360IntermediaryEmployeeSearchResult_Public>(null as any);
    }

    /**
     * Daily sales report for intermediary
     * @return daily sales report result
     */
    intermediary_dailysales_today(
        intermediaryId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<DailySalesReport_Public> {
        let url_ = this.baseUrl + "/api/secured/v360/intermediary/{intermediaryId}/daily-sales/today";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined.");
        url_ = url_.replace("{intermediaryId}", encodeURIComponent("" + intermediaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processIntermediary_dailysales_today(_response);
            });
    }

    protected processIntermediary_dailysales_today(response: AxiosResponse): Promise<DailySalesReport_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DailySalesReport_Public.fromJS(resultData200);
            return Promise.resolve<DailySalesReport_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailySalesReport_Public>(null as any);
    }

    /**
     * redirection token preparation
     * @param appName application code, used for link generation
     * @return OK
     */
    user_oneTimeAuthToken(appName: string, cancelToken?: CancelToken | undefined): Promise<TokenHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/user/onetime-auth-token?";
        if (appName === undefined || appName === null)
            throw new Error("The parameter 'appName' must be defined and cannot be null.");
        else url_ += "appName=" + encodeURIComponent("" + appName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUser_oneTimeAuthToken(_response);
            });
    }

    protected processUser_oneTimeAuthToken(response: AxiosResponse): Promise<TokenHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TokenHolder_Public.fromJS(resultData200);
            return Promise.resolve<TokenHolder_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenHolder_Public>(null as any);
    }

    /**
     * List UWR trainings
     * @return OK
     */
    uwr_training_list(
        underwriterId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<UnderwriterTraining_Public[]> {
        let url_ = this.baseUrl + "/api/secured/underwriter/{underwriterId}/training";
        if (underwriterId === undefined || underwriterId === null)
            throw new Error("The parameter 'underwriterId' must be defined.");
        url_ = url_.replace("{underwriterId}", encodeURIComponent("" + underwriterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processUwr_training_list(_response);
            });
    }

    protected processUwr_training_list(response: AxiosResponse): Promise<UnderwriterTraining_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(UnderwriterTraining_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<UnderwriterTraining_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnderwriterTraining_Public[]>(null as any);
    }

    /**
     * Get score card
     * @param periodCode Report period code
     * @param reportType Report type, should be one of MONTHLY, MONTHLY_RMS or QUARTERLY
     * @return Score card
     */
    scorecard_report(
        periodCode: string,
        reportType: string,
        cancelToken?: CancelToken | undefined
    ): Promise<ScoreCardTimePeriod_Public> {
        let url_ = this.baseUrl + "/api/secured/report/score-card?";
        if (periodCode === undefined || periodCode === null)
            throw new Error("The parameter 'periodCode' must be defined and cannot be null.");
        else url_ += "periodCode=" + encodeURIComponent("" + periodCode) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processScorecard_report(_response);
            });
    }

    protected processScorecard_report(response: AxiosResponse): Promise<ScoreCardTimePeriod_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ScoreCardTimePeriod_Public.fromJS(resultData200);
            return Promise.resolve<ScoreCardTimePeriod_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScoreCardTimePeriod_Public>(null as any);
    }

    /**
     * Get list available period list for reporting
     * @param reportType Report type, should be one of MONTHLY, MONTHLY_RMS or QUARTERLY
     * @return Score card period identity
     */
    scorecard_periodList(
        reportType: string,
        cancelToken?: CancelToken | undefined
    ): Promise<ScoreCardPeriodIdentity_Public[]> {
        let url_ = this.baseUrl + "/api/secured/report/score-card/period-list?";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processScorecard_periodList(_response);
            });
    }

    protected processScorecard_periodList(response: AxiosResponse): Promise<ScoreCardPeriodIdentity_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(ScoreCardPeriodIdentity_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<ScoreCardPeriodIdentity_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScoreCardPeriodIdentity_Public[]>(null as any);
    }

    /**
     * Get ranking report
     * @param reportType (optional) report type
     * @return Ranking report
     */
    ranking_report(
        reportType: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<RankingReport_Public> {
        let url_ = this.baseUrl + "/api/secured/report/ranking?";
        if (reportType === null) throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined) url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processRanking_report(_response);
            });
    }

    protected processRanking_report(response: AxiosResponse): Promise<RankingReport_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RankingReport_Public.fromJS(resultData200);
            return Promise.resolve<RankingReport_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RankingReport_Public>(null as any);
    }

    /**
     * List notes
     * @param offset (optional) notes response offset, default 0
     * @param limit (optional) notes response limit
     * @param phrase (optional) phrase to limit sales person / intermediary - used for search without entity context
     * @param orderBy (optional) order by column
     * @param orderDirection (optional) order direction (asc, desc)
     * @param minFirstEditDate (optional) minimum first edit date
     * @param maxFirstEditDate (optional) maximum first edit date
     * @param minLastEditDate (optional) minimum last edit date
     * @param maxLastEditDate (optional) maximum last edit date
     * @param minContactDate (optional) minimum contact date
     * @param maxContactDate (optional) maximum contact date
     * @param noteTypeCode (optional) note type code (see NOTE_TYPE dictionary items)
     * @param noteTypeCodeList (optional) note type code list (see NOTE_TYPE dictionary items)
     * @param authorId (optional) reference to the primary author of the note
     * @param subjectCorpoCodeList (optional) list of the corporate subject list of the note (at least one much match)
     * @param subjectRetailCodeList (optional) list of the retail subject list of the note (at least one much match)
     * @return OK
     */
    note_search(
        offset: string | undefined,
        limit: string | undefined,
        phrase: string | undefined,
        orderBy: string | undefined,
        orderDirection: string | undefined,
        minFirstEditDate: string | undefined,
        maxFirstEditDate: string | undefined,
        minLastEditDate: string | undefined,
        maxLastEditDate: string | undefined,
        minContactDate: string | undefined,
        maxContactDate: string | undefined,
        noteTypeCode: string | undefined,
        noteTypeCodeList: string | undefined,
        authorId: string | undefined,
        subjectCorpoCodeList: string | undefined,
        subjectRetailCodeList: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<EntityNoteSearchResult_Public> {
        let url_ = this.baseUrl + "/api/secured/note?";
        if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (phrase === null) throw new Error("The parameter 'phrase' cannot be null.");
        else if (phrase !== undefined) url_ += "phrase=" + encodeURIComponent("" + phrase) + "&";
        if (orderBy === null) throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined) url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderDirection === null) throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (minFirstEditDate === null) throw new Error("The parameter 'minFirstEditDate' cannot be null.");
        else if (minFirstEditDate !== undefined)
            url_ += "minFirstEditDate=" + encodeURIComponent("" + minFirstEditDate) + "&";
        if (maxFirstEditDate === null) throw new Error("The parameter 'maxFirstEditDate' cannot be null.");
        else if (maxFirstEditDate !== undefined)
            url_ += "maxFirstEditDate=" + encodeURIComponent("" + maxFirstEditDate) + "&";
        if (minLastEditDate === null) throw new Error("The parameter 'minLastEditDate' cannot be null.");
        else if (minLastEditDate !== undefined)
            url_ += "minLastEditDate=" + encodeURIComponent("" + minLastEditDate) + "&";
        if (maxLastEditDate === null) throw new Error("The parameter 'maxLastEditDate' cannot be null.");
        else if (maxLastEditDate !== undefined)
            url_ += "maxLastEditDate=" + encodeURIComponent("" + maxLastEditDate) + "&";
        if (minContactDate === null) throw new Error("The parameter 'minContactDate' cannot be null.");
        else if (minContactDate !== undefined)
            url_ += "minContactDate=" + encodeURIComponent("" + minContactDate) + "&";
        if (maxContactDate === null) throw new Error("The parameter 'maxContactDate' cannot be null.");
        else if (maxContactDate !== undefined)
            url_ += "maxContactDate=" + encodeURIComponent("" + maxContactDate) + "&";
        if (noteTypeCode === null) throw new Error("The parameter 'noteTypeCode' cannot be null.");
        else if (noteTypeCode !== undefined) url_ += "noteTypeCode=" + encodeURIComponent("" + noteTypeCode) + "&";
        if (noteTypeCodeList === null) throw new Error("The parameter 'noteTypeCodeList' cannot be null.");
        else if (noteTypeCodeList !== undefined)
            url_ += "noteTypeCodeList=" + encodeURIComponent("" + noteTypeCodeList) + "&";
        if (authorId === null) throw new Error("The parameter 'authorId' cannot be null.");
        else if (authorId !== undefined) url_ += "authorId=" + encodeURIComponent("" + authorId) + "&";
        if (subjectCorpoCodeList === null) throw new Error("The parameter 'subjectCorpoCodeList' cannot be null.");
        else if (subjectCorpoCodeList !== undefined)
            url_ += "subjectCorpoCodeList=" + encodeURIComponent("" + subjectCorpoCodeList) + "&";
        if (subjectRetailCodeList === null) throw new Error("The parameter 'subjectRetailCodeList' cannot be null.");
        else if (subjectRetailCodeList !== undefined)
            url_ += "subjectRetailCodeList=" + encodeURIComponent("" + subjectRetailCodeList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processNote_search(_response);
            });
    }

    protected processNote_search(response: AxiosResponse): Promise<EntityNoteSearchResult_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EntityNoteSearchResult_Public.fromJS(resultData200);
            return Promise.resolve<EntityNoteSearchResult_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityNoteSearchResult_Public>(null as any);
    }

    /**
     * Note users
     * @return OK
     */
    note_users(cancelToken?: CancelToken | undefined): Promise<NoteUserIdentity_Public[]> {
        let url_ = this.baseUrl + "/api/secured/note/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processNote_users(_response);
            });
    }

    protected processNote_users(response: AxiosResponse): Promise<NoteUserIdentity_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(NoteUserIdentity_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<NoteUserIdentity_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteUserIdentity_Public[]>(null as any);
    }

    /**
     * Note report
     * @return OK
     */
    note_report(cancelToken?: CancelToken | undefined): Promise<SalesReportHolder_Public> {
        let url_ = this.baseUrl + "/api/secured/note/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processNote_report(_response);
            });
    }

    protected processNote_report(response: AxiosResponse): Promise<SalesReportHolder_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SalesReportHolder_Public.fromJS(resultData200);
            return Promise.resolve<SalesReportHolder_Public>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesReportHolder_Public>(null as any);
    }

    /**
     * List of dictionaries for given code list
     * @param code (optional) list of dictionary codes separated by comma
     * @return List of dictionaries
     */
    dictionary_list(code: string | undefined, cancelToken?: CancelToken | undefined): Promise<Dictionary_Public[]> {
        let url_ = this.baseUrl + "/api/secured/dictionary?";
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDictionary_list(_response);
            });
    }

    protected processDictionary_list(response: AxiosResponse): Promise<Dictionary_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(Dictionary_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<Dictionary_Public[]>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404) result404!.push(Dictionary_Public.fromJS(item));
            } else {
                result404 = <any>null;
            }
            return throwException(
                "No dictionaries with given code list were found",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Dictionary_Public[]>(null as any);
    }

    /**
     * Get one dictionary with elements
     * @param dictionaryCode dictionary code
     * @return Dictionary with elements
     */
    dictionary_getOne(dictionaryCode: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/dictionary/{dictionaryCode}";
        if (dictionaryCode === undefined || dictionaryCode === null)
            throw new Error("The parameter 'dictionaryCode' must be defined.");
        url_ = url_.replace("{dictionaryCode}", encodeURIComponent("" + dictionaryCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "application/json",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDictionary_getOne(_response);
            });
    }

    protected processDictionary_getOne(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : <any>null;

            return throwException(
                "No dictionary with given code has been found",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get one dictionary item with code
     * @param dictionaryCode dictionary code
     * @param itemCode item code
     * @return List of dictionaries
     */
    dictionary_item_itemAndTranslationMap(
        dictionaryCode: string,
        itemCode: string,
        cancelToken?: CancelToken | undefined
    ): Promise<void> {
        let url_ = this.baseUrl + "/api/secured/dictionary/{dictionaryCode}/{itemCode}";
        if (dictionaryCode === undefined || dictionaryCode === null)
            throw new Error("The parameter 'dictionaryCode' must be defined.");
        url_ = url_.replace("{dictionaryCode}", encodeURIComponent("" + dictionaryCode));
        if (itemCode === undefined || itemCode === null) throw new Error("The parameter 'itemCode' must be defined.");
        url_ = url_.replace("{itemCode}", encodeURIComponent("" + itemCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "application/json",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDictionary_item_itemAndTranslationMap(_response);
            });
    }

    protected processDictionary_item_itemAndTranslationMap(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DictionaryItemWithTranslationMap_Public.fromJS(resultData404);
            return throwException(
                "Dictionary with given code or item with given code not found",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * List of dashboard tasks with filter
     * @param startDate (optional) starting date of task due date
     * @param endDate (optional) ending date of task due date
     * @param attributeList (optional) list of attributes that should be returned within found task
     * @param attachmentList (optional) should list of attachments be returned with the task element on the list
     * @param commentList (optional) should list of task comments be returned with the task element on the list
     * @return List of dashboard task elements that meets the query parameters. Returned list is limited to first 100 elements that meet the criteria
     */
    dashboard_list(
        startDate: string | undefined,
        endDate: string | undefined,
        attributeList: string | undefined,
        attachmentList: string | undefined,
        commentList: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public[]> {
        let url_ = this.baseUrl + "/api/secured/dashboard?";
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (attributeList === null) throw new Error("The parameter 'attributeList' cannot be null.");
        else if (attributeList !== undefined) url_ += "attributeList=" + encodeURIComponent("" + attributeList) + "&";
        if (attachmentList === null) throw new Error("The parameter 'attachmentList' cannot be null.");
        else if (attachmentList !== undefined)
            url_ += "attachmentList=" + encodeURIComponent("" + attachmentList) + "&";
        if (commentList === null) throw new Error("The parameter 'commentList' cannot be null.");
        else if (commentList !== undefined) url_ += "commentList=" + encodeURIComponent("" + commentList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_list(_response);
            });
    }

    protected processDashboard_list(response: AxiosResponse): Promise<DashboardTask_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(DashboardTask_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<DashboardTask_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public[]>(null as any);
    }

    /**
     * Get one dashboard task with given id
     * @param id id of the dashboard task
     * @return Dashboard task
     */
    dashboard_getOne(id: number, cancelToken?: CancelToken | undefined): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_getOne(_response);
            });
    }

    protected processDashboard_getOne(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }

    /**
     * Get list of available users that may be assigned to the task.
     * @param id id of the dashboard task
     * @return List of possible assignees is returned
     */
    dashboard_assigneeList_1(id: number, cancelToken?: CancelToken | undefined): Promise<SystemUserIdentity_Public[]> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/assignee/list";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_assigneeList_1(_response);
            });
    }

    protected processDashboard_assigneeList_1(response: AxiosResponse): Promise<SystemUserIdentity_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(SystemUserIdentity_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<SystemUserIdentity_Public[]>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            if (Array.isArray(resultData404)) {
                result404 = [] as any;
                for (let item of resultData404) result404!.push(SystemUserIdentity_Public.fromJS(item));
            } else {
                result404 = <any>null;
            }
            return throwException(
                "Task with given id does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemUserIdentity_Public[]>(null as any);
    }

    /**
     * List of network branches
     * @param code (optional) branch code
     * @param typeCode (optional) branch type
     * @return OK
     */
    branch_list(
        code: string | undefined,
        typeCode: string | undefined,
        cancelToken?: CancelToken | undefined
    ): Promise<NetworkBranch_Public[]> {
        let url_ = this.baseUrl + "/api/secured/branch?";
        if (code === null) throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined) url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (typeCode === null) throw new Error("The parameter 'typeCode' cannot be null.");
        else if (typeCode !== undefined) url_ += "typeCode=" + encodeURIComponent("" + typeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processBranch_list(_response);
            });
    }

    protected processBranch_list(response: AxiosResponse): Promise<NetworkBranch_Public[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) result200!.push(NetworkBranch_Public.fromJS(item));
            } else {
                result200 = <any>null;
            }
            return Promise.resolve<NetworkBranch_Public[]>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NetworkBranch_Public[]>(null as any);
    }

    /**
     * Get frontend config
     * @return Frontend configuration
     */
    frontend_config(cancelToken?: CancelToken | undefined): Promise<FrontendConfig> {
        let url_ = this.baseUrl + "/api/public/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "application/json",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processFrontend_config(_response);
            });
    }

    protected processFrontend_config(response: AxiosResponse): Promise<FrontendConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FrontendConfig.fromJS(resultData200);
            return Promise.resolve<FrontendConfig>(result200);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrontendConfig>(null as any);
    }

    /**
     * Attachment removal
     * @param id id of the dasboard task
     * @param attachmentId id of the attachment
     * @return Updated task
     */
    dashboard_attachment_remove(
        id: number,
        attachmentId: number,
        cancelToken?: CancelToken | undefined
    ): Promise<DashboardTask_Public> {
        let url_ = this.baseUrl + "/api/secured/dashboard/{id}/attachment/{attachmentId}";
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "*/*",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processDashboard_attachment_remove(_response);
            });
    }

    protected processDashboard_attachment_remove(response: AxiosResponse): Promise<DashboardTask_Public> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DashboardTask_Public.fromJS(resultData200);
            return Promise.resolve<DashboardTask_Public>(result200);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = DashboardTask_Public.fromJS(resultData404);
            return throwException(
                "Task with given id or the attachment with given id in the scope of the task does not exists or not available for the user",
                status,
                _responseText,
                _headers,
                result404
            );
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400) result400!.push(ApiValidationError_Public.fromJS(item));
            } else {
                result400 = <any>null;
            }
            return throwException("Validation error", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No access", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = ApiError_Public.fromJS(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardTask_Public>(null as any);
    }
}

export class DictionaryItem_Public implements IDictionaryItem_Public {
    id?: number;
    code!: string;
    deleted?: boolean;
    descriptionTranslationCode?: string;
    description?: string;
    flexField1?: string;
    flexFilter1?: string[];
    orderIndex?: number;

    [key: string]: any;

    constructor(data?: IDictionaryItem_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.deleted = _data["deleted"];
            this.descriptionTranslationCode = _data["descriptionTranslationCode"];
            this.description = _data["description"];
            this.flexField1 = _data["flexField1"];
            if (Array.isArray(_data["flexFilter1"])) {
                this.flexFilter1 = [] as any;
                for (let item of _data["flexFilter1"]) this.flexFilter1!.push(item);
            }
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): DictionaryItem_Public {
        data = typeof data === "object" ? data : {};
        let result = new DictionaryItem_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["deleted"] = this.deleted;
        data["descriptionTranslationCode"] = this.descriptionTranslationCode;
        data["description"] = this.description;
        data["flexField1"] = this.flexField1;
        if (Array.isArray(this.flexFilter1)) {
            data["flexFilter1"] = [];
            for (let item of this.flexFilter1) data["flexFilter1"].push(item);
        }
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IDictionaryItem_Public {
    id?: number;
    code: string;
    deleted?: boolean;
    descriptionTranslationCode?: string;
    description?: string;
    flexField1?: string;
    flexFilter1?: string[];
    orderIndex?: number;

    [key: string]: any;
}

/** note data */
export class EntityNote_Public implements IEntityNote_Public {
    id?: number;
    /** entity type */
    entityType?: EntityNote_PublicEntityType;
    /** entityId */
    entityId?: number;
    /** entity name */
    entityName?: string;
    /** first edit date */
    firstEditDate?: Date;
    /** last edit date */
    lastEditDate?: Date;
    author?: UserBasicEntity_Public;
    lastEditBy?: UserBasicEntity_Public;
    /** note body */
    body?: string;
    noteType?: DictionaryItem_Public;
    /** contact date */
    contactDate?: Date;
    /** list of available note operations */
    operationList?: OperationList[];
    /** list of subjects for retail */
    subjectRetailList?: DictionaryItem_Public[];
    /** list of subjects for corpo */
    subjectCorpoList?: DictionaryItem_Public[];
    /** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
    intermediaryReferenceList?: IntermediaryReference_Public[];

    [key: string]: any;

    constructor(data?: IEntityNote_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.firstEditDate = _data["firstEditDate"] ? new Date(_data["firstEditDate"].toString()) : <any>undefined;
            this.lastEditDate = _data["lastEditDate"] ? new Date(_data["lastEditDate"].toString()) : <any>undefined;
            this.author = _data["author"] ? UserBasicEntity_Public.fromJS(_data["author"]) : <any>undefined;
            this.lastEditBy = _data["lastEditBy"] ? UserBasicEntity_Public.fromJS(_data["lastEditBy"]) : <any>undefined;
            this.body = _data["body"];
            this.noteType = _data["noteType"] ? DictionaryItem_Public.fromJS(_data["noteType"]) : <any>undefined;
            this.contactDate = _data["contactDate"] ? new Date(_data["contactDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["operationList"])) {
                this.operationList = [] as any;
                for (let item of _data["operationList"]) this.operationList!.push(item);
            }
            if (Array.isArray(_data["subjectRetailList"])) {
                this.subjectRetailList = [] as any;
                for (let item of _data["subjectRetailList"])
                    this.subjectRetailList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["subjectCorpoList"])) {
                this.subjectCorpoList = [] as any;
                for (let item of _data["subjectCorpoList"])
                    this.subjectCorpoList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["intermediaryReferenceList"])) {
                this.intermediaryReferenceList = [] as any;
                for (let item of _data["intermediaryReferenceList"])
                    this.intermediaryReferenceList!.push(IntermediaryReference_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityNote_Public {
        data = typeof data === "object" ? data : {};
        let result = new EntityNote_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["firstEditDate"] = this.firstEditDate ? this.firstEditDate.toISOString() : <any>undefined;
        data["lastEditDate"] = this.lastEditDate ? this.lastEditDate.toISOString() : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["lastEditBy"] = this.lastEditBy ? this.lastEditBy.toJSON() : <any>undefined;
        data["body"] = this.body;
        data["noteType"] = this.noteType ? this.noteType.toJSON() : <any>undefined;
        data["contactDate"] = this.contactDate ? formatDate(this.contactDate) : <any>undefined;
        if (Array.isArray(this.operationList)) {
            data["operationList"] = [];
            for (let item of this.operationList) data["operationList"].push(item);
        }
        if (Array.isArray(this.subjectRetailList)) {
            data["subjectRetailList"] = [];
            for (let item of this.subjectRetailList) data["subjectRetailList"].push(item.toJSON());
        }
        if (Array.isArray(this.subjectCorpoList)) {
            data["subjectCorpoList"] = [];
            for (let item of this.subjectCorpoList) data["subjectCorpoList"].push(item.toJSON());
        }
        if (Array.isArray(this.intermediaryReferenceList)) {
            data["intermediaryReferenceList"] = [];
            for (let item of this.intermediaryReferenceList) data["intermediaryReferenceList"].push(item.toJSON());
        }
        return data;
    }
}

/** note data */
export interface IEntityNote_Public {
    id?: number;
    /** entity type */
    entityType?: EntityNote_PublicEntityType;
    /** entityId */
    entityId?: number;
    /** entity name */
    entityName?: string;
    /** first edit date */
    firstEditDate?: Date;
    /** last edit date */
    lastEditDate?: Date;
    author?: UserBasicEntity_Public;
    lastEditBy?: UserBasicEntity_Public;
    /** note body */
    body?: string;
    noteType?: DictionaryItem_Public;
    /** contact date */
    contactDate?: Date;
    /** list of available note operations */
    operationList?: OperationList[];
    /** list of subjects for retail */
    subjectRetailList?: DictionaryItem_Public[];
    /** list of subjects for corpo */
    subjectCorpoList?: DictionaryItem_Public[];
    /** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
    intermediaryReferenceList?: IntermediaryReference_Public[];

    [key: string]: any;
}

/** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
export class IntermediaryReference_Public implements IIntermediaryReference_Public {
    id?: number;
    name?: string;
    number?: string;

    [key: string]: any;

    constructor(data?: IIntermediaryReference_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): IntermediaryReference_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryReference_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        return data;
    }
}

/** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
export interface IIntermediaryReference_Public {
    id?: number;
    name?: string;
    number?: string;

    [key: string]: any;
}

/** user that modified the note as last */
export class UserBasicEntity_Public implements IUserBasicEntity_Public {
    /** username */
    username?: string;
    /** user first name */
    firstName?: string;
    /** user last name */
    lastName?: string;
    /** user mobile number */
    mobilePhone?: string;
    /** user principal name */
    userPrincipalName?: string;
    /** user full name */
    fullName?: string;

    [key: string]: any;

    constructor(data?: IUserBasicEntity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobilePhone = _data["mobilePhone"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserBasicEntity_Public {
        data = typeof data === "object" ? data : {};
        let result = new UserBasicEntity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobilePhone"] = this.mobilePhone;
        data["userPrincipalName"] = this.userPrincipalName;
        data["fullName"] = this.fullName;
        return data;
    }
}

/** user that modified the note as last */
export interface IUserBasicEntity_Public {
    /** username */
    username?: string;
    /** user first name */
    firstName?: string;
    /** user last name */
    lastName?: string;
    /** user mobile number */
    mobilePhone?: string;
    /** user principal name */
    userPrincipalName?: string;
    /** user full name */
    fullName?: string;

    [key: string]: any;
}

export class DailySalesConfig_Public implements IDailySalesConfig_Public {
    tenantList?: DailySalesTenantConfig_Public[];
    reloadIntervalSeconds?: number;

    [key: string]: any;

    constructor(data?: IDailySalesConfig_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["tenantList"])) {
                this.tenantList = [] as any;
                for (let item of _data["tenantList"]) this.tenantList!.push(DailySalesTenantConfig_Public.fromJS(item));
            }
            this.reloadIntervalSeconds = _data["reloadIntervalSeconds"];
        }
    }

    static fromJS(data: any): DailySalesConfig_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesConfig_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.tenantList)) {
            data["tenantList"] = [];
            for (let item of this.tenantList) data["tenantList"].push(item.toJSON());
        }
        data["reloadIntervalSeconds"] = this.reloadIntervalSeconds;
        return data;
    }
}

export interface IDailySalesConfig_Public {
    tenantList?: DailySalesTenantConfig_Public[];
    reloadIntervalSeconds?: number;

    [key: string]: any;
}

export class DailySalesSegmentIdentity_Public implements IDailySalesSegmentIdentity_Public {
    code?: string;
    index?: number;

    [key: string]: any;

    constructor(data?: IDailySalesSegmentIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): DailySalesSegmentIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesSegmentIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["index"] = this.index;
        return data;
    }
}

export interface IDailySalesSegmentIdentity_Public {
    code?: string;
    index?: number;

    [key: string]: any;
}

export class DailySalesTenantConfig_Public implements IDailySalesTenantConfig_Public {
    tenantCode?: string;
    segmentList?: DailySalesSegmentIdentity_Public[];

    [key: string]: any;

    constructor(data?: IDailySalesTenantConfig_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.tenantCode = _data["tenantCode"];
            if (Array.isArray(_data["segmentList"])) {
                this.segmentList = [] as any;
                for (let item of _data["segmentList"])
                    this.segmentList!.push(DailySalesSegmentIdentity_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailySalesTenantConfig_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesTenantConfig_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["tenantCode"] = this.tenantCode;
        if (Array.isArray(this.segmentList)) {
            data["segmentList"] = [];
            for (let item of this.segmentList) data["segmentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailySalesTenantConfig_Public {
    tenantCode?: string;
    segmentList?: DailySalesSegmentIdentity_Public[];

    [key: string]: any;
}

export class NetworkBranch_Public implements INetworkBranch_Public {
    id?: number;
    /** branch code */
    code?: string;
    /** branch name */
    name?: string;
    /** branch type */
    typeCode?: string;
    /** parent branch code */
    parentCode?: string;

    [key: string]: any;

    constructor(data?: INetworkBranch_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.typeCode = _data["typeCode"];
            this.parentCode = _data["parentCode"];
        }
    }

    static fromJS(data: any): NetworkBranch_Public {
        data = typeof data === "object" ? data : {};
        let result = new NetworkBranch_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["typeCode"] = this.typeCode;
        data["parentCode"] = this.parentCode;
        return data;
    }
}

export interface INetworkBranch_Public {
    id?: number;
    /** branch code */
    code?: string;
    /** branch name */
    name?: string;
    /** branch type */
    typeCode?: string;
    /** parent branch code */
    parentCode?: string;

    [key: string]: any;
}

/** pełnomocnictwa dystrybucyjne */
export class UnderwriterCertificate_Public implements IUnderwriterCertificate_Public {
    id?: number;
    type?: DictionaryItem_Public;
    certificateNumber?: string;
    issueDate?: Date;
    effectiveDateFrom?: Date;
    effectiveDateTo?: Date;
    status?: DictionaryItem_Public;
    originalReturnFlag?: boolean;
    substitutionFlag?: boolean;
    scopeDescription?: string;
    notes?: string;

    [key: string]: any;

    constructor(data?: IUnderwriterCertificate_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.certificateNumber = _data["certificateNumber"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.effectiveDateFrom = _data["effectiveDateFrom"]
                ? new Date(_data["effectiveDateFrom"].toString())
                : <any>undefined;
            this.effectiveDateTo = _data["effectiveDateTo"]
                ? new Date(_data["effectiveDateTo"].toString())
                : <any>undefined;
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.originalReturnFlag = _data["originalReturnFlag"];
            this.substitutionFlag = _data["substitutionFlag"];
            this.scopeDescription = _data["scopeDescription"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UnderwriterCertificate_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterCertificate_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["certificateNumber"] = this.certificateNumber;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : <any>undefined;
        data["effectiveDateFrom"] = this.effectiveDateFrom ? formatDate(this.effectiveDateFrom) : <any>undefined;
        data["effectiveDateTo"] = this.effectiveDateTo ? formatDate(this.effectiveDateTo) : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["originalReturnFlag"] = this.originalReturnFlag;
        data["substitutionFlag"] = this.substitutionFlag;
        data["scopeDescription"] = this.scopeDescription;
        data["notes"] = this.notes;
        return data;
    }
}

/** pełnomocnictwa dystrybucyjne */
export interface IUnderwriterCertificate_Public {
    id?: number;
    type?: DictionaryItem_Public;
    certificateNumber?: string;
    issueDate?: Date;
    effectiveDateFrom?: Date;
    effectiveDateTo?: Date;
    status?: DictionaryItem_Public;
    originalReturnFlag?: boolean;
    substitutionFlag?: boolean;
    scopeDescription?: string;
    notes?: string;

    [key: string]: any;
}

/** pełnomocnictwa prowizyjne */
export class UnderwriterCommissionCertificate_Public implements IUnderwriterCommissionCertificate_Public {
    id?: number;
    type?: DictionaryItem_Public;
    commissionLob?: DictionaryItem_Public;
    effectiveDateFrom?: Date;
    effectiveDateTo?: Date;

    [key: string]: any;

    constructor(data?: IUnderwriterCommissionCertificate_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.commissionLob = _data["commissionLob"]
                ? DictionaryItem_Public.fromJS(_data["commissionLob"])
                : <any>undefined;
            this.effectiveDateFrom = _data["effectiveDateFrom"]
                ? new Date(_data["effectiveDateFrom"].toString())
                : <any>undefined;
            this.effectiveDateTo = _data["effectiveDateTo"]
                ? new Date(_data["effectiveDateTo"].toString())
                : <any>undefined;
        }
    }

    static fromJS(data: any): UnderwriterCommissionCertificate_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterCommissionCertificate_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["commissionLob"] = this.commissionLob ? this.commissionLob.toJSON() : <any>undefined;
        data["effectiveDateFrom"] = this.effectiveDateFrom ? formatDate(this.effectiveDateFrom) : <any>undefined;
        data["effectiveDateTo"] = this.effectiveDateTo ? formatDate(this.effectiveDateTo) : <any>undefined;
        return data;
    }
}

/** pełnomocnictwa prowizyjne */
export interface IUnderwriterCommissionCertificate_Public {
    id?: number;
    type?: DictionaryItem_Public;
    commissionLob?: DictionaryItem_Public;
    effectiveDateFrom?: Date;
    effectiveDateTo?: Date;

    [key: string]: any;
}

export class UnderwriterOwcdData_Public implements IUnderwriterOwcdData_Public {
    id?: number;
    tenant?: DictionaryItem_Public;
    standardFlag?: boolean;
    examDate?: Date;
    krkDate?: Date;
    declarationDate?: Date;
    certificateDeliveryFlag?: boolean;
    reinsuranceFlag?: boolean;
    entryDate?: Date;
    removalDate?: Date;
    documentLocation?: DictionaryItem_Public;
    notes?: string;
    active?: boolean;

    [key: string]: any;

    constructor(data?: IUnderwriterOwcdData_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenant = _data["tenant"] ? DictionaryItem_Public.fromJS(_data["tenant"]) : <any>undefined;
            this.standardFlag = _data["standardFlag"];
            this.examDate = _data["examDate"] ? new Date(_data["examDate"].toString()) : <any>undefined;
            this.krkDate = _data["krkDate"] ? new Date(_data["krkDate"].toString()) : <any>undefined;
            this.declarationDate = _data["declarationDate"]
                ? new Date(_data["declarationDate"].toString())
                : <any>undefined;
            this.certificateDeliveryFlag = _data["certificateDeliveryFlag"];
            this.reinsuranceFlag = _data["reinsuranceFlag"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.removalDate = _data["removalDate"] ? new Date(_data["removalDate"].toString()) : <any>undefined;
            this.documentLocation = _data["documentLocation"]
                ? DictionaryItem_Public.fromJS(_data["documentLocation"])
                : <any>undefined;
            this.notes = _data["notes"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): UnderwriterOwcdData_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterOwcdData_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["standardFlag"] = this.standardFlag;
        data["examDate"] = this.examDate ? formatDate(this.examDate) : <any>undefined;
        data["krkDate"] = this.krkDate ? formatDate(this.krkDate) : <any>undefined;
        data["declarationDate"] = this.declarationDate ? formatDate(this.declarationDate) : <any>undefined;
        data["certificateDeliveryFlag"] = this.certificateDeliveryFlag;
        data["reinsuranceFlag"] = this.reinsuranceFlag;
        data["entryDate"] = this.entryDate ? formatDate(this.entryDate) : <any>undefined;
        data["removalDate"] = this.removalDate ? formatDate(this.removalDate) : <any>undefined;
        data["documentLocation"] = this.documentLocation ? this.documentLocation.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["active"] = this.active;
        return data;
    }
}

export interface IUnderwriterOwcdData_Public {
    id?: number;
    tenant?: DictionaryItem_Public;
    standardFlag?: boolean;
    examDate?: Date;
    krkDate?: Date;
    declarationDate?: Date;
    certificateDeliveryFlag?: boolean;
    reinsuranceFlag?: boolean;
    entryDate?: Date;
    removalDate?: Date;
    documentLocation?: DictionaryItem_Public;
    notes?: string;
    active?: boolean;

    [key: string]: any;
}

/** assigned team */
export class UnderwriterTeam_Public implements IUnderwriterTeam_Public {
    id?: number;
    /** team code */
    code?: string;
    /** team name */
    name?: string;
    type?: DictionaryItem_Public;
    city?: DictionaryItem_Public;

    [key: string]: any;

    constructor(data?: IUnderwriterTeam_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.city = _data["city"] ? DictionaryItem_Public.fromJS(_data["city"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UnderwriterTeam_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterTeam_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        return data;
    }
}

/** assigned team */
export interface IUnderwriterTeam_Public {
    id?: number;
    /** team code */
    code?: string;
    /** team name */
    name?: string;
    type?: DictionaryItem_Public;
    city?: DictionaryItem_Public;

    [key: string]: any;
}

export class Underwriter_Public implements IUnderwriter_Public {
    id?: number;
    underwriterNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    pesel?: string;
    branch?: NetworkBranch_Public;
    position?: DictionaryItem_Public;
    segment?: DictionaryItem_Public;
    status?: DictionaryItem_Public;
    /** login of the underwriter in Active Directory */
    login?: string;
    /** flag that represent if the entity is the manager */
    managerFlag?: boolean;
    /** position name in external (HR) system */
    externalPositionDescription?: string;
    team?: UnderwriterTeam_Public;
    /** contract termination date */
    terminationDate?: Date;
    /** phone number */
    phoneNumber?: string;
    owcdList?: UnderwriterOwcdData_Public[];
    /** pełnomocnictwa dystrybucyjne */
    certificateList?: UnderwriterCertificate_Public[];
    /** pełnomocnictwa prowizyjne */
    commissionCertificateList?: UnderwriterCommissionCertificate_Public[];

    [key: string]: any;

    constructor(data?: IUnderwriter_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.underwriterNumber = _data["underwriterNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.pesel = _data["pesel"];
            this.branch = _data["branch"] ? NetworkBranch_Public.fromJS(_data["branch"]) : <any>undefined;
            this.position = _data["position"] ? DictionaryItem_Public.fromJS(_data["position"]) : <any>undefined;
            this.segment = _data["segment"] ? DictionaryItem_Public.fromJS(_data["segment"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.login = _data["login"];
            this.managerFlag = _data["managerFlag"];
            this.externalPositionDescription = _data["externalPositionDescription"];
            this.team = _data["team"] ? UnderwriterTeam_Public.fromJS(_data["team"]) : <any>undefined;
            this.terminationDate = _data["terminationDate"]
                ? new Date(_data["terminationDate"].toString())
                : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["owcdList"])) {
                this.owcdList = [] as any;
                for (let item of _data["owcdList"]) this.owcdList!.push(UnderwriterOwcdData_Public.fromJS(item));
            }
            if (Array.isArray(_data["certificateList"])) {
                this.certificateList = [] as any;
                for (let item of _data["certificateList"])
                    this.certificateList!.push(UnderwriterCertificate_Public.fromJS(item));
            }
            if (Array.isArray(_data["commissionCertificateList"])) {
                this.commissionCertificateList = [] as any;
                for (let item of _data["commissionCertificateList"])
                    this.commissionCertificateList!.push(UnderwriterCommissionCertificate_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Underwriter_Public {
        data = typeof data === "object" ? data : {};
        let result = new Underwriter_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["underwriterNumber"] = this.underwriterNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["pesel"] = this.pesel;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["segment"] = this.segment ? this.segment.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["login"] = this.login;
        data["managerFlag"] = this.managerFlag;
        data["externalPositionDescription"] = this.externalPositionDescription;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["terminationDate"] = this.terminationDate ? formatDate(this.terminationDate) : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.owcdList)) {
            data["owcdList"] = [];
            for (let item of this.owcdList) data["owcdList"].push(item.toJSON());
        }
        if (Array.isArray(this.certificateList)) {
            data["certificateList"] = [];
            for (let item of this.certificateList) data["certificateList"].push(item.toJSON());
        }
        if (Array.isArray(this.commissionCertificateList)) {
            data["commissionCertificateList"] = [];
            for (let item of this.commissionCertificateList) data["commissionCertificateList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnderwriter_Public {
    id?: number;
    underwriterNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    pesel?: string;
    branch?: NetworkBranch_Public;
    position?: DictionaryItem_Public;
    segment?: DictionaryItem_Public;
    status?: DictionaryItem_Public;
    /** login of the underwriter in Active Directory */
    login?: string;
    /** flag that represent if the entity is the manager */
    managerFlag?: boolean;
    /** position name in external (HR) system */
    externalPositionDescription?: string;
    team?: UnderwriterTeam_Public;
    /** contract termination date */
    terminationDate?: Date;
    /** phone number */
    phoneNumber?: string;
    owcdList?: UnderwriterOwcdData_Public[];
    /** pełnomocnictwa dystrybucyjne */
    certificateList?: UnderwriterCertificate_Public[];
    /** pełnomocnictwa prowizyjne */
    commissionCertificateList?: UnderwriterCommissionCertificate_Public[];

    [key: string]: any;
}

export class AttributeCustomValue_Public implements IAttributeCustomValue_Public {
    value?: any;

    [key: string]: any;

    protected _discriminator: string;

    constructor(data?: IAttributeCustomValue_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AttributeCustomValue_Public";
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AttributeCustomValue_Public {
        data = typeof data === "object" ? data : {};
        let result = new AttributeCustomValue_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["className"] = this._discriminator;
        data["value"] = this.value;
        return data;
    }
}

export interface IAttributeCustomValue_Public {
    value?: any;

    [key: string]: any;
}

/** List of task attachments */
export class DashboardAttachment_Public implements IDashboardAttachment_Public {
    id?: number;
    date?: Date;
    file?: SystemFile_Public;

    [key: string]: any;

    constructor(data?: IDashboardAttachment_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.file = _data["file"] ? SystemFile_Public.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardAttachment_Public {
        data = typeof data === "object" ? data : {};
        let result = new DashboardAttachment_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

/** List of task attachments */
export interface IDashboardAttachment_Public {
    id?: number;
    date?: Date;
    file?: SystemFile_Public;

    [key: string]: any;
}

/** List of task attributes plus the one that created the task */
export class DashboardTaskAttribute_Public implements IDashboardTaskAttribute_Public {
    id?: number;
    code?: string;
    type?: DashboardTaskAttribute_PublicType;
    stringValue?: string;
    longValue?: number;
    decimalValue?: number;
    dateValue?: Date;
    dateTimeValue?: Date;
    customValue?: AttributeCustomValue_Public;
    operationList?: OperationList2[];

    [key: string]: any;

    constructor(data?: IDashboardTaskAttribute_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.stringValue = _data["stringValue"];
            this.longValue = _data["longValue"];
            this.decimalValue = _data["decimalValue"];
            this.dateValue = _data["dateValue"] ? new Date(_data["dateValue"].toString()) : <any>undefined;
            this.dateTimeValue = _data["dateTimeValue"] ? new Date(_data["dateTimeValue"].toString()) : <any>undefined;
            this.customValue = _data["customValue"]
                ? AttributeCustomValue_Public.fromJS(_data["customValue"])
                : <any>undefined;
            if (Array.isArray(_data["operationList"])) {
                this.operationList = [] as any;
                for (let item of _data["operationList"]) this.operationList!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardTaskAttribute_Public {
        data = typeof data === "object" ? data : {};
        let result = new DashboardTaskAttribute_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["stringValue"] = this.stringValue;
        data["longValue"] = this.longValue;
        data["decimalValue"] = this.decimalValue;
        data["dateValue"] = this.dateValue ? formatDate(this.dateValue) : <any>undefined;
        data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toISOString() : <any>undefined;
        data["customValue"] = this.customValue ? this.customValue.toJSON() : <any>undefined;
        if (Array.isArray(this.operationList)) {
            data["operationList"] = [];
            for (let item of this.operationList) data["operationList"].push(item);
        }
        return data;
    }
}

/** List of task attributes plus the one that created the task */
export interface IDashboardTaskAttribute_Public {
    id?: number;
    code?: string;
    type?: DashboardTaskAttribute_PublicType;
    stringValue?: string;
    longValue?: number;
    decimalValue?: number;
    dateValue?: Date;
    dateTimeValue?: Date;
    customValue?: AttributeCustomValue_Public;
    operationList?: OperationList2[];

    [key: string]: any;
}

/** List of task comments */
export class DashboardTaskComment_Public implements IDashboardTaskComment_Public {
    /** comment id */
    readonly id?: number;
    body?: string;
    commentDate?: Date;
    author?: SystemUserIdentity_Public;
    /** attachment list */
    readonly fileList?: SystemFile_Public[];
    /** list of available operations for the comment */
    readonly operationList?: OperationList3[];

    [key: string]: any;

    constructor(data?: IDashboardTaskComment_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            (<any>this).id = _data["id"];
            this.body = _data["body"];
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : <any>undefined;
            this.author = _data["author"] ? SystemUserIdentity_Public.fromJS(_data["author"]) : <any>undefined;
            if (Array.isArray(_data["fileList"])) {
                (<any>this).fileList = [] as any;
                for (let item of _data["fileList"]) (<any>this).fileList!.push(SystemFile_Public.fromJS(item));
            }
            if (Array.isArray(_data["operationList"])) {
                (<any>this).operationList = [] as any;
                for (let item of _data["operationList"]) (<any>this).operationList!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardTaskComment_Public {
        data = typeof data === "object" ? data : {};
        let result = new DashboardTaskComment_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["body"] = this.body;
        data["commentDate"] = this.commentDate ? this.commentDate.toISOString() : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        if (Array.isArray(this.fileList)) {
            data["fileList"] = [];
            for (let item of this.fileList) data["fileList"].push(item.toJSON());
        }
        if (Array.isArray(this.operationList)) {
            data["operationList"] = [];
            for (let item of this.operationList) data["operationList"].push(item);
        }
        return data;
    }
}

/** List of task comments */
export interface IDashboardTaskComment_Public {
    /** comment id */
    id?: number;
    body?: string;
    commentDate?: Date;
    author?: SystemUserIdentity_Public;
    /** attachment list */
    fileList?: SystemFile_Public[];
    /** list of available operations for the comment */
    operationList?: OperationList3[];

    [key: string]: any;
}

export class DashboardTask_Public implements IDashboardTask_Public {
    id?: number;
    number?: string;
    subject?: string;
    description?: string;
    issueDate?: Date;
    plannedDate?: Date;
    referenceId?: number;
    referenceType?: string;
    /** external reference identification - this can be anything that external system is using for identification. By example it can be a claim number, policy id, customer reference */
    externalReferenceId?: string;
    /** external reference type - this should be meaningful for external system entity type identification.By example it can be a CLAIM, POLICY, CUSTOMER. */
    externalReferenceType?: string;
    /** Date after which the task is going to be auto-closed (if not null) */
    autoCloseAfter?: Date;
    author?: SystemUserIdentity_Public;
    assignee?: SystemUserIdentity_Public;
    /** List of task attachments */
    readonly attachmentList?: DashboardAttachment_Public[];
    status?: DictionaryItem_Public;
    /** The date of last status modification */
    readonly statusDate?: Date;
    taskType?: DictionaryItem_Public;
    /** List of task comments */
    readonly commentList?: DashboardTaskComment_Public[];
    /** List of task watchers. The watcher is the one that has been assigned to the task at any moment in the history plus the one that created the task */
    readonly watcherList?: SystemUserIdentity_Public[];
    /** List of task attributes plus the one that created the task */
    readonly attributeList?: DashboardTaskAttribute_Public[];
    intermediary?: IntermediaryIdentity_Public;
    typeCode?: string;
    operationList?: OperationList4[];
    priorityCode?: string;
    statusCode?: string;

    [key: string]: any;

    constructor(data?: IDashboardTask_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.number = _data["number"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.externalReferenceType = _data["externalReferenceType"];
            this.autoCloseAfter = _data["autoCloseAfter"]
                ? new Date(_data["autoCloseAfter"].toString())
                : <any>undefined;
            this.author = _data["author"] ? SystemUserIdentity_Public.fromJS(_data["author"]) : <any>undefined;
            this.assignee = _data["assignee"] ? SystemUserIdentity_Public.fromJS(_data["assignee"]) : <any>undefined;
            if (Array.isArray(_data["attachmentList"])) {
                (<any>this).attachmentList = [] as any;
                for (let item of _data["attachmentList"])
                    (<any>this).attachmentList!.push(DashboardAttachment_Public.fromJS(item));
            }
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            (<any>this).statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.taskType = _data["taskType"] ? DictionaryItem_Public.fromJS(_data["taskType"]) : <any>undefined;
            if (Array.isArray(_data["commentList"])) {
                (<any>this).commentList = [] as any;
                for (let item of _data["commentList"])
                    (<any>this).commentList!.push(DashboardTaskComment_Public.fromJS(item));
            }
            if (Array.isArray(_data["watcherList"])) {
                (<any>this).watcherList = [] as any;
                for (let item of _data["watcherList"])
                    (<any>this).watcherList!.push(SystemUserIdentity_Public.fromJS(item));
            }
            if (Array.isArray(_data["attributeList"])) {
                (<any>this).attributeList = [] as any;
                for (let item of _data["attributeList"])
                    (<any>this).attributeList!.push(DashboardTaskAttribute_Public.fromJS(item));
            }
            this.intermediary = _data["intermediary"]
                ? IntermediaryIdentity_Public.fromJS(_data["intermediary"])
                : <any>undefined;
            this.typeCode = _data["typeCode"];
            if (Array.isArray(_data["operationList"])) {
                this.operationList = [] as any;
                for (let item of _data["operationList"]) this.operationList!.push(item);
            }
            this.priorityCode = _data["priorityCode"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): DashboardTask_Public {
        data = typeof data === "object" ? data : {};
        let result = new DashboardTask_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["number"] = this.number;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        data["externalReferenceId"] = this.externalReferenceId;
        data["externalReferenceType"] = this.externalReferenceType;
        data["autoCloseAfter"] = this.autoCloseAfter ? formatDate(this.autoCloseAfter) : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        if (Array.isArray(this.attachmentList)) {
            data["attachmentList"] = [];
            for (let item of this.attachmentList) data["attachmentList"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["taskType"] = this.taskType ? this.taskType.toJSON() : <any>undefined;
        if (Array.isArray(this.commentList)) {
            data["commentList"] = [];
            for (let item of this.commentList) data["commentList"].push(item.toJSON());
        }
        if (Array.isArray(this.watcherList)) {
            data["watcherList"] = [];
            for (let item of this.watcherList) data["watcherList"].push(item.toJSON());
        }
        if (Array.isArray(this.attributeList)) {
            data["attributeList"] = [];
            for (let item of this.attributeList) data["attributeList"].push(item.toJSON());
        }
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["typeCode"] = this.typeCode;
        if (Array.isArray(this.operationList)) {
            data["operationList"] = [];
            for (let item of this.operationList) data["operationList"].push(item);
        }
        data["priorityCode"] = this.priorityCode;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IDashboardTask_Public {
    id?: number;
    number?: string;
    subject?: string;
    description?: string;
    issueDate?: Date;
    plannedDate?: Date;
    referenceId?: number;
    referenceType?: string;
    /** external reference identification - this can be anything that external system is using for identification. By example it can be a claim number, policy id, customer reference */
    externalReferenceId?: string;
    /** external reference type - this should be meaningful for external system entity type identification.By example it can be a CLAIM, POLICY, CUSTOMER. */
    externalReferenceType?: string;
    /** Date after which the task is going to be auto-closed (if not null) */
    autoCloseAfter?: Date;
    author?: SystemUserIdentity_Public;
    assignee?: SystemUserIdentity_Public;
    /** List of task attachments */
    attachmentList?: DashboardAttachment_Public[];
    status?: DictionaryItem_Public;
    /** The date of last status modification */
    statusDate?: Date;
    taskType?: DictionaryItem_Public;
    /** List of task comments */
    commentList?: DashboardTaskComment_Public[];
    /** List of task watchers. The watcher is the one that has been assigned to the task at any moment in the history plus the one that created the task */
    watcherList?: SystemUserIdentity_Public[];
    /** List of task attributes plus the one that created the task */
    attributeList?: DashboardTaskAttribute_Public[];
    intermediary?: IntermediaryIdentity_Public;
    typeCode?: string;
    operationList?: OperationList4[];
    priorityCode?: string;
    statusCode?: string;

    [key: string]: any;
}

/** Intermediary identification data (if the task is related with the intermediary) */
export class IntermediaryIdentity_Public implements IIntermediaryIdentity_Public {
    /** Intermediary number */
    number?: string;
    /** Intermediary name */
    name?: string;
    businessSymbol?: string;

    [key: string]: any;

    constructor(data?: IIntermediaryIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.number = _data["number"];
            this.name = _data["name"];
            this.businessSymbol = _data["businessSymbol"];
        }
    }

    static fromJS(data: any): IntermediaryIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["number"] = this.number;
        data["name"] = this.name;
        data["businessSymbol"] = this.businessSymbol;
        return data;
    }
}

/** Intermediary identification data (if the task is related with the intermediary) */
export interface IIntermediaryIdentity_Public {
    /** Intermediary number */
    number?: string;
    /** Intermediary name */
    name?: string;
    businessSymbol?: string;

    [key: string]: any;
}

/** attachment list */
export class SystemFile_Public implements ISystemFile_Public {
    filename?: string;
    extension?: string;
    hash?: string;
    size?: number;
    crc?: string;
    file?: string;

    [key: string]: any;

    constructor(data?: ISystemFile_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.filename = _data["filename"];
            this.extension = _data["extension"];
            this.hash = _data["hash"];
            this.size = _data["size"];
            this.crc = _data["crc"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): SystemFile_Public {
        data = typeof data === "object" ? data : {};
        let result = new SystemFile_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["filename"] = this.filename;
        data["extension"] = this.extension;
        data["hash"] = this.hash;
        data["size"] = this.size;
        data["crc"] = this.crc;
        data["file"] = this.file;
        return data;
    }
}

/** attachment list */
export interface ISystemFile_Public {
    filename?: string;
    extension?: string;
    hash?: string;
    size?: number;
    crc?: string;
    file?: string;

    [key: string]: any;
}

/** List of task watchers. The watcher is the one that has been assigned to the task at any moment in the history plus the one that created the task */
export class SystemUserIdentity_Public implements ISystemUserIdentity_Public {
    /** username / login of the user */
    username?: string;
    /** user's email */
    email?: string;
    /** user's full name as concatenated string */
    fullname?: string;
    /** business role identification */
    businessRole?: SystemUserIdentity_PublicBusinessRole;
    /** branch code that the user is assigned to */
    branchCode?: string;

    [key: string]: any;

    constructor(data?: ISystemUserIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.username = _data["username"];
            this.email = _data["email"];
            this.fullname = _data["fullname"];
            this.businessRole = _data["businessRole"];
            this.branchCode = _data["branchCode"];
        }
    }

    static fromJS(data: any): SystemUserIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new SystemUserIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["username"] = this.username;
        data["email"] = this.email;
        data["fullname"] = this.fullname;
        data["businessRole"] = this.businessRole;
        data["branchCode"] = this.branchCode;
        return data;
    }
}

/** List of task watchers. The watcher is the one that has been assigned to the task at any moment in the history plus the one that created the task */
export interface ISystemUserIdentity_Public {
    /** username / login of the user */
    username?: string;
    /** user's email */
    email?: string;
    /** user's full name as concatenated string */
    fullname?: string;
    /** business role identification */
    businessRole?: SystemUserIdentity_PublicBusinessRole;
    /** branch code that the user is assigned to */
    branchCode?: string;

    [key: string]: any;
}

export class CardEvent_Public implements ICardEvent_Public {
    /** task identification */
    issueId?: number;
    status?: DictionaryItem_Public;
    /** reference to the previous task; previous means the one that should be listed before modified issue. This field might be null, and in such case it means that the task should be put in top of the list */
    previousId?: number;

    [key: string]: any;

    constructor(data?: ICardEvent_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.issueId = _data["issueId"];
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.previousId = _data["previousId"];
        }
    }

    static fromJS(data: any): CardEvent_Public {
        data = typeof data === "object" ? data : {};
        let result = new CardEvent_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["issueId"] = this.issueId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["previousId"] = this.previousId;
        return data;
    }
}

export interface ICardEvent_Public {
    /** task identification */
    issueId?: number;
    status?: DictionaryItem_Public;
    /** reference to the previous task; previous means the one that should be listed before modified issue. This field might be null, and in such case it means that the task should be put in top of the list */
    previousId?: number;

    [key: string]: any;
}

/** list of requested reports */
export class MultiReportElement_Public implements IMultiReportElement_Public {
    filter?: ReportFilter_Public;
    /** ordered reports */
    reportCodeList?: string[];

    [key: string]: any;

    constructor(data?: IMultiReportElement_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.filter = _data["filter"] ? ReportFilter_Public.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["reportCodeList"])) {
                this.reportCodeList = [] as any;
                for (let item of _data["reportCodeList"]) this.reportCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): MultiReportElement_Public {
        data = typeof data === "object" ? data : {};
        let result = new MultiReportElement_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.reportCodeList)) {
            data["reportCodeList"] = [];
            for (let item of this.reportCodeList) data["reportCodeList"].push(item);
        }
        return data;
    }
}

/** list of requested reports */
export interface IMultiReportElement_Public {
    filter?: ReportFilter_Public;
    /** ordered reports */
    reportCodeList?: string[];

    [key: string]: any;
}

/** multi-query request filter */
export class MultiReportRequest_Public implements IMultiReportRequest_Public {
    /** list of requested reports */
    list?: MultiReportElement_Public[];

    [key: string]: any;

    constructor(data?: IMultiReportRequest_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(MultiReportElement_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiReportRequest_Public {
        data = typeof data === "object" ? data : {};
        let result = new MultiReportRequest_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        return data;
    }
}

/** multi-query request filter */
export interface IMultiReportRequest_Public {
    /** list of requested reports */
    list?: MultiReportElement_Public[];

    [key: string]: any;
}

/** filter definition */
export class ReportFilter_Public implements IReportFilter_Public {
    /** intermediary number (only if  the report is in context of sales person */
    intermediaryNumber?: string;
    /** tenant code */
    companyCode?: string;
    /** report mode */
    reportMode?: string;
    /** report scope */
    reportScope?: string;

    [key: string]: any;

    constructor(data?: IReportFilter_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.intermediaryNumber = _data["intermediaryNumber"];
            this.companyCode = _data["companyCode"];
            this.reportMode = _data["reportMode"];
            this.reportScope = _data["reportScope"];
        }
    }

    static fromJS(data: any): ReportFilter_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportFilter_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["intermediaryNumber"] = this.intermediaryNumber;
        data["companyCode"] = this.companyCode;
        data["reportMode"] = this.reportMode;
        data["reportScope"] = this.reportScope;
        return data;
    }
}

/** filter definition */
export interface IReportFilter_Public {
    /** intermediary number (only if  the report is in context of sales person */
    intermediaryNumber?: string;
    /** tenant code */
    companyCode?: string;
    /** report mode */
    reportMode?: string;
    /** report scope */
    reportScope?: string;

    [key: string]: any;
}

/** report data */
export class ReportDefinition_Public implements IReportDefinition_Public {
    /** report code */
    code?: ReportDefinition_PublicCode;
    /** report name */
    name?: string;
    /** list of labels */
    labels?: string[];
    /** list of series */
    seriesList?: ReportSeries_Public[];

    [key: string]: any;

    constructor(data?: IReportDefinition_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"]) this.labels!.push(item);
            }
            if (Array.isArray(_data["seriesList"])) {
                this.seriesList = [] as any;
                for (let item of _data["seriesList"]) this.seriesList!.push(ReportSeries_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportDefinition_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportDefinition_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels) data["labels"].push(item);
        }
        if (Array.isArray(this.seriesList)) {
            data["seriesList"] = [];
            for (let item of this.seriesList) data["seriesList"].push(item.toJSON());
        }
        return data;
    }
}

/** report data */
export interface IReportDefinition_Public {
    /** report code */
    code?: ReportDefinition_PublicCode;
    /** report name */
    name?: string;
    /** list of labels */
    labels?: string[];
    /** list of series */
    seriesList?: ReportSeries_Public[];

    [key: string]: any;
}

/** list of series */
export class ReportSeries_Public implements IReportSeries_Public {
    /** year */
    year?: number;
    /** series code */
    code?: string;
    /** series name */
    name?: string;
    /** tooltip value */
    tooltip?: string;
    /** unit type for series */
    unitType?: ReportSeries_PublicUnitType;
    /** dataset (array of values) */
    dataset?: any[];
    /** series order index */
    orderIndex?: number;

    [key: string]: any;

    constructor(data?: IReportSeries_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.year = _data["year"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.tooltip = _data["tooltip"];
            this.unitType = _data["unitType"];
            if (Array.isArray(_data["dataset"])) {
                this.dataset = [] as any;
                for (let item of _data["dataset"]) this.dataset!.push(item);
            }
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): ReportSeries_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportSeries_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["year"] = this.year;
        data["code"] = this.code;
        data["name"] = this.name;
        data["tooltip"] = this.tooltip;
        data["unitType"] = this.unitType;
        if (Array.isArray(this.dataset)) {
            data["dataset"] = [];
            for (let item of this.dataset) data["dataset"].push(item);
        }
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

/** list of series */
export interface IReportSeries_Public {
    /** year */
    year?: number;
    /** series code */
    code?: string;
    /** series name */
    name?: string;
    /** tooltip value */
    tooltip?: string;
    /** unit type for series */
    unitType?: ReportSeries_PublicUnitType;
    /** dataset (array of values) */
    dataset?: any[];
    /** series order index */
    orderIndex?: number;

    [key: string]: any;
}

export class SalesReportHolder_Public implements ISalesReportHolder_Public {
    report?: ReportDefinition_Public;

    [key: string]: any;

    constructor(data?: ISalesReportHolder_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.report = _data["report"] ? ReportDefinition_Public.fromJS(_data["report"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesReportHolder_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesReportHolder_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISalesReportHolder_Public {
    report?: ReportDefinition_Public;

    [key: string]: any;
}

export class AzureAppTokenRequest_Public implements IAzureAppTokenRequest_Public {
    /** Teams token / assertion */
    assertion?: string;
    /** list of scopes */
    scopeList?: string[];

    [key: string]: any;

    constructor(data?: IAzureAppTokenRequest_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.assertion = _data["assertion"];
            if (Array.isArray(_data["scopeList"])) {
                this.scopeList = [] as any;
                for (let item of _data["scopeList"]) this.scopeList!.push(item);
            }
        }
    }

    static fromJS(data: any): AzureAppTokenRequest_Public {
        data = typeof data === "object" ? data : {};
        let result = new AzureAppTokenRequest_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["assertion"] = this.assertion;
        if (Array.isArray(this.scopeList)) {
            data["scopeList"] = [];
            for (let item of this.scopeList) data["scopeList"].push(item);
        }
        return data;
    }
}

export interface IAzureAppTokenRequest_Public {
    /** Teams token / assertion */
    assertion?: string;
    /** list of scopes */
    scopeList?: string[];

    [key: string]: any;
}

export class AzureAppToken_Public implements IAzureAppToken_Public {
    /** generated bearer token */
    accessToken?: string;
    /** token validity in seconds */
    expiresIn?: number;

    [key: string]: any;

    constructor(data?: IAzureAppToken_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.accessToken = _data["accessToken"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): AzureAppToken_Public {
        data = typeof data === "object" ? data : {};
        let result = new AzureAppToken_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["accessToken"] = this.accessToken;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface IAzureAppToken_Public {
    /** generated bearer token */
    accessToken?: string;
    /** token validity in seconds */
    expiresIn?: number;

    [key: string]: any;
}

export class ScorecardReportV3Filter_Public implements IScorecardReportV3Filter_Public {
    scorecardToken?: string;
    level?: ScorecardReportV3Filter_PublicLevel;

    [key: string]: any;

    constructor(data?: IScorecardReportV3Filter_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.scorecardToken = _data["scorecardToken"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): ScorecardReportV3Filter_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardReportV3Filter_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["scorecardToken"] = this.scorecardToken;
        data["level"] = this.level;
        return data;
    }
}

export interface IScorecardReportV3Filter_Public {
    scorecardToken?: string;
    level?: ScorecardReportV3Filter_PublicLevel;

    [key: string]: any;
}

export class ScorecardGoalV3_Public implements IScorecardGoalV3_Public {
    /** tenant identification */
    tenant?: ScorecardGoalV3_PublicTenant;
    /** goal title */
    title?: string;
    /** goal current value */
    currentValue?: number;
    /** progress in % */
    progress?: number;
    /** goal target */
    targetValue?: number;
    /** goal extra text */
    text?: string;
    /** goal order index */
    orderIndex?: number;
    /** ahead value */
    ahead?: number;
    status?: ScorecardGoalV3_PublicStatus;
    /** unit */
    unit?: ScorecardGoalV3_PublicUnit;
    progressValue?: number;

    [key: string]: any;

    constructor(data?: IScorecardGoalV3_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.tenant = _data["tenant"];
            this.title = _data["title"];
            this.currentValue = _data["currentValue"];
            this.progress = _data["progress"];
            this.targetValue = _data["targetValue"];
            this.text = _data["text"];
            this.orderIndex = _data["orderIndex"];
            this.ahead = _data["ahead"];
            this.status = _data["status"];
            this.unit = _data["unit"];
            this.progressValue = _data["progressValue"];
        }
    }

    static fromJS(data: any): ScorecardGoalV3_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardGoalV3_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["tenant"] = this.tenant;
        data["title"] = this.title;
        data["currentValue"] = this.currentValue;
        data["progress"] = this.progress;
        data["targetValue"] = this.targetValue;
        data["text"] = this.text;
        data["orderIndex"] = this.orderIndex;
        data["ahead"] = this.ahead;
        data["status"] = this.status;
        data["unit"] = this.unit;
        data["progressValue"] = this.progressValue;
        return data;
    }
}

export interface IScorecardGoalV3_Public {
    /** tenant identification */
    tenant?: ScorecardGoalV3_PublicTenant;
    /** goal title */
    title?: string;
    /** goal current value */
    currentValue?: number;
    /** progress in % */
    progress?: number;
    /** goal target */
    targetValue?: number;
    /** goal extra text */
    text?: string;
    /** goal order index */
    orderIndex?: number;
    /** ahead value */
    ahead?: number;
    status?: ScorecardGoalV3_PublicStatus;
    /** unit */
    unit?: ScorecardGoalV3_PublicUnit;
    progressValue?: number;

    [key: string]: any;
}

/** report entity list */
export class ScorecardV3ReportEntity_Public implements IScorecardV3ReportEntity_Public {
    scoreCardType?: ScorecardV3ReportEntity_PublicScoreCardType;
    userFullName?: string;
    branchName?: string;
    branchCode?: string;
    mine?: boolean;
    username?: string;
    goalList?: ScorecardGoalV3_Public[];

    [key: string]: any;

    constructor(data?: IScorecardV3ReportEntity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.scoreCardType = _data["scoreCardType"];
            this.userFullName = _data["userFullName"];
            this.branchName = _data["branchName"];
            this.branchCode = _data["branchCode"];
            this.mine = _data["mine"];
            this.username = _data["username"];
            if (Array.isArray(_data["goalList"])) {
                this.goalList = [] as any;
                for (let item of _data["goalList"]) this.goalList!.push(ScorecardGoalV3_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScorecardV3ReportEntity_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardV3ReportEntity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["scoreCardType"] = this.scoreCardType;
        data["userFullName"] = this.userFullName;
        data["branchName"] = this.branchName;
        data["branchCode"] = this.branchCode;
        data["mine"] = this.mine;
        data["username"] = this.username;
        if (Array.isArray(this.goalList)) {
            data["goalList"] = [];
            for (let item of this.goalList) data["goalList"].push(item.toJSON());
        }
        return data;
    }
}

/** report entity list */
export interface IScorecardV3ReportEntity_Public {
    scoreCardType?: ScorecardV3ReportEntity_PublicScoreCardType;
    userFullName?: string;
    branchName?: string;
    branchCode?: string;
    mine?: boolean;
    username?: string;
    goalList?: ScorecardGoalV3_Public[];

    [key: string]: any;
}

export class ScorecardV3Report_Public implements IScorecardV3Report_Public {
    /** score card unique token */
    token?: string;
    /** score card period type */
    periodType?: ScorecardV3Report_PublicPeriodType;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;
    /** period description (to be shown for user selection) */
    description?: string;
    /** report entity list */
    list?: ScorecardV3ReportEntity_Public[];

    [key: string]: any;

    constructor(data?: IScorecardV3Report_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.token = _data["token"];
            this.periodType = _data["periodType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(ScorecardV3ReportEntity_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScorecardV3Report_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardV3Report_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["token"] = this.token;
        data["periodType"] = this.periodType;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScorecardV3Report_Public {
    /** score card unique token */
    token?: string;
    /** score card period type */
    periodType?: ScorecardV3Report_PublicPeriodType;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;
    /** period description (to be shown for user selection) */
    description?: string;
    /** report entity list */
    list?: ScorecardV3ReportEntity_Public[];

    [key: string]: any;
}

export class RankingV3ReportFilter_Public implements IRankingV3ReportFilter_Public {
    level?: RankingV3ReportFilter_PublicLevel;
    period?: RankingV3ReportFilter_PublicPeriod;

    [key: string]: any;

    constructor(data?: IRankingV3ReportFilter_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.level = _data["level"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): RankingV3ReportFilter_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingV3ReportFilter_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["level"] = this.level;
        data["period"] = this.period;
        return data;
    }
}

export interface IRankingV3ReportFilter_Public {
    level?: RankingV3ReportFilter_PublicLevel;
    period?: RankingV3ReportFilter_PublicPeriod;

    [key: string]: any;
}

/** ranking element list */
export class RankingV3Element_Public implements IRankingV3Element_Public {
    /** tenant identification */
    tenant?: RankingV3Element_PublicTenant;
    /** element title */
    title?: string;
    /** ranking extra text */
    text?: string;
    /** current position */
    position?: number;
    /** position delta */
    positionDelta?: number;
    /** group count */
    groupCount?: number;
    /** target plan */
    planTarget?: number;
    /** current value */
    planValue?: number;
    /** unit */
    unit?: RankingV3Element_PublicUnit;

    [key: string]: any;

    constructor(data?: IRankingV3Element_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.tenant = _data["tenant"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.position = _data["position"];
            this.positionDelta = _data["positionDelta"];
            this.groupCount = _data["groupCount"];
            this.planTarget = _data["planTarget"];
            this.planValue = _data["planValue"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): RankingV3Element_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingV3Element_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["tenant"] = this.tenant;
        data["title"] = this.title;
        data["text"] = this.text;
        data["position"] = this.position;
        data["positionDelta"] = this.positionDelta;
        data["groupCount"] = this.groupCount;
        data["planTarget"] = this.planTarget;
        data["planValue"] = this.planValue;
        data["unit"] = this.unit;
        return data;
    }
}

/** ranking element list */
export interface IRankingV3Element_Public {
    /** tenant identification */
    tenant?: RankingV3Element_PublicTenant;
    /** element title */
    title?: string;
    /** ranking extra text */
    text?: string;
    /** current position */
    position?: number;
    /** position delta */
    positionDelta?: number;
    /** group count */
    groupCount?: number;
    /** target plan */
    planTarget?: number;
    /** current value */
    planValue?: number;
    /** unit */
    unit?: RankingV3Element_PublicUnit;

    [key: string]: any;
}

export class RankingV3ReportEntity_Public implements IRankingV3ReportEntity_Public {
    /** ranking type */
    rankingType?: RankingV3ReportEntity_PublicRankingType;
    /** level */
    level?: RankingV3ReportEntity_PublicLevel;
    /** branch code */
    branchCode?: string;
    /** branch name */
    branchName?: string;
    /** username */
    username?: string;
    userFullName?: string;
    mine?: boolean;
    /** ranking element list */
    elementList?: RankingV3Element_Public[];

    [key: string]: any;

    constructor(data?: IRankingV3ReportEntity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.rankingType = _data["rankingType"];
            this.level = _data["level"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.username = _data["username"];
            this.userFullName = _data["userFullName"];
            this.mine = _data["mine"];
            if (Array.isArray(_data["elementList"])) {
                this.elementList = [] as any;
                for (let item of _data["elementList"]) this.elementList!.push(RankingV3Element_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RankingV3ReportEntity_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingV3ReportEntity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["rankingType"] = this.rankingType;
        data["level"] = this.level;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["username"] = this.username;
        data["userFullName"] = this.userFullName;
        data["mine"] = this.mine;
        if (Array.isArray(this.elementList)) {
            data["elementList"] = [];
            for (let item of this.elementList) data["elementList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRankingV3ReportEntity_Public {
    /** ranking type */
    rankingType?: RankingV3ReportEntity_PublicRankingType;
    /** level */
    level?: RankingV3ReportEntity_PublicLevel;
    /** branch code */
    branchCode?: string;
    /** branch name */
    branchName?: string;
    /** username */
    username?: string;
    userFullName?: string;
    mine?: boolean;
    /** ranking element list */
    elementList?: RankingV3Element_Public[];

    [key: string]: any;
}

export class RankingV3Report_Public implements IRankingV3Report_Public {
    effectiveDate?: Date;
    list?: RankingV3ReportEntity_Public[];

    [key: string]: any;

    constructor(data?: IRankingV3Report_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(RankingV3ReportEntity_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RankingV3Report_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingV3Report_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["effectiveDate"] = this.effectiveDate ? formatDate(this.effectiveDate) : <any>undefined;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRankingV3Report_Public {
    effectiveDate?: Date;
    list?: RankingV3ReportEntity_Public[];

    [key: string]: any;
}

export class ApiToken_Public implements IApiToken_Public {
    creationTime?: Date;
    token?: string;
    validDate?: Date;

    [key: string]: any;

    constructor(data?: IApiToken_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.token = _data["token"];
            this.validDate = _data["validDate"] ? new Date(_data["validDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiToken_Public {
        data = typeof data === "object" ? data : {};
        let result = new ApiToken_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["token"] = this.token;
        data["validDate"] = this.validDate ? this.validDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApiToken_Public {
    creationTime?: Date;
    token?: string;
    validDate?: Date;

    [key: string]: any;
}

export class SystemUser_Public implements ISystemUser_Public {
    id?: number;
    username?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    businessRole?: SystemUser_PublicBusinessRole;
    branchCode?: string;
    mobilePhone?: string;
    fullName?: string;
    grantList?: string[];
    grantGroupIdentities?: UserGrantGroupIdentity_Public[];
    refreshToken?: ApiToken_Public;

    [key: string]: any;

    constructor(data?: ISystemUser_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.businessRole = _data["businessRole"];
            this.branchCode = _data["branchCode"];
            this.mobilePhone = _data["mobilePhone"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["grantList"])) {
                this.grantList = [] as any;
                for (let item of _data["grantList"]) this.grantList!.push(item);
            }
            if (Array.isArray(_data["grantGroupIdentities"])) {
                this.grantGroupIdentities = [] as any;
                for (let item of _data["grantGroupIdentities"])
                    this.grantGroupIdentities!.push(UserGrantGroupIdentity_Public.fromJS(item));
            }
            this.refreshToken = _data["refreshToken"] ? ApiToken_Public.fromJS(_data["refreshToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemUser_Public {
        data = typeof data === "object" ? data : {};
        let result = new SystemUser_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["businessRole"] = this.businessRole;
        data["branchCode"] = this.branchCode;
        data["mobilePhone"] = this.mobilePhone;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.grantList)) {
            data["grantList"] = [];
            for (let item of this.grantList) data["grantList"].push(item);
        }
        if (Array.isArray(this.grantGroupIdentities)) {
            data["grantGroupIdentities"] = [];
            for (let item of this.grantGroupIdentities) data["grantGroupIdentities"].push(item.toJSON());
        }
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISystemUser_Public {
    id?: number;
    username?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    businessRole?: SystemUser_PublicBusinessRole;
    branchCode?: string;
    mobilePhone?: string;
    fullName?: string;
    grantList?: string[];
    grantGroupIdentities?: UserGrantGroupIdentity_Public[];
    refreshToken?: ApiToken_Public;

    [key: string]: any;
}

export class UserGrantGroupIdentity_Public implements IUserGrantGroupIdentity_Public {
    /** grant technical id */
    id?: number;
    /** grant code */
    code?: string;
    /** grant name */
    name?: string;

    [key: string]: any;

    constructor(data?: IUserGrantGroupIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserGrantGroupIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new UserGrantGroupIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserGrantGroupIdentity_Public {
    /** grant technical id */
    id?: number;
    /** grant code */
    code?: string;
    /** grant name */
    name?: string;

    [key: string]: any;
}

export class V360SearchFilter_Public implements IV360SearchFilter_Public {
    /** should the list be limited to active only entities; if false - then this search attribute is ignored (both active and non active will be returned */
    activeOnly?: boolean;
    /** limit definition, default 100 */
    limit?: number;
    /** phrase for entity search */
    phrase?: string;

    [key: string]: any;

    constructor(data?: IV360SearchFilter_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.activeOnly = _data["activeOnly"];
            this.limit = _data["limit"];
            this.phrase = _data["phrase"];
        }
    }

    static fromJS(data: any): V360SearchFilter_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360SearchFilter_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["activeOnly"] = this.activeOnly;
        data["limit"] = this.limit;
        data["phrase"] = this.phrase;
        return data;
    }
}

export interface IV360SearchFilter_Public {
    /** should the list be limited to active only entities; if false - then this search attribute is ignored (both active and non active will be returned */
    activeOnly?: boolean;
    /** limit definition, default 100 */
    limit?: number;
    /** phrase for entity search */
    phrase?: string;

    [key: string]: any;
}

/** entity list */
export class V360SearchResultItem_Public implements IV360SearchResultItem_Public {
    /** entity technical id */
    entityId?: number;
    /** entity type */
    entityType?: string;
    /** entity name */
    name?: string;
    /** list of intermediary names (only for sales person) */
    intermediaryList?: string[];
    status?: DictionaryItem_Public;

    [key: string]: any;

    constructor(data?: IV360SearchResultItem_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.name = _data["name"];
            if (Array.isArray(_data["intermediaryList"])) {
                this.intermediaryList = [] as any;
                for (let item of _data["intermediaryList"]) this.intermediaryList!.push(item);
            }
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): V360SearchResultItem_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360SearchResultItem_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["name"] = this.name;
        if (Array.isArray(this.intermediaryList)) {
            data["intermediaryList"] = [];
            for (let item of this.intermediaryList) data["intermediaryList"].push(item);
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

/** entity list */
export interface IV360SearchResultItem_Public {
    /** entity technical id */
    entityId?: number;
    /** entity type */
    entityType?: string;
    /** entity name */
    name?: string;
    /** list of intermediary names (only for sales person) */
    intermediaryList?: string[];
    status?: DictionaryItem_Public;

    [key: string]: any;
}

export class V360SearchResult_Public implements IV360SearchResult_Public {
    /** entity list */
    list?: V360SearchResultItem_Public[];
    /** flag if there is more results */
    hasMore?: boolean;

    [key: string]: any;

    constructor(data?: IV360SearchResult_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(V360SearchResultItem_Public.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): V360SearchResult_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360SearchResult_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IV360SearchResult_Public {
    /** entity list */
    list?: V360SearchResultItem_Public[];
    /** flag if there is more results */
    hasMore?: boolean;

    [key: string]: any;
}

/** access control per information block */
export class SalesPersonAcl_Public implements ISalesPersonAcl_Public {
    /** if sales reports are accessible */
    salesReports?: boolean;
    /** if notes functionality is accessible */
    notes?: boolean;

    [key: string]: any;

    constructor(data?: ISalesPersonAcl_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.salesReports = _data["salesReports"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SalesPersonAcl_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesPersonAcl_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["salesReports"] = this.salesReports;
        data["notes"] = this.notes;
        return data;
    }
}

/** access control per information block */
export interface ISalesPersonAcl_Public {
    /** if sales reports are accessible */
    salesReports?: boolean;
    /** if notes functionality is accessible */
    notes?: boolean;

    [key: string]: any;
}

/** dynamic attribute list */
export class SalesPersonNetworkDynamicAttribute_Public implements ISalesPersonNetworkDynamicAttribute_Public {
    id?: number;
    /** attribute code, one of codes from SALES_NETWORK_ATTRIBUTE dictionary items */
    code?: string;
    definition?: DictionaryItem_Public;
    /** tenant code */
    tenantCode?: string;
    /** string value (only if the type of the attribute is STRING) */
    stringValue?: string;
    /** long / integer value (only if the type of the attribute is LONG) */
    longValue?: number;
    /** decimal value (only if the type of the attribute is DECIMAL) */
    decimalValue?: number;
    /** boolean value (only if the type of the attribute is BOOLEAN) */
    booleanValue?: boolean;
    /** date value (only if the type of the attribute is DATE) */
    dateValue?: Date;
    /** date-time value (only if the type of the attribute is DATETIME) */
    dateTimeValue?: Date;

    [key: string]: any;

    constructor(data?: ISalesPersonNetworkDynamicAttribute_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.definition = _data["definition"] ? DictionaryItem_Public.fromJS(_data["definition"]) : <any>undefined;
            this.tenantCode = _data["tenantCode"];
            this.stringValue = _data["stringValue"];
            this.longValue = _data["longValue"];
            this.decimalValue = _data["decimalValue"];
            this.booleanValue = _data["booleanValue"];
            this.dateValue = _data["dateValue"] ? new Date(_data["dateValue"].toString()) : <any>undefined;
            this.dateTimeValue = _data["dateTimeValue"] ? new Date(_data["dateTimeValue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesPersonNetworkDynamicAttribute_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesPersonNetworkDynamicAttribute_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["tenantCode"] = this.tenantCode;
        data["stringValue"] = this.stringValue;
        data["longValue"] = this.longValue;
        data["decimalValue"] = this.decimalValue;
        data["booleanValue"] = this.booleanValue;
        data["dateValue"] = this.dateValue ? formatDate(this.dateValue) : <any>undefined;
        data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toISOString() : <any>undefined;
        return data;
    }
}

/** dynamic attribute list */
export interface ISalesPersonNetworkDynamicAttribute_Public {
    id?: number;
    /** attribute code, one of codes from SALES_NETWORK_ATTRIBUTE dictionary items */
    code?: string;
    definition?: DictionaryItem_Public;
    /** tenant code */
    tenantCode?: string;
    /** string value (only if the type of the attribute is STRING) */
    stringValue?: string;
    /** long / integer value (only if the type of the attribute is LONG) */
    longValue?: number;
    /** decimal value (only if the type of the attribute is DECIMAL) */
    decimalValue?: number;
    /** boolean value (only if the type of the attribute is BOOLEAN) */
    booleanValue?: boolean;
    /** date value (only if the type of the attribute is DATE) */
    dateValue?: Date;
    /** date-time value (only if the type of the attribute is DATETIME) */
    dateTimeValue?: Date;

    [key: string]: any;
}

/** list of trainings */
export class SalesPersonTraining_Public implements ISalesPersonTraining_Public {
    id?: number;
    /** tenant code */
    tenantCode?: string;
    /** source system identification */
    sourceCode?: string;
    /** source system training identification */
    sourceTrainingId?: string;
    /** training date */
    trainingDate?: Date;
    /** training name */
    trainingName?: string;
    type?: DictionaryItem_Public;
    /** number of training hours */
    hoursCount?: number;
    /** work training flag */
    workTraining?: boolean;
    /** training completion flag */
    completionFlag?: boolean;

    [key: string]: any;

    constructor(data?: ISalesPersonTraining_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenantCode = _data["tenantCode"];
            this.sourceCode = _data["sourceCode"];
            this.sourceTrainingId = _data["sourceTrainingId"];
            this.trainingDate = _data["trainingDate"] ? new Date(_data["trainingDate"].toString()) : <any>undefined;
            this.trainingName = _data["trainingName"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.hoursCount = _data["hoursCount"];
            this.workTraining = _data["workTraining"];
            this.completionFlag = _data["completionFlag"];
        }
    }

    static fromJS(data: any): SalesPersonTraining_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesPersonTraining_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenantCode"] = this.tenantCode;
        data["sourceCode"] = this.sourceCode;
        data["sourceTrainingId"] = this.sourceTrainingId;
        data["trainingDate"] = this.trainingDate ? formatDate(this.trainingDate) : <any>undefined;
        data["trainingName"] = this.trainingName;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["hoursCount"] = this.hoursCount;
        data["workTraining"] = this.workTraining;
        data["completionFlag"] = this.completionFlag;
        return data;
    }
}

/** list of trainings */
export interface ISalesPersonTraining_Public {
    id?: number;
    /** tenant code */
    tenantCode?: string;
    /** source system identification */
    sourceCode?: string;
    /** source system training identification */
    sourceTrainingId?: string;
    /** training date */
    trainingDate?: Date;
    /** training name */
    trainingName?: string;
    type?: DictionaryItem_Public;
    /** number of training hours */
    hoursCount?: number;
    /** work training flag */
    workTraining?: boolean;
    /** training completion flag */
    completionFlag?: boolean;

    [key: string]: any;
}

/** profile list */
export class SalesPersonV360Profile_Public implements ISalesPersonV360Profile_Public {
    /** intermediary technical id, used for link generation in frontend */
    intermediaryId?: number;
    /** intermediary name */
    name?: string;
    /** intermediary name */
    number?: string;
    /** list of profile numbers */
    profileNumberList?: string[];
    /** list of profile identities */
    profileIdentityList?: V360ProfileIdentity_Public[];
    /** branch name and code */
    branch?: string;
    /** role in the profile */
    role?: string;
    rms?: UserBasicEntity_Public;
    /** channel definition */
    channel?: string;
    /** list of system access */
    systemAccess?: string;
    director?: UserBasicEntity_Public;

    [key: string]: any;

    constructor(data?: ISalesPersonV360Profile_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.intermediaryId = _data["intermediaryId"];
            this.name = _data["name"];
            this.number = _data["number"];
            if (Array.isArray(_data["profileNumberList"])) {
                this.profileNumberList = [] as any;
                for (let item of _data["profileNumberList"]) this.profileNumberList!.push(item);
            }
            if (Array.isArray(_data["profileIdentityList"])) {
                this.profileIdentityList = [] as any;
                for (let item of _data["profileIdentityList"])
                    this.profileIdentityList!.push(V360ProfileIdentity_Public.fromJS(item));
            }
            this.branch = _data["branch"];
            this.role = _data["role"];
            this.rms = _data["rms"] ? UserBasicEntity_Public.fromJS(_data["rms"]) : <any>undefined;
            this.channel = _data["channel"];
            this.systemAccess = _data["systemAccess"];
            this.director = _data["director"] ? UserBasicEntity_Public.fromJS(_data["director"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesPersonV360Profile_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesPersonV360Profile_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["intermediaryId"] = this.intermediaryId;
        data["name"] = this.name;
        data["number"] = this.number;
        if (Array.isArray(this.profileNumberList)) {
            data["profileNumberList"] = [];
            for (let item of this.profileNumberList) data["profileNumberList"].push(item);
        }
        if (Array.isArray(this.profileIdentityList)) {
            data["profileIdentityList"] = [];
            for (let item of this.profileIdentityList) data["profileIdentityList"].push(item.toJSON());
        }
        data["branch"] = this.branch;
        data["role"] = this.role;
        data["rms"] = this.rms ? this.rms.toJSON() : <any>undefined;
        data["channel"] = this.channel;
        data["systemAccess"] = this.systemAccess;
        data["director"] = this.director ? this.director.toJSON() : <any>undefined;
        return data;
    }
}

/** profile list */
export interface ISalesPersonV360Profile_Public {
    /** intermediary technical id, used for link generation in frontend */
    intermediaryId?: number;
    /** intermediary name */
    name?: string;
    /** intermediary name */
    number?: string;
    /** list of profile numbers */
    profileNumberList?: string[];
    /** list of profile identities */
    profileIdentityList?: V360ProfileIdentity_Public[];
    /** branch name and code */
    branch?: string;
    /** role in the profile */
    role?: string;
    rms?: UserBasicEntity_Public;
    /** channel definition */
    channel?: string;
    /** list of system access */
    systemAccess?: string;
    director?: UserBasicEntity_Public;

    [key: string]: any;
}

export class SalesPersonV360_Public implements ISalesPersonV360_Public {
    /** sales person technical id */
    id?: number;
    acl?: SalesPersonAcl_Public;
    /** punu */
    punu?: string;
    /** first name */
    firstName?: string;
    /** last name */
    lastName?: string;
    /** birth date */
    birthDate?: Date;
    /** number of the person entity in core system */
    systemNumber?: string;
    /** phone number granted for EHM tenant (dynamic attribute of PHONE and EHM tenant) */
    phoneNumberEHM?: string;
    /** phone number granted for EHZ tenant (dynamic attribute of PHONE and EHZ tenant) */
    phoneNumberEHZ?: string;
    /** email address granted for EHM tenant (dynamic attribute of EMAIL and EHM tenant) */
    emailEHM?: string;
    /** email address granted for EHZ tenant (dynamic attribute of EMAIL and EHZ tenant) */
    emailEHZ?: string;
    /** marketing consent for EHM tenant (dynamic attribute of MARKETING_CONSENT and EHM tenant) */
    marketingConsentEHM?: boolean;
    /** marketing consent for EHZ tenant (dynamic attribute of MARKETING_CONSENT and EHZ tenant) */
    marketingConsentEHZ?: boolean;
    /** knf registration date for EHM tenant (dynamic attribute of KNF_DATE and tenant EHM) */
    knfDateEHM?: Date;
    /** knf registration date for EHZ tenant (dynamic attribute of KNF_DATE and tenant EHZ) */
    knfDateEHZ?: Date;
    certification?: DictionaryItem_Public;
    /** list of trainings */
    trainingList?: SalesPersonTraining_Public[];
    /** profile list */
    profileList?: SalesPersonV360Profile_Public[];
    /** dynamic attribute list */
    dynamicAttributeList?: SalesPersonNetworkDynamicAttribute_Public[];
    status?: DictionaryItem_Public;
    ipunktStatus?: string;

    [key: string]: any;

    constructor(data?: ISalesPersonV360_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.acl = _data["acl"] ? SalesPersonAcl_Public.fromJS(_data["acl"]) : <any>undefined;
            this.punu = _data["punu"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.systemNumber = _data["systemNumber"];
            this.phoneNumberEHM = _data["phoneNumberEHM"];
            this.phoneNumberEHZ = _data["phoneNumberEHZ"];
            this.emailEHM = _data["emailEHM"];
            this.emailEHZ = _data["emailEHZ"];
            this.marketingConsentEHM = _data["marketingConsentEHM"];
            this.marketingConsentEHZ = _data["marketingConsentEHZ"];
            this.knfDateEHM = _data["knfDateEHM"] ? new Date(_data["knfDateEHM"].toString()) : <any>undefined;
            this.knfDateEHZ = _data["knfDateEHZ"] ? new Date(_data["knfDateEHZ"].toString()) : <any>undefined;
            this.certification = _data["certification"]
                ? DictionaryItem_Public.fromJS(_data["certification"])
                : <any>undefined;
            if (Array.isArray(_data["trainingList"])) {
                this.trainingList = [] as any;
                for (let item of _data["trainingList"])
                    this.trainingList!.push(SalesPersonTraining_Public.fromJS(item));
            }
            if (Array.isArray(_data["profileList"])) {
                this.profileList = [] as any;
                for (let item of _data["profileList"])
                    this.profileList!.push(SalesPersonV360Profile_Public.fromJS(item));
            }
            if (Array.isArray(_data["dynamicAttributeList"])) {
                this.dynamicAttributeList = [] as any;
                for (let item of _data["dynamicAttributeList"])
                    this.dynamicAttributeList!.push(SalesPersonNetworkDynamicAttribute_Public.fromJS(item));
            }
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.ipunktStatus = _data["ipunktStatus"];
        }
    }

    static fromJS(data: any): SalesPersonV360_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesPersonV360_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["acl"] = this.acl ? this.acl.toJSON() : <any>undefined;
        data["punu"] = this.punu;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["systemNumber"] = this.systemNumber;
        data["phoneNumberEHM"] = this.phoneNumberEHM;
        data["phoneNumberEHZ"] = this.phoneNumberEHZ;
        data["emailEHM"] = this.emailEHM;
        data["emailEHZ"] = this.emailEHZ;
        data["marketingConsentEHM"] = this.marketingConsentEHM;
        data["marketingConsentEHZ"] = this.marketingConsentEHZ;
        data["knfDateEHM"] = this.knfDateEHM ? formatDate(this.knfDateEHM) : <any>undefined;
        data["knfDateEHZ"] = this.knfDateEHZ ? formatDate(this.knfDateEHZ) : <any>undefined;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        if (Array.isArray(this.trainingList)) {
            data["trainingList"] = [];
            for (let item of this.trainingList) data["trainingList"].push(item.toJSON());
        }
        if (Array.isArray(this.profileList)) {
            data["profileList"] = [];
            for (let item of this.profileList) data["profileList"].push(item.toJSON());
        }
        if (Array.isArray(this.dynamicAttributeList)) {
            data["dynamicAttributeList"] = [];
            for (let item of this.dynamicAttributeList) data["dynamicAttributeList"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["ipunktStatus"] = this.ipunktStatus;
        return data;
    }
}

export interface ISalesPersonV360_Public {
    /** sales person technical id */
    id?: number;
    acl?: SalesPersonAcl_Public;
    /** punu */
    punu?: string;
    /** first name */
    firstName?: string;
    /** last name */
    lastName?: string;
    /** birth date */
    birthDate?: Date;
    /** number of the person entity in core system */
    systemNumber?: string;
    /** phone number granted for EHM tenant (dynamic attribute of PHONE and EHM tenant) */
    phoneNumberEHM?: string;
    /** phone number granted for EHZ tenant (dynamic attribute of PHONE and EHZ tenant) */
    phoneNumberEHZ?: string;
    /** email address granted for EHM tenant (dynamic attribute of EMAIL and EHM tenant) */
    emailEHM?: string;
    /** email address granted for EHZ tenant (dynamic attribute of EMAIL and EHZ tenant) */
    emailEHZ?: string;
    /** marketing consent for EHM tenant (dynamic attribute of MARKETING_CONSENT and EHM tenant) */
    marketingConsentEHM?: boolean;
    /** marketing consent for EHZ tenant (dynamic attribute of MARKETING_CONSENT and EHZ tenant) */
    marketingConsentEHZ?: boolean;
    /** knf registration date for EHM tenant (dynamic attribute of KNF_DATE and tenant EHM) */
    knfDateEHM?: Date;
    /** knf registration date for EHZ tenant (dynamic attribute of KNF_DATE and tenant EHZ) */
    knfDateEHZ?: Date;
    certification?: DictionaryItem_Public;
    /** list of trainings */
    trainingList?: SalesPersonTraining_Public[];
    /** profile list */
    profileList?: SalesPersonV360Profile_Public[];
    /** dynamic attribute list */
    dynamicAttributeList?: SalesPersonNetworkDynamicAttribute_Public[];
    status?: DictionaryItem_Public;
    ipunktStatus?: string;

    [key: string]: any;
}

/** list of profile identities */
export class V360ProfileIdentity_Public implements IV360ProfileIdentity_Public {
    /** profule number */
    number?: string;
    /** identification of main profile */
    isMain?: boolean;

    [key: string]: any;

    constructor(data?: IV360ProfileIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.number = _data["number"];
            this.isMain = _data["isMain"];
        }
    }

    static fromJS(data: any): V360ProfileIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360ProfileIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["number"] = this.number;
        data["isMain"] = this.isMain;
        return data;
    }
}

/** list of profile identities */
export interface IV360ProfileIdentity_Public {
    /** profule number */
    number?: string;
    /** identification of main profile */
    isMain?: boolean;

    [key: string]: any;
}

export class EntityNoteHeader_Public implements IEntityNoteHeader_Public {
    id?: number;
    /** entity type */
    entityType?: EntityNoteHeader_PublicEntityType;
    /** entityId */
    entityId?: number;
    entityName?: string;
    /** first edit date */
    firstEditDate?: Date;
    /** last edit date */
    lastEditDate?: Date;
    author?: UserBasicEntity_Public;
    lastEditBy?: UserBasicEntity_Public;
    noteType?: DictionaryItem_Public;
    /** contact date */
    contactDate?: Date;
    /** list of subjects for retail */
    subjectRetailList?: DictionaryItem_Public[];
    /** list of subjects for corpo */
    subjectCorpoList?: DictionaryItem_Public[];
    /** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
    intermediaryReferenceList?: IntermediaryReference_Public[];

    [key: string]: any;

    constructor(data?: IEntityNoteHeader_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.firstEditDate = _data["firstEditDate"] ? new Date(_data["firstEditDate"].toString()) : <any>undefined;
            this.lastEditDate = _data["lastEditDate"] ? new Date(_data["lastEditDate"].toString()) : <any>undefined;
            this.author = _data["author"] ? UserBasicEntity_Public.fromJS(_data["author"]) : <any>undefined;
            this.lastEditBy = _data["lastEditBy"] ? UserBasicEntity_Public.fromJS(_data["lastEditBy"]) : <any>undefined;
            this.noteType = _data["noteType"] ? DictionaryItem_Public.fromJS(_data["noteType"]) : <any>undefined;
            this.contactDate = _data["contactDate"] ? new Date(_data["contactDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["subjectRetailList"])) {
                this.subjectRetailList = [] as any;
                for (let item of _data["subjectRetailList"])
                    this.subjectRetailList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["subjectCorpoList"])) {
                this.subjectCorpoList = [] as any;
                for (let item of _data["subjectCorpoList"])
                    this.subjectCorpoList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["intermediaryReferenceList"])) {
                this.intermediaryReferenceList = [] as any;
                for (let item of _data["intermediaryReferenceList"])
                    this.intermediaryReferenceList!.push(IntermediaryReference_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityNoteHeader_Public {
        data = typeof data === "object" ? data : {};
        let result = new EntityNoteHeader_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["firstEditDate"] = this.firstEditDate ? this.firstEditDate.toISOString() : <any>undefined;
        data["lastEditDate"] = this.lastEditDate ? this.lastEditDate.toISOString() : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["lastEditBy"] = this.lastEditBy ? this.lastEditBy.toJSON() : <any>undefined;
        data["noteType"] = this.noteType ? this.noteType.toJSON() : <any>undefined;
        data["contactDate"] = this.contactDate ? formatDate(this.contactDate) : <any>undefined;
        if (Array.isArray(this.subjectRetailList)) {
            data["subjectRetailList"] = [];
            for (let item of this.subjectRetailList) data["subjectRetailList"].push(item.toJSON());
        }
        if (Array.isArray(this.subjectCorpoList)) {
            data["subjectCorpoList"] = [];
            for (let item of this.subjectCorpoList) data["subjectCorpoList"].push(item.toJSON());
        }
        if (Array.isArray(this.intermediaryReferenceList)) {
            data["intermediaryReferenceList"] = [];
            for (let item of this.intermediaryReferenceList) data["intermediaryReferenceList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntityNoteHeader_Public {
    id?: number;
    /** entity type */
    entityType?: EntityNoteHeader_PublicEntityType;
    /** entityId */
    entityId?: number;
    entityName?: string;
    /** first edit date */
    firstEditDate?: Date;
    /** last edit date */
    lastEditDate?: Date;
    author?: UserBasicEntity_Public;
    lastEditBy?: UserBasicEntity_Public;
    noteType?: DictionaryItem_Public;
    /** contact date */
    contactDate?: Date;
    /** list of subjects for retail */
    subjectRetailList?: DictionaryItem_Public[];
    /** list of subjects for corpo */
    subjectCorpoList?: DictionaryItem_Public[];
    /** extra identification of the intermediary related with the note, should be provided just when the main entity is OFWCA */
    intermediaryReferenceList?: IntermediaryReference_Public[];

    [key: string]: any;
}

export class EntityNoteSearchResult_Public implements IEntityNoteSearchResult_Public {
    list?: EntityNoteHeader_Public[];
    hasMore?: boolean;

    [key: string]: any;

    constructor(data?: IEntityNoteSearchResult_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(EntityNoteHeader_Public.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): EntityNoteSearchResult_Public {
        data = typeof data === "object" ? data : {};
        let result = new EntityNoteSearchResult_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IEntityNoteSearchResult_Public {
    list?: EntityNoteHeader_Public[];
    hasMore?: boolean;

    [key: string]: any;
}

export class DailySalesReport_Public implements IDailySalesReport_Public {
    tenantList?: DailySalesTenantReport_Public[];

    [key: string]: any;

    constructor(data?: IDailySalesReport_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["tenantList"])) {
                this.tenantList = [] as any;
                for (let item of _data["tenantList"]) this.tenantList!.push(DailySalesTenantReport_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailySalesReport_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesReport_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.tenantList)) {
            data["tenantList"] = [];
            for (let item of this.tenantList) data["tenantList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailySalesReport_Public {
    tenantList?: DailySalesTenantReport_Public[];

    [key: string]: any;
}

export class DailySalesSegment_Public implements IDailySalesSegment_Public {
    segment?: ReportLabel_Public;
    premium?: number;
    count?: number;

    [key: string]: any;

    constructor(data?: IDailySalesSegment_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.segment = _data["segment"] ? ReportLabel_Public.fromJS(_data["segment"]) : <any>undefined;
            this.premium = _data["premium"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DailySalesSegment_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesSegment_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["segment"] = this.segment ? this.segment.toJSON() : <any>undefined;
        data["premium"] = this.premium;
        data["count"] = this.count;
        return data;
    }
}

export interface IDailySalesSegment_Public {
    segment?: ReportLabel_Public;
    premium?: number;
    count?: number;

    [key: string]: any;
}

export class DailySalesTenantReport_Public implements IDailySalesTenantReport_Public {
    code?: string;
    name?: string;
    colorScheme?: string;
    orderIndex?: number;
    premium?: number;
    count?: number;
    seriesList?: SeriesIdentity_Public[];
    segmentList?: DailySalesSegment_Public[];

    [key: string]: any;

    constructor(data?: IDailySalesTenantReport_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
            this.colorScheme = _data["colorScheme"];
            this.orderIndex = _data["orderIndex"];
            this.premium = _data["premium"];
            this.count = _data["count"];
            if (Array.isArray(_data["seriesList"])) {
                this.seriesList = [] as any;
                for (let item of _data["seriesList"]) this.seriesList!.push(SeriesIdentity_Public.fromJS(item));
            }
            if (Array.isArray(_data["segmentList"])) {
                this.segmentList = [] as any;
                for (let item of _data["segmentList"]) this.segmentList!.push(DailySalesSegment_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailySalesTenantReport_Public {
        data = typeof data === "object" ? data : {};
        let result = new DailySalesTenantReport_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        data["colorScheme"] = this.colorScheme;
        data["orderIndex"] = this.orderIndex;
        data["premium"] = this.premium;
        data["count"] = this.count;
        if (Array.isArray(this.seriesList)) {
            data["seriesList"] = [];
            for (let item of this.seriesList) data["seriesList"].push(item.toJSON());
        }
        if (Array.isArray(this.segmentList)) {
            data["segmentList"] = [];
            for (let item of this.segmentList) data["segmentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailySalesTenantReport_Public {
    code?: string;
    name?: string;
    colorScheme?: string;
    orderIndex?: number;
    premium?: number;
    count?: number;
    seriesList?: SeriesIdentity_Public[];
    segmentList?: DailySalesSegment_Public[];

    [key: string]: any;
}

/** report label / selection element definition */
export class ReportLabel_Public implements IReportLabel_Public {
    /** code */
    code?: string;
    /** description / name of the element */
    description?: string;
    /** order index */
    orderIndex?: number;
    /** default selection flag */
    selected?: boolean;

    [key: string]: any;

    constructor(data?: IReportLabel_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.description = _data["description"];
            this.orderIndex = _data["orderIndex"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): ReportLabel_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportLabel_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["description"] = this.description;
        data["orderIndex"] = this.orderIndex;
        data["selected"] = this.selected;
        return data;
    }
}

/** report label / selection element definition */
export interface IReportLabel_Public {
    /** code */
    code?: string;
    /** description / name of the element */
    description?: string;
    /** order index */
    orderIndex?: number;
    /** default selection flag */
    selected?: boolean;

    [key: string]: any;
}

export class SeriesIdentity_Public implements ISeriesIdentity_Public {
    code?: string;
    tooltip?: string;
    name?: string;

    [key: string]: any;

    constructor(data?: ISeriesIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.tooltip = _data["tooltip"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SeriesIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new SeriesIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["tooltip"] = this.tooltip;
        data["name"] = this.name;
        return data;
    }
}

export interface ISeriesIdentity_Public {
    code?: string;
    tooltip?: string;
    name?: string;

    [key: string]: any;
}

export class SalesReportConfig_Public implements ISalesReportConfig_Public {
    /** list of available company list */
    companyList?: DictionaryItem_Public[];
    /** list of available years */
    yearList?: DictionaryItem_Public[];
    /** list of available segments */
    segmentList?: DictionaryItem_Public[];
    /** list of available report modes */
    reportModeList?: DictionaryItem_Public[];
    /** list of available intermediaries (just for sales person configuration) */
    intermediaryList?: DictionaryItem_Public[];
    /** list of available report scopes */
    reportScopeList?: DictionaryItem_Public[];
    /** list of available reports */
    reportList?: DictionaryItem_Public[];

    [key: string]: any;

    constructor(data?: ISalesReportConfig_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["companyList"])) {
                this.companyList = [] as any;
                for (let item of _data["companyList"]) this.companyList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["yearList"])) {
                this.yearList = [] as any;
                for (let item of _data["yearList"]) this.yearList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["segmentList"])) {
                this.segmentList = [] as any;
                for (let item of _data["segmentList"]) this.segmentList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportModeList"])) {
                this.reportModeList = [] as any;
                for (let item of _data["reportModeList"]) this.reportModeList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["intermediaryList"])) {
                this.intermediaryList = [] as any;
                for (let item of _data["intermediaryList"])
                    this.intermediaryList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportScopeList"])) {
                this.reportScopeList = [] as any;
                for (let item of _data["reportScopeList"])
                    this.reportScopeList!.push(DictionaryItem_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportList"])) {
                this.reportList = [] as any;
                for (let item of _data["reportList"]) this.reportList!.push(DictionaryItem_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportConfig_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesReportConfig_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.companyList)) {
            data["companyList"] = [];
            for (let item of this.companyList) data["companyList"].push(item.toJSON());
        }
        if (Array.isArray(this.yearList)) {
            data["yearList"] = [];
            for (let item of this.yearList) data["yearList"].push(item.toJSON());
        }
        if (Array.isArray(this.segmentList)) {
            data["segmentList"] = [];
            for (let item of this.segmentList) data["segmentList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportModeList)) {
            data["reportModeList"] = [];
            for (let item of this.reportModeList) data["reportModeList"].push(item.toJSON());
        }
        if (Array.isArray(this.intermediaryList)) {
            data["intermediaryList"] = [];
            for (let item of this.intermediaryList) data["intermediaryList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportScopeList)) {
            data["reportScopeList"] = [];
            for (let item of this.reportScopeList) data["reportScopeList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportList)) {
            data["reportList"] = [];
            for (let item of this.reportList) data["reportList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalesReportConfig_Public {
    /** list of available company list */
    companyList?: DictionaryItem_Public[];
    /** list of available years */
    yearList?: DictionaryItem_Public[];
    /** list of available segments */
    segmentList?: DictionaryItem_Public[];
    /** list of available report modes */
    reportModeList?: DictionaryItem_Public[];
    /** list of available intermediaries (just for sales person configuration) */
    intermediaryList?: DictionaryItem_Public[];
    /** list of available report scopes */
    reportScopeList?: DictionaryItem_Public[];
    /** list of available reports */
    reportList?: DictionaryItem_Public[];

    [key: string]: any;
}

/** period definition */
export class PeriodDefinition_Public implements IPeriodDefinition_Public {
    /** list of available years */
    periodList?: ReportLabel_Public[];
    /** segment selection mode */
    selectionMode?: PeriodDefinition_PublicSelectionMode;
    /** if the selection of at least one is required */
    required?: boolean;

    [key: string]: any;

    constructor(data?: IPeriodDefinition_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["periodList"])) {
                this.periodList = [] as any;
                for (let item of _data["periodList"]) this.periodList!.push(ReportLabel_Public.fromJS(item));
            }
            this.selectionMode = _data["selectionMode"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): PeriodDefinition_Public {
        data = typeof data === "object" ? data : {};
        let result = new PeriodDefinition_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.periodList)) {
            data["periodList"] = [];
            for (let item of this.periodList) data["periodList"].push(item.toJSON());
        }
        data["selectionMode"] = this.selectionMode;
        data["required"] = this.required;
        return data;
    }
}

/** period definition */
export interface IPeriodDefinition_Public {
    /** list of available years */
    periodList?: ReportLabel_Public[];
    /** segment selection mode */
    selectionMode?: PeriodDefinition_PublicSelectionMode;
    /** if the selection of at least one is required */
    required?: boolean;

    [key: string]: any;
}

export class ReportConfig_Public implements IReportConfig_Public {
    /** report code */
    report?: ReportConfig_PublicReport;
    /** list of configuration per tenant */
    tenantList?: ReportTenantConfig_Public[];
    /** available report mode list */
    reportModeList?: ReportLabel_Public[];
    /** available report scope list */
    reportScopeList?: ReportLabel_Public[];
    periodDefinition?: PeriodDefinition_Public;

    [key: string]: any;

    constructor(data?: IReportConfig_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.report = _data["report"];
            if (Array.isArray(_data["tenantList"])) {
                this.tenantList = [] as any;
                for (let item of _data["tenantList"]) this.tenantList!.push(ReportTenantConfig_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportModeList"])) {
                this.reportModeList = [] as any;
                for (let item of _data["reportModeList"]) this.reportModeList!.push(ReportLabel_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportScopeList"])) {
                this.reportScopeList = [] as any;
                for (let item of _data["reportScopeList"]) this.reportScopeList!.push(ReportLabel_Public.fromJS(item));
            }
            this.periodDefinition = _data["periodDefinition"]
                ? PeriodDefinition_Public.fromJS(_data["periodDefinition"])
                : <any>undefined;
        }
    }

    static fromJS(data: any): ReportConfig_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportConfig_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["report"] = this.report;
        if (Array.isArray(this.tenantList)) {
            data["tenantList"] = [];
            for (let item of this.tenantList) data["tenantList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportModeList)) {
            data["reportModeList"] = [];
            for (let item of this.reportModeList) data["reportModeList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportScopeList)) {
            data["reportScopeList"] = [];
            for (let item of this.reportScopeList) data["reportScopeList"].push(item.toJSON());
        }
        data["periodDefinition"] = this.periodDefinition ? this.periodDefinition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportConfig_Public {
    /** report code */
    report?: ReportConfig_PublicReport;
    /** list of configuration per tenant */
    tenantList?: ReportTenantConfig_Public[];
    /** available report mode list */
    reportModeList?: ReportLabel_Public[];
    /** available report scope list */
    reportScopeList?: ReportLabel_Public[];
    periodDefinition?: PeriodDefinition_Public;

    [key: string]: any;
}

/** report date information */
export class ReportDateInformation_Public implements IReportDateInformation_Public {
    /** company code */
    companyCode?: ReportDateInformation_PublicCompanyCode;
    /** company name */
    companyName?: string;
    /** timestamp of data snapshot */
    timestamp?: Date;

    [key: string]: any;

    constructor(data?: IReportDateInformation_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.companyCode = _data["companyCode"];
            this.companyName = _data["companyName"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportDateInformation_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportDateInformation_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["companyCode"] = this.companyCode;
        data["companyName"] = this.companyName;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

/** report date information */
export interface IReportDateInformation_Public {
    /** company code */
    companyCode?: ReportDateInformation_PublicCompanyCode;
    /** company name */
    companyName?: string;
    /** timestamp of data snapshot */
    timestamp?: Date;

    [key: string]: any;
}

/** report config at tenant level */
export class ReportTenantConfig_Public implements IReportTenantConfig_Public {
    /** code */
    code?: ReportTenantConfig_PublicCode;
    segmentDefinition?: SegmentDefinition_Public;
    company?: ReportTenantConfig_Public;

    [key: string]: any;

    constructor(data?: IReportTenantConfig_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.segmentDefinition = _data["segmentDefinition"]
                ? SegmentDefinition_Public.fromJS(_data["segmentDefinition"])
                : <any>undefined;
            this.company = _data["company"] ? ReportTenantConfig_Public.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportTenantConfig_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportTenantConfig_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["segmentDefinition"] = this.segmentDefinition ? this.segmentDefinition.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }
}

/** report config at tenant level */
export interface IReportTenantConfig_Public {
    /** code */
    code?: ReportTenantConfig_PublicCode;
    segmentDefinition?: SegmentDefinition_Public;
    company?: ReportTenantConfig_Public;

    [key: string]: any;
}

/** report tenant information / config */
export class ReportTenantInformation_Public implements IReportTenantInformation_Public {
    code?: string;
    name?: string;
    colorScheme?: string;
    orderIndex?: number;

    [key: string]: any;

    constructor(data?: IReportTenantInformation_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
            this.colorScheme = _data["colorScheme"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): ReportTenantInformation_Public {
        data = typeof data === "object" ? data : {};
        let result = new ReportTenantInformation_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        data["colorScheme"] = this.colorScheme;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

/** report tenant information / config */
export interface IReportTenantInformation_Public {
    code?: string;
    name?: string;
    colorScheme?: string;
    orderIndex?: number;

    [key: string]: any;
}

/** report configuration entity */
export class SalesReportConfigV2_Public implements ISalesReportConfigV2_Public {
    /** list of tenants */
    tenantList?: ReportTenantInformation_Public[];
    /** list of report configurations */
    reportList?: ReportConfig_Public[];
    /** list of report date informations */
    reportDateInformationList?: ReportDateInformation_Public[];
    /** list of available intermediaries (used only in sales person context) */
    intermediaryList?: ReportLabel_Public[];

    [key: string]: any;

    constructor(data?: ISalesReportConfigV2_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["tenantList"])) {
                this.tenantList = [] as any;
                for (let item of _data["tenantList"])
                    this.tenantList!.push(ReportTenantInformation_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportList"])) {
                this.reportList = [] as any;
                for (let item of _data["reportList"]) this.reportList!.push(ReportConfig_Public.fromJS(item));
            }
            if (Array.isArray(_data["reportDateInformationList"])) {
                this.reportDateInformationList = [] as any;
                for (let item of _data["reportDateInformationList"])
                    this.reportDateInformationList!.push(ReportDateInformation_Public.fromJS(item));
            }
            if (Array.isArray(_data["intermediaryList"])) {
                this.intermediaryList = [] as any;
                for (let item of _data["intermediaryList"])
                    this.intermediaryList!.push(ReportLabel_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportConfigV2_Public {
        data = typeof data === "object" ? data : {};
        let result = new SalesReportConfigV2_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.tenantList)) {
            data["tenantList"] = [];
            for (let item of this.tenantList) data["tenantList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportList)) {
            data["reportList"] = [];
            for (let item of this.reportList) data["reportList"].push(item.toJSON());
        }
        if (Array.isArray(this.reportDateInformationList)) {
            data["reportDateInformationList"] = [];
            for (let item of this.reportDateInformationList) data["reportDateInformationList"].push(item.toJSON());
        }
        if (Array.isArray(this.intermediaryList)) {
            data["intermediaryList"] = [];
            for (let item of this.intermediaryList) data["intermediaryList"].push(item.toJSON());
        }
        return data;
    }
}

/** report configuration entity */
export interface ISalesReportConfigV2_Public {
    /** list of tenants */
    tenantList?: ReportTenantInformation_Public[];
    /** list of report configurations */
    reportList?: ReportConfig_Public[];
    /** list of report date informations */
    reportDateInformationList?: ReportDateInformation_Public[];
    /** list of available intermediaries (used only in sales person context) */
    intermediaryList?: ReportLabel_Public[];

    [key: string]: any;
}

export class SegmentDefinition_Public implements ISegmentDefinition_Public {
    /** list of available segments */
    list?: ReportLabel_Public[];
    /** selection mode */
    selectionMode?: SegmentDefinition_PublicSelectionMode;

    [key: string]: any;

    constructor(data?: ISegmentDefinition_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(ReportLabel_Public.fromJS(item));
            }
            this.selectionMode = _data["selectionMode"];
        }
    }

    static fromJS(data: any): SegmentDefinition_Public {
        data = typeof data === "object" ? data : {};
        let result = new SegmentDefinition_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["selectionMode"] = this.selectionMode;
        return data;
    }
}

export interface ISegmentDefinition_Public {
    /** list of available segments */
    list?: ReportLabel_Public[];
    /** selection mode */
    selectionMode?: SegmentDefinition_PublicSelectionMode;

    [key: string]: any;
}

/** address definition */
export class Address_Public implements IAddress_Public {
    /** postal code */
    postalCode?: string;
    /** street name */
    streetName?: string;
    /** street number */
    streetNumber?: string;
    /** apartment number */
    apartmentNumber?: string;
    /** city name */
    city?: string;

    [key: string]: any;

    constructor(data?: IAddress_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.postalCode = _data["postalCode"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.apartmentNumber = _data["apartmentNumber"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): Address_Public {
        data = typeof data === "object" ? data : {};
        let result = new Address_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["postalCode"] = this.postalCode;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["apartmentNumber"] = this.apartmentNumber;
        data["city"] = this.city;
        return data;
    }
}

/** address definition */
export interface IAddress_Public {
    /** postal code */
    postalCode?: string;
    /** street name */
    streetName?: string;
    /** street number */
    streetNumber?: string;
    /** apartment number */
    apartmentNumber?: string;
    /** city name */
    city?: string;

    [key: string]: any;
}

/** access control per information block */
export class IntermediaryAcl_Public implements IIntermediaryAcl_Public {
    /** if commission table is accessible */
    commissionTable?: boolean;
    /** if contract list is accessible */
    contracts?: boolean;
    /** if sales person list is accessible */
    employees?: boolean;
    /** if sales reports are accessible */
    salesReports?: boolean;
    /** if notes functionality is accessible */
    notes?: boolean;

    [key: string]: any;

    constructor(data?: IIntermediaryAcl_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.commissionTable = _data["commissionTable"];
            this.contracts = _data["contracts"];
            this.employees = _data["employees"];
            this.salesReports = _data["salesReports"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): IntermediaryAcl_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryAcl_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["commissionTable"] = this.commissionTable;
        data["contracts"] = this.contracts;
        data["employees"] = this.employees;
        data["salesReports"] = this.salesReports;
        data["notes"] = this.notes;
        return data;
    }
}

/** access control per information block */
export interface IIntermediaryAcl_Public {
    /** if commission table is accessible */
    commissionTable?: boolean;
    /** if contract list is accessible */
    contracts?: boolean;
    /** if sales person list is accessible */
    employees?: boolean;
    /** if sales reports are accessible */
    salesReports?: boolean;
    /** if notes functionality is accessible */
    notes?: boolean;

    [key: string]: any;
}

/** commission definition */
export class IntermediaryCommissionRow_Public implements IIntermediaryCommissionRow_Public {
    id?: number;
    system?: DictionaryItem_Public;
    line?: DictionaryItem_Public;
    group?: DictionaryItem_Public;
    /** year-period definition */
    yearGroup?: string;
    /** base rate */
    baseRate?: number;
    /** bonus for dynamics */
    dynamicsRate?: number;
    /** bonus for location */
    locationRate?: number;
    /** bonus for claim ratio */
    claimRatioRate?: number;
    /** order index for sorting purposes */
    orderIndex?: number;

    [key: string]: any;

    constructor(data?: IIntermediaryCommissionRow_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.system = _data["system"] ? DictionaryItem_Public.fromJS(_data["system"]) : <any>undefined;
            this.line = _data["line"] ? DictionaryItem_Public.fromJS(_data["line"]) : <any>undefined;
            this.group = _data["group"] ? DictionaryItem_Public.fromJS(_data["group"]) : <any>undefined;
            this.yearGroup = _data["yearGroup"];
            this.baseRate = _data["baseRate"];
            this.dynamicsRate = _data["dynamicsRate"];
            this.locationRate = _data["locationRate"];
            this.claimRatioRate = _data["claimRatioRate"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): IntermediaryCommissionRow_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryCommissionRow_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["system"] = this.system ? this.system.toJSON() : <any>undefined;
        data["line"] = this.line ? this.line.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["yearGroup"] = this.yearGroup;
        data["baseRate"] = this.baseRate;
        data["dynamicsRate"] = this.dynamicsRate;
        data["locationRate"] = this.locationRate;
        data["claimRatioRate"] = this.claimRatioRate;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

/** commission definition */
export interface IIntermediaryCommissionRow_Public {
    id?: number;
    system?: DictionaryItem_Public;
    line?: DictionaryItem_Public;
    group?: DictionaryItem_Public;
    /** year-period definition */
    yearGroup?: string;
    /** base rate */
    baseRate?: number;
    /** bonus for dynamics */
    dynamicsRate?: number;
    /** bonus for location */
    locationRate?: number;
    /** bonus for claim ratio */
    claimRatioRate?: number;
    /** order index for sorting purposes */
    orderIndex?: number;

    [key: string]: any;
}

/** list contracts */
export class IntermediaryContract_Public implements IIntermediaryContract_Public {
    id?: number;
    /** source system identification code */
    sourceCode?: string;
    /** source system identification of the contract */
    sourceContractId?: string;
    /** start date of the contract */
    startDate?: Date;
    /** end date of the contract */
    endDate?: Date;
    type?: DictionaryItem_Public;
    status?: DictionaryItem_Public;
    period?: DictionaryItem_Public;

    [key: string]: any;

    constructor(data?: IIntermediaryContract_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceContractId = _data["sourceContractId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.period = _data["period"] ? DictionaryItem_Public.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryContract_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryContract_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceContractId"] = this.sourceContractId;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

/** list contracts */
export interface IIntermediaryContract_Public {
    id?: number;
    /** source system identification code */
    sourceCode?: string;
    /** source system identification of the contract */
    sourceContractId?: string;
    /** start date of the contract */
    startDate?: Date;
    /** end date of the contract */
    endDate?: Date;
    type?: DictionaryItem_Public;
    status?: DictionaryItem_Public;
    period?: DictionaryItem_Public;

    [key: string]: any;
}

/** intermediary location list */
export class IntermediaryLocation_Public implements IIntermediaryLocation_Public {
    id?: number;
    /** source system identification code */
    sourceCode?: string;
    /** entity identification in source system */
    sourceLocationId?: string;
    type?: DictionaryItem_Public;
    /** list of location tags (zero or more of SALES_NETWORK_LOCATION_TAG dictionary items) */
    tagList?: DictionaryItem_Public[];
    address?: Address_Public;

    [key: string]: any;

    constructor(data?: IIntermediaryLocation_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceLocationId = _data["sourceLocationId"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"]) this.tagList!.push(DictionaryItem_Public.fromJS(item));
            }
            this.address = _data["address"] ? Address_Public.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryLocation_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryLocation_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceLocationId"] = this.sourceLocationId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList) data["tagList"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

/** intermediary location list */
export interface IIntermediaryLocation_Public {
    id?: number;
    /** source system identification code */
    sourceCode?: string;
    /** entity identification in source system */
    sourceLocationId?: string;
    type?: DictionaryItem_Public;
    /** list of location tags (zero or more of SALES_NETWORK_LOCATION_TAG dictionary items) */
    tagList?: DictionaryItem_Public[];
    address?: Address_Public;

    [key: string]: any;
}

/** list of dynamic attributes */
export class IntermediaryNetworkDynamicAttribute_Public implements IIntermediaryNetworkDynamicAttribute_Public {
    id?: number;
    /** attribute code, one of codes from SALES_NETWORK_ATTRIBUTE dictionary items */
    code?: string;
    definition?: DictionaryItem_Public;
    /** tenant code */
    tenantCode?: string;
    /** string value (only if the type of the attribute is STRING) */
    stringValue?: string;
    /** long / integer value (only if the type of the attribute is LONG) */
    longValue?: number;
    /** decimal value (only if the type of the attribute is DECIMAL) */
    decimalValue?: number;
    /** boolean value (only if the type of the attribute is BOOLEAN) */
    booleanValue?: boolean;
    /** date value (only if the type of the attribute is DATE) */
    dateValue?: Date;
    /** date-time value (only if the type of the attribute is DATETIME) */
    dateTimeValue?: Date;

    [key: string]: any;

    constructor(data?: IIntermediaryNetworkDynamicAttribute_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.definition = _data["definition"] ? DictionaryItem_Public.fromJS(_data["definition"]) : <any>undefined;
            this.tenantCode = _data["tenantCode"];
            this.stringValue = _data["stringValue"];
            this.longValue = _data["longValue"];
            this.decimalValue = _data["decimalValue"];
            this.booleanValue = _data["booleanValue"];
            this.dateValue = _data["dateValue"] ? new Date(_data["dateValue"].toString()) : <any>undefined;
            this.dateTimeValue = _data["dateTimeValue"] ? new Date(_data["dateTimeValue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryNetworkDynamicAttribute_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryNetworkDynamicAttribute_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["tenantCode"] = this.tenantCode;
        data["stringValue"] = this.stringValue;
        data["longValue"] = this.longValue;
        data["decimalValue"] = this.decimalValue;
        data["booleanValue"] = this.booleanValue;
        data["dateValue"] = this.dateValue ? formatDate(this.dateValue) : <any>undefined;
        data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toISOString() : <any>undefined;
        return data;
    }
}

/** list of dynamic attributes */
export interface IIntermediaryNetworkDynamicAttribute_Public {
    id?: number;
    /** attribute code, one of codes from SALES_NETWORK_ATTRIBUTE dictionary items */
    code?: string;
    definition?: DictionaryItem_Public;
    /** tenant code */
    tenantCode?: string;
    /** string value (only if the type of the attribute is STRING) */
    stringValue?: string;
    /** long / integer value (only if the type of the attribute is LONG) */
    longValue?: number;
    /** decimal value (only if the type of the attribute is DECIMAL) */
    decimalValue?: number;
    /** boolean value (only if the type of the attribute is BOOLEAN) */
    booleanValue?: boolean;
    /** date value (only if the type of the attribute is DATE) */
    dateValue?: Date;
    /** date-time value (only if the type of the attribute is DATETIME) */
    dateTimeValue?: Date;

    [key: string]: any;
}

/** list of intermediary profiles */
export class IntermediaryProfile_Public implements IIntermediaryProfile_Public {
    id?: number;
    /** profule number */
    number?: string;
    /** identification of main profile */
    isMain?: boolean;
    /** tenant code */
    tenantCode?: string;
    channel?: DictionaryItem_Public;
    distributionGroup?: DictionaryItem_Public;
    proxy?: DictionaryItem_Public;
    /** list of granted system list, zero or more items of SALES_NETWORK_SYSTEM dictionary items */
    systemList?: DictionaryItem_Public[];
    status?: DictionaryItem_Public;
    branch?: NetworkBranch_Public;
    rms?: UserBasicEntity_Public;
    director?: UserBasicEntity_Public;

    [key: string]: any;

    constructor(data?: IIntermediaryProfile_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.number = _data["number"];
            this.isMain = _data["isMain"];
            this.tenantCode = _data["tenantCode"];
            this.channel = _data["channel"] ? DictionaryItem_Public.fromJS(_data["channel"]) : <any>undefined;
            this.distributionGroup = _data["distributionGroup"]
                ? DictionaryItem_Public.fromJS(_data["distributionGroup"])
                : <any>undefined;
            this.proxy = _data["proxy"] ? DictionaryItem_Public.fromJS(_data["proxy"]) : <any>undefined;
            if (Array.isArray(_data["systemList"])) {
                this.systemList = [] as any;
                for (let item of _data["systemList"]) this.systemList!.push(DictionaryItem_Public.fromJS(item));
            }
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.branch = _data["branch"] ? NetworkBranch_Public.fromJS(_data["branch"]) : <any>undefined;
            this.rms = _data["rms"] ? UserBasicEntity_Public.fromJS(_data["rms"]) : <any>undefined;
            this.director = _data["director"] ? UserBasicEntity_Public.fromJS(_data["director"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryProfile_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryProfile_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["number"] = this.number;
        data["isMain"] = this.isMain;
        data["tenantCode"] = this.tenantCode;
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        data["distributionGroup"] = this.distributionGroup ? this.distributionGroup.toJSON() : <any>undefined;
        data["proxy"] = this.proxy ? this.proxy.toJSON() : <any>undefined;
        if (Array.isArray(this.systemList)) {
            data["systemList"] = [];
            for (let item of this.systemList) data["systemList"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["rms"] = this.rms ? this.rms.toJSON() : <any>undefined;
        data["director"] = this.director ? this.director.toJSON() : <any>undefined;
        return data;
    }
}

/** list of intermediary profiles */
export interface IIntermediaryProfile_Public {
    id?: number;
    /** profule number */
    number?: string;
    /** identification of main profile */
    isMain?: boolean;
    /** tenant code */
    tenantCode?: string;
    channel?: DictionaryItem_Public;
    distributionGroup?: DictionaryItem_Public;
    proxy?: DictionaryItem_Public;
    /** list of granted system list, zero or more items of SALES_NETWORK_SYSTEM dictionary items */
    systemList?: DictionaryItem_Public[];
    status?: DictionaryItem_Public;
    branch?: NetworkBranch_Public;
    rms?: UserBasicEntity_Public;
    director?: UserBasicEntity_Public;

    [key: string]: any;
}

/** list of representatives */
export class IntermediaryRepresentative_Public implements IIntermediaryRepresentative_Public {
    id?: number;
    /** source code (identification of source system) */
    sourceCode?: string;
    /** source representative id (identification in source system) */
    sourceRepresentativeId?: string;
    /** sales person id used for link creation in frontend */
    salesPersonId?: number;
    /** punu number */
    punu?: string;
    /** representative first name */
    firstName?: string;
    /** representative last name */
    lastName?: string;
    /** is the representative the owner of intermediary  */
    isOwner?: boolean;

    [key: string]: any;

    constructor(data?: IIntermediaryRepresentative_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sourceCode = _data["sourceCode"];
            this.sourceRepresentativeId = _data["sourceRepresentativeId"];
            this.salesPersonId = _data["salesPersonId"];
            this.punu = _data["punu"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any): IntermediaryRepresentative_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryRepresentative_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["sourceCode"] = this.sourceCode;
        data["sourceRepresentativeId"] = this.sourceRepresentativeId;
        data["salesPersonId"] = this.salesPersonId;
        data["punu"] = this.punu;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isOwner"] = this.isOwner;
        return data;
    }
}

/** list of representatives */
export interface IIntermediaryRepresentative_Public {
    id?: number;
    /** source code (identification of source system) */
    sourceCode?: string;
    /** source representative id (identification in source system) */
    sourceRepresentativeId?: string;
    /** sales person id used for link creation in frontend */
    salesPersonId?: number;
    /** punu number */
    punu?: string;
    /** representative first name */
    firstName?: string;
    /** representative last name */
    lastName?: string;
    /** is the representative the owner of intermediary  */
    isOwner?: boolean;

    [key: string]: any;
}

export class IntermediaryV360_Public implements IIntermediaryV360_Public {
    /** intermediary technical id */
    id?: number;
    acl?: IntermediaryAcl_Public;
    /** intermediary number */
    number?: string;
    /** intermediary name */
    name?: string;
    /** intermediary tax id */
    nip?: string;
    /** intermediary regon */
    regon?: string;
    branch?: NetworkBranch_Public;
    salesManager?: UserBasicEntity_Public;
    director?: UserBasicEntity_Public;
    /** date of cooperation start with EHM */
    startEHM?: Date;
    /** date of cooperation start with EHZ */
    startEHZ?: Date;
    address?: Address_Public;
    /** intermediary registration email (dynamic attribute REGISTRATION_EMAIL) */
    email?: string;
    /** intermediary registration phone number (dynamic attribute REGISTRATION_PHONE) */
    phone?: string;
    /** list of representatives */
    representativeList?: IntermediaryRepresentative_Public[];
    /** intermediary location list */
    locationList?: IntermediaryLocation_Public[];
    /** list of intermediary profiles */
    profileList?: IntermediaryProfile_Public[];
    /** list contracts */
    contractList?: IntermediaryContract_Public[];
    /** commission definition */
    commissionList?: IntermediaryCommissionRow_Public[];
    /** list of dynamic attributes */
    dynamicAttributeList?: IntermediaryNetworkDynamicAttribute_Public[];
    status?: DictionaryItem_Public;

    [key: string]: any;

    constructor(data?: IIntermediaryV360_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.acl = _data["acl"] ? IntermediaryAcl_Public.fromJS(_data["acl"]) : <any>undefined;
            this.number = _data["number"];
            this.name = _data["name"];
            this.nip = _data["nip"];
            this.regon = _data["regon"];
            this.branch = _data["branch"] ? NetworkBranch_Public.fromJS(_data["branch"]) : <any>undefined;
            this.salesManager = _data["salesManager"]
                ? UserBasicEntity_Public.fromJS(_data["salesManager"])
                : <any>undefined;
            this.director = _data["director"] ? UserBasicEntity_Public.fromJS(_data["director"]) : <any>undefined;
            this.startEHM = _data["startEHM"] ? new Date(_data["startEHM"].toString()) : <any>undefined;
            this.startEHZ = _data["startEHZ"] ? new Date(_data["startEHZ"].toString()) : <any>undefined;
            this.address = _data["address"] ? Address_Public.fromJS(_data["address"]) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["representativeList"])) {
                this.representativeList = [] as any;
                for (let item of _data["representativeList"])
                    this.representativeList!.push(IntermediaryRepresentative_Public.fromJS(item));
            }
            if (Array.isArray(_data["locationList"])) {
                this.locationList = [] as any;
                for (let item of _data["locationList"])
                    this.locationList!.push(IntermediaryLocation_Public.fromJS(item));
            }
            if (Array.isArray(_data["profileList"])) {
                this.profileList = [] as any;
                for (let item of _data["profileList"]) this.profileList!.push(IntermediaryProfile_Public.fromJS(item));
            }
            if (Array.isArray(_data["contractList"])) {
                this.contractList = [] as any;
                for (let item of _data["contractList"])
                    this.contractList!.push(IntermediaryContract_Public.fromJS(item));
            }
            if (Array.isArray(_data["commissionList"])) {
                this.commissionList = [] as any;
                for (let item of _data["commissionList"])
                    this.commissionList!.push(IntermediaryCommissionRow_Public.fromJS(item));
            }
            if (Array.isArray(_data["dynamicAttributeList"])) {
                this.dynamicAttributeList = [] as any;
                for (let item of _data["dynamicAttributeList"])
                    this.dynamicAttributeList!.push(IntermediaryNetworkDynamicAttribute_Public.fromJS(item));
            }
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntermediaryV360_Public {
        data = typeof data === "object" ? data : {};
        let result = new IntermediaryV360_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["acl"] = this.acl ? this.acl.toJSON() : <any>undefined;
        data["number"] = this.number;
        data["name"] = this.name;
        data["nip"] = this.nip;
        data["regon"] = this.regon;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["salesManager"] = this.salesManager ? this.salesManager.toJSON() : <any>undefined;
        data["director"] = this.director ? this.director.toJSON() : <any>undefined;
        data["startEHM"] = this.startEHM ? formatDate(this.startEHM) : <any>undefined;
        data["startEHZ"] = this.startEHZ ? formatDate(this.startEHZ) : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.representativeList)) {
            data["representativeList"] = [];
            for (let item of this.representativeList) data["representativeList"].push(item.toJSON());
        }
        if (Array.isArray(this.locationList)) {
            data["locationList"] = [];
            for (let item of this.locationList) data["locationList"].push(item.toJSON());
        }
        if (Array.isArray(this.profileList)) {
            data["profileList"] = [];
            for (let item of this.profileList) data["profileList"].push(item.toJSON());
        }
        if (Array.isArray(this.contractList)) {
            data["contractList"] = [];
            for (let item of this.contractList) data["contractList"].push(item.toJSON());
        }
        if (Array.isArray(this.commissionList)) {
            data["commissionList"] = [];
            for (let item of this.commissionList) data["commissionList"].push(item.toJSON());
        }
        if (Array.isArray(this.dynamicAttributeList)) {
            data["dynamicAttributeList"] = [];
            for (let item of this.dynamicAttributeList) data["dynamicAttributeList"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIntermediaryV360_Public {
    /** intermediary technical id */
    id?: number;
    acl?: IntermediaryAcl_Public;
    /** intermediary number */
    number?: string;
    /** intermediary name */
    name?: string;
    /** intermediary tax id */
    nip?: string;
    /** intermediary regon */
    regon?: string;
    branch?: NetworkBranch_Public;
    salesManager?: UserBasicEntity_Public;
    director?: UserBasicEntity_Public;
    /** date of cooperation start with EHM */
    startEHM?: Date;
    /** date of cooperation start with EHZ */
    startEHZ?: Date;
    address?: Address_Public;
    /** intermediary registration email (dynamic attribute REGISTRATION_EMAIL) */
    email?: string;
    /** intermediary registration phone number (dynamic attribute REGISTRATION_PHONE) */
    phone?: string;
    /** list of representatives */
    representativeList?: IntermediaryRepresentative_Public[];
    /** intermediary location list */
    locationList?: IntermediaryLocation_Public[];
    /** list of intermediary profiles */
    profileList?: IntermediaryProfile_Public[];
    /** list contracts */
    contractList?: IntermediaryContract_Public[];
    /** commission definition */
    commissionList?: IntermediaryCommissionRow_Public[];
    /** list of dynamic attributes */
    dynamicAttributeList?: IntermediaryNetworkDynamicAttribute_Public[];
    status?: DictionaryItem_Public;

    [key: string]: any;
}

export class V360IntermediaryEmployeeSearchResult_Public implements IV360IntermediaryEmployeeSearchResult_Public {
    /** employee list */
    list?: V360IntermediaryEmployee_Public[];
    /** flag that says if there is more records that fits the query, limit and offset */
    hasMore?: boolean;

    [key: string]: any;

    constructor(data?: IV360IntermediaryEmployeeSearchResult_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(V360IntermediaryEmployee_Public.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): V360IntermediaryEmployeeSearchResult_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360IntermediaryEmployeeSearchResult_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IV360IntermediaryEmployeeSearchResult_Public {
    /** employee list */
    list?: V360IntermediaryEmployee_Public[];
    /** flag that says if there is more records that fits the query, limit and offset */
    hasMore?: boolean;

    [key: string]: any;
}

/** employee list */
export class V360IntermediaryEmployee_Public implements IV360IntermediaryEmployee_Public {
    /** sales person technical id */
    id?: number;
    /** employee first name */
    firstName?: string;
    /** employee last name */
    lastName?: string;
    /** employee punu number */
    punu?: string;
    /** list of companies that the sales person is working with (has active profiles) */
    tenantCodeList?: string[];

    [key: string]: any;

    constructor(data?: IV360IntermediaryEmployee_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.punu = _data["punu"];
            if (Array.isArray(_data["tenantCodeList"])) {
                this.tenantCodeList = [] as any;
                for (let item of _data["tenantCodeList"]) this.tenantCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): V360IntermediaryEmployee_Public {
        data = typeof data === "object" ? data : {};
        let result = new V360IntermediaryEmployee_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["punu"] = this.punu;
        if (Array.isArray(this.tenantCodeList)) {
            data["tenantCodeList"] = [];
            for (let item of this.tenantCodeList) data["tenantCodeList"].push(item);
        }
        return data;
    }
}

/** employee list */
export interface IV360IntermediaryEmployee_Public {
    /** sales person technical id */
    id?: number;
    /** employee first name */
    firstName?: string;
    /** employee last name */
    lastName?: string;
    /** employee punu number */
    punu?: string;
    /** list of companies that the sales person is working with (has active profiles) */
    tenantCodeList?: string[];

    [key: string]: any;
}

export class TokenHolder_Public implements ITokenHolder_Public {
    /** token code */
    token?: string;
    /** url to final application */
    redirectUrl?: string;

    [key: string]: any;

    constructor(data?: ITokenHolder_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.token = _data["token"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TokenHolder_Public {
        data = typeof data === "object" ? data : {};
        let result = new TokenHolder_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["token"] = this.token;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITokenHolder_Public {
    /** token code */
    token?: string;
    /** url to final application */
    redirectUrl?: string;

    [key: string]: any;
}

export class UnderwriterHeader_Public implements IUnderwriterHeader_Public {
    id?: number;
    firstName?: string;
    lastName?: string;
    underwriterNumber?: string;
    login?: string;
    position?: DictionaryItem_Public;
    branch?: NetworkBranch_Public;
    status?: DictionaryItem_Public;
    fullName?: string;

    [key: string]: any;

    constructor(data?: IUnderwriterHeader_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.underwriterNumber = _data["underwriterNumber"];
            this.login = _data["login"];
            this.position = _data["position"] ? DictionaryItem_Public.fromJS(_data["position"]) : <any>undefined;
            this.branch = _data["branch"] ? NetworkBranch_Public.fromJS(_data["branch"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryItem_Public.fromJS(_data["status"]) : <any>undefined;
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UnderwriterHeader_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterHeader_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["underwriterNumber"] = this.underwriterNumber;
        data["login"] = this.login;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUnderwriterHeader_Public {
    id?: number;
    firstName?: string;
    lastName?: string;
    underwriterNumber?: string;
    login?: string;
    position?: DictionaryItem_Public;
    branch?: NetworkBranch_Public;
    status?: DictionaryItem_Public;
    fullName?: string;

    [key: string]: any;
}

export class UnderwriterSearchResult_Public implements IUnderwriterSearchResult_Public {
    list?: UnderwriterHeader_Public[];
    hasMore?: boolean;

    [key: string]: any;

    constructor(data?: IUnderwriterSearchResult_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(UnderwriterHeader_Public.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): UnderwriterSearchResult_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterSearchResult_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IUnderwriterSearchResult_Public {
    list?: UnderwriterHeader_Public[];
    hasMore?: boolean;

    [key: string]: any;
}

export class UnderwriterTraining_Public implements IUnderwriterTraining_Public {
    id?: number;
    /** tenant code */
    tenantCode?: string;
    /** source system identification */
    sourceCode?: string;
    /** source system training identification */
    sourceTrainingId?: string;
    /** training date */
    trainingDate?: Date;
    /** training name */
    trainingName?: string;
    type?: DictionaryItem_Public;
    /** number of training hours */
    hoursCount?: number;
    /** work training flag */
    workTraining?: boolean;
    /** training completion flag */
    completionFlag?: boolean;

    [key: string]: any;

    constructor(data?: IUnderwriterTraining_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenantCode = _data["tenantCode"];
            this.sourceCode = _data["sourceCode"];
            this.sourceTrainingId = _data["sourceTrainingId"];
            this.trainingDate = _data["trainingDate"] ? new Date(_data["trainingDate"].toString()) : <any>undefined;
            this.trainingName = _data["trainingName"];
            this.type = _data["type"] ? DictionaryItem_Public.fromJS(_data["type"]) : <any>undefined;
            this.hoursCount = _data["hoursCount"];
            this.workTraining = _data["workTraining"];
            this.completionFlag = _data["completionFlag"];
        }
    }

    static fromJS(data: any): UnderwriterTraining_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterTraining_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenantCode"] = this.tenantCode;
        data["sourceCode"] = this.sourceCode;
        data["sourceTrainingId"] = this.sourceTrainingId;
        data["trainingDate"] = this.trainingDate ? formatDate(this.trainingDate) : <any>undefined;
        data["trainingName"] = this.trainingName;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["hoursCount"] = this.hoursCount;
        data["workTraining"] = this.workTraining;
        data["completionFlag"] = this.completionFlag;
        return data;
    }
}

export interface IUnderwriterTraining_Public {
    id?: number;
    /** tenant code */
    tenantCode?: string;
    /** source system identification */
    sourceCode?: string;
    /** source system training identification */
    sourceTrainingId?: string;
    /** training date */
    trainingDate?: Date;
    /** training name */
    trainingName?: string;
    type?: DictionaryItem_Public;
    /** number of training hours */
    hoursCount?: number;
    /** work training flag */
    workTraining?: boolean;
    /** training completion flag */
    completionFlag?: boolean;

    [key: string]: any;
}

/** underwriter team search result wrapper */
export class UnderwriterTeamSearchResult_Public implements IUnderwriterTeamSearchResult_Public {
    /** list of underwriter teams matching search criteria */
    list?: UnderwriterTeam_Public[];
    /** flag that represents if more results exists (with greater orderIndex) */
    hasMore?: boolean;

    [key: string]: any;

    constructor(data?: IUnderwriterTeamSearchResult_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(UnderwriterTeam_Public.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): UnderwriterTeamSearchResult_Public {
        data = typeof data === "object" ? data : {};
        let result = new UnderwriterTeamSearchResult_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        return data;
    }
}

/** underwriter team search result wrapper */
export interface IUnderwriterTeamSearchResult_Public {
    /** list of underwriter teams matching search criteria */
    list?: UnderwriterTeam_Public[];
    /** flag that represents if more results exists (with greater orderIndex) */
    hasMore?: boolean;

    [key: string]: any;
}

/** list of group score elements */
export class AggregationGroupScoreInternal_Public implements IAggregationGroupScoreInternal_Public {
    /** code of the company */
    companyCode?: string;
    /** aggregation group (one of SEGMENT_CM, SEGMENT_B, ERGO4, SIRIUS */
    group?: AggregationGroupScoreInternal_PublicGroup;
    /** sales network type (one of CLASSIC, NATIONAL */
    salesNetworkType?: AggregationGroupScoreInternal_PublicSalesNetworkType;
    /** target goal */
    target?: number;
    /** current value */
    value?: number;
    /** progress; maximum is 100 */
    progress?: number;
    /** progress value - mostly same as the progress, but if the progress is above the line, it's not limited to 100 */
    progressValue?: number;
    /** ahead of plan realization */
    ahead?: number;
    /** status of hte score; if the ahead is positive or progress value is greater or equal to 100 then the status is OK, otherwise its NOK */
    status?: AggregationGroupScoreInternal_PublicStatus;

    [key: string]: any;

    constructor(data?: IAggregationGroupScoreInternal_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.companyCode = _data["companyCode"];
            this.group = _data["group"];
            this.salesNetworkType = _data["salesNetworkType"];
            this.target = _data["target"];
            this.value = _data["value"];
            this.progress = _data["progress"];
            this.progressValue = _data["progressValue"];
            this.ahead = _data["ahead"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AggregationGroupScoreInternal_Public {
        data = typeof data === "object" ? data : {};
        let result = new AggregationGroupScoreInternal_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["companyCode"] = this.companyCode;
        data["group"] = this.group;
        data["salesNetworkType"] = this.salesNetworkType;
        data["target"] = this.target;
        data["value"] = this.value;
        data["progress"] = this.progress;
        data["progressValue"] = this.progressValue;
        data["ahead"] = this.ahead;
        data["status"] = this.status;
        return data;
    }
}

/** list of group score elements */
export interface IAggregationGroupScoreInternal_Public {
    /** code of the company */
    companyCode?: string;
    /** aggregation group (one of SEGMENT_CM, SEGMENT_B, ERGO4, SIRIUS */
    group?: AggregationGroupScoreInternal_PublicGroup;
    /** sales network type (one of CLASSIC, NATIONAL */
    salesNetworkType?: AggregationGroupScoreInternal_PublicSalesNetworkType;
    /** target goal */
    target?: number;
    /** current value */
    value?: number;
    /** progress; maximum is 100 */
    progress?: number;
    /** progress value - mostly same as the progress, but if the progress is above the line, it's not limited to 100 */
    progressValue?: number;
    /** ahead of plan realization */
    ahead?: number;
    /** status of hte score; if the ahead is positive or progress value is greater or equal to 100 then the status is OK, otherwise its NOK */
    status?: AggregationGroupScoreInternal_PublicStatus;

    [key: string]: any;
}

/** list of score card elements */
export class ScoreCardElement_Public implements IScoreCardElement_Public {
    /** user full name */
    userFullName?: string;
    /** users branch name */
    branchName?: string;
    /** username */
    username?: string;
    /** flag if the current record is related to the person context (its like `mine` flag) */
    main?: boolean;
    /** list of group score elements */
    groupScoreList?: AggregationGroupScoreInternal_Public[];

    [key: string]: any;

    constructor(data?: IScoreCardElement_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.userFullName = _data["userFullName"];
            this.branchName = _data["branchName"];
            this.username = _data["username"];
            this.main = _data["main"];
            if (Array.isArray(_data["groupScoreList"])) {
                this.groupScoreList = [] as any;
                for (let item of _data["groupScoreList"])
                    this.groupScoreList!.push(AggregationGroupScoreInternal_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScoreCardElement_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScoreCardElement_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["userFullName"] = this.userFullName;
        data["branchName"] = this.branchName;
        data["username"] = this.username;
        data["main"] = this.main;
        if (Array.isArray(this.groupScoreList)) {
            data["groupScoreList"] = [];
            for (let item of this.groupScoreList) data["groupScoreList"].push(item.toJSON());
        }
        return data;
    }
}

/** list of score card elements */
export interface IScoreCardElement_Public {
    /** user full name */
    userFullName?: string;
    /** users branch name */
    branchName?: string;
    /** username */
    username?: string;
    /** flag if the current record is related to the person context (its like `mine` flag) */
    main?: boolean;
    /** list of group score elements */
    groupScoreList?: AggregationGroupScoreInternal_Public[];

    [key: string]: any;
}

export class ScoreCardTimePeriod_Public implements IScoreCardTimePeriod_Public {
    /** report date (date of report data collected in the system) */
    reportDate?: Date;
    /** starting date of the report period */
    startDate?: Date;
    /** list of score card elements */
    list?: ScoreCardElement_Public[];
    /** end date of the reporting period */
    endDate?: Date;
    /** percentage progress of reporting period */
    progress?: number;

    [key: string]: any;

    constructor(data?: IScoreCardTimePeriod_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"]) this.list!.push(ScoreCardElement_Public.fromJS(item));
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): ScoreCardTimePeriod_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScoreCardTimePeriod_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["reportDate"] = this.reportDate ? formatDate(this.reportDate) : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list) data["list"].push(item.toJSON());
        }
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IScoreCardTimePeriod_Public {
    /** report date (date of report data collected in the system) */
    reportDate?: Date;
    /** starting date of the report period */
    startDate?: Date;
    /** list of score card elements */
    list?: ScoreCardElement_Public[];
    /** end date of the reporting period */
    endDate?: Date;
    /** percentage progress of reporting period */
    progress?: number;

    [key: string]: any;
}

/** score card entity list */
export class ScorecardEntityV3_Public implements IScorecardEntityV3_Public {
    id?: number;
    /** score card entity token */
    token?: string;
    /** score card token */
    scorecardToken?: string;
    /** score card level */
    level?: ScorecardEntityV3_PublicLevel;
    /** score card type */
    scorecardType?: ScorecardEntityV3_PublicScorecardType;
    /** branch code */
    branchCode?: string;
    /** branch name */
    branchName?: string;
    /** username */
    username?: string;
    /** user first name */
    firstName?: string;
    /** user last name */
    lastName?: string;
    /** score card token */
    goalList?: ScorecardGoalV3_Public[];

    [key: string]: any;

    constructor(data?: IScorecardEntityV3_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.token = _data["token"];
            this.scorecardToken = _data["scorecardToken"];
            this.level = _data["level"];
            this.scorecardType = _data["scorecardType"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["goalList"])) {
                this.goalList = [] as any;
                for (let item of _data["goalList"]) this.goalList!.push(ScorecardGoalV3_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScorecardEntityV3_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardEntityV3_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["token"] = this.token;
        data["scorecardToken"] = this.scorecardToken;
        data["level"] = this.level;
        data["scorecardType"] = this.scorecardType;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.goalList)) {
            data["goalList"] = [];
            for (let item of this.goalList) data["goalList"].push(item.toJSON());
        }
        return data;
    }
}

/** score card entity list */
export interface IScorecardEntityV3_Public {
    id?: number;
    /** score card entity token */
    token?: string;
    /** score card token */
    scorecardToken?: string;
    /** score card level */
    level?: ScorecardEntityV3_PublicLevel;
    /** score card type */
    scorecardType?: ScorecardEntityV3_PublicScorecardType;
    /** branch code */
    branchCode?: string;
    /** branch name */
    branchName?: string;
    /** username */
    username?: string;
    /** user first name */
    firstName?: string;
    /** user last name */
    lastName?: string;
    /** score card token */
    goalList?: ScorecardGoalV3_Public[];

    [key: string]: any;
}

export class ScorecardV3_Public implements IScorecardV3_Public {
    id?: number;
    /** score card unique token */
    token?: string;
    /** score card period type */
    periodType?: ScorecardV3_PublicPeriodType;
    /** score card status */
    status?: ScorecardV3_PublicStatus;
    /** score card status timestamp */
    statusDate?: Date;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;
    /** period description (to be shown for user selection) */
    description?: string;
    /** score card entity list */
    entityList?: ScorecardEntityV3_Public[];
    timeProgress?: number;

    [key: string]: any;

    constructor(data?: IScorecardV3_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.token = _data["token"];
            this.periodType = _data["periodType"];
            this.status = _data["status"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["entityList"])) {
                this.entityList = [] as any;
                for (let item of _data["entityList"]) this.entityList!.push(ScorecardEntityV3_Public.fromJS(item));
            }
            this.timeProgress = _data["timeProgress"];
        }
    }

    static fromJS(data: any): ScorecardV3_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScorecardV3_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["token"] = this.token;
        data["periodType"] = this.periodType;
        data["status"] = this.status;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.entityList)) {
            data["entityList"] = [];
            for (let item of this.entityList) data["entityList"].push(item.toJSON());
        }
        data["timeProgress"] = this.timeProgress;
        return data;
    }
}

export interface IScorecardV3_Public {
    id?: number;
    /** score card unique token */
    token?: string;
    /** score card period type */
    periodType?: ScorecardV3_PublicPeriodType;
    /** score card status */
    status?: ScorecardV3_PublicStatus;
    /** score card status timestamp */
    statusDate?: Date;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;
    /** period description (to be shown for user selection) */
    description?: string;
    /** score card entity list */
    entityList?: ScorecardEntityV3_Public[];
    timeProgress?: number;

    [key: string]: any;
}

export class ScoreCardPeriodIdentity_Public implements IScoreCardPeriodIdentity_Public {
    /** report period code */
    periodCode?: string;
    /** period description (to be shown for user selection) */
    description?: string;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;

    [key: string]: any;

    constructor(data?: IScoreCardPeriodIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.periodCode = _data["periodCode"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScoreCardPeriodIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new ScoreCardPeriodIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["periodCode"] = this.periodCode;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        return data;
    }
}

export interface IScoreCardPeriodIdentity_Public {
    /** report period code */
    periodCode?: string;
    /** period description (to be shown for user selection) */
    description?: string;
    /** start date of the period */
    startDate?: Date;
    /** end date of the period */
    endDate?: Date;

    [key: string]: any;
}

/** list of ranking columns */
export class RankingColumn_Public implements IRankingColumn_Public {
    /** company code */
    companyCode?: string;
    /** aggregation group */
    group?: RankingColumn_PublicGroup;
    /** network type */
    salesNetworkType?: RankingColumn_PublicSalesNetworkType;
    /** ranking position */
    position?: number;
    /** number of elements in ranking group */
    groupCount?: number;
    /** position change / delta vs previous measurement */
    positionDelta?: number;
    /** plan target value */
    planTarget?: number;
    /** plan realization value */
    planValue?: number;

    [key: string]: any;

    constructor(data?: IRankingColumn_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.companyCode = _data["companyCode"];
            this.group = _data["group"];
            this.salesNetworkType = _data["salesNetworkType"];
            this.position = _data["position"];
            this.groupCount = _data["groupCount"];
            this.positionDelta = _data["positionDelta"];
            this.planTarget = _data["planTarget"];
            this.planValue = _data["planValue"];
        }
    }

    static fromJS(data: any): RankingColumn_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingColumn_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["companyCode"] = this.companyCode;
        data["group"] = this.group;
        data["salesNetworkType"] = this.salesNetworkType;
        data["position"] = this.position;
        data["groupCount"] = this.groupCount;
        data["positionDelta"] = this.positionDelta;
        data["planTarget"] = this.planTarget;
        data["planValue"] = this.planValue;
        return data;
    }
}

/** list of ranking columns */
export interface IRankingColumn_Public {
    /** company code */
    companyCode?: string;
    /** aggregation group */
    group?: RankingColumn_PublicGroup;
    /** network type */
    salesNetworkType?: RankingColumn_PublicSalesNetworkType;
    /** ranking position */
    position?: number;
    /** number of elements in ranking group */
    groupCount?: number;
    /** position change / delta vs previous measurement */
    positionDelta?: number;
    /** plan target value */
    planTarget?: number;
    /** plan realization value */
    planValue?: number;

    [key: string]: any;
}

/** ranking report row list */
export class RankingReportElement_Public implements IRankingReportElement_Public {
    /** entity name */
    entityName?: string;
    /** flag if the row is related to user context (mine) */
    main?: boolean;
    /** list of ranking columns */
    rankingList?: RankingColumn_Public[];

    [key: string]: any;

    constructor(data?: IRankingReportElement_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.entityName = _data["entityName"];
            this.main = _data["main"];
            if (Array.isArray(_data["rankingList"])) {
                this.rankingList = [] as any;
                for (let item of _data["rankingList"]) this.rankingList!.push(RankingColumn_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RankingReportElement_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingReportElement_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["entityName"] = this.entityName;
        data["main"] = this.main;
        if (Array.isArray(this.rankingList)) {
            data["rankingList"] = [];
            for (let item of this.rankingList) data["rankingList"].push(item.toJSON());
        }
        return data;
    }
}

/** ranking report row list */
export interface IRankingReportElement_Public {
    /** entity name */
    entityName?: string;
    /** flag if the row is related to user context (mine) */
    main?: boolean;
    /** list of ranking columns */
    rankingList?: RankingColumn_Public[];

    [key: string]: any;
}

export class RankingReport_Public implements IRankingReport_Public {
    /** period start date */
    startDate?: Date;
    /** period end date */
    endDate?: Date;
    /** period type */
    periodType?: RankingReport_PublicPeriodType;
    /** ranking report row list */
    rowList?: RankingReportElement_Public[];

    [key: string]: any;

    constructor(data?: IRankingReport_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.periodType = _data["periodType"];
            if (Array.isArray(_data["rowList"])) {
                this.rowList = [] as any;
                for (let item of _data["rowList"]) this.rowList!.push(RankingReportElement_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RankingReport_Public {
        data = typeof data === "object" ? data : {};
        let result = new RankingReport_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["periodType"] = this.periodType;
        if (Array.isArray(this.rowList)) {
            data["rowList"] = [];
            for (let item of this.rowList) data["rowList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRankingReport_Public {
    /** period start date */
    startDate?: Date;
    /** period end date */
    endDate?: Date;
    /** period type */
    periodType?: RankingReport_PublicPeriodType;
    /** ranking report row list */
    rowList?: RankingReportElement_Public[];

    [key: string]: any;
}

export class NoteUserIdentity_Public implements INoteUserIdentity_Public {
    id?: number;
    firstName?: string;
    lastName?: string;
    businessRole?: NoteUserIdentity_PublicBusinessRole;
    branchCode?: string;

    [key: string]: any;

    constructor(data?: INoteUserIdentity_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessRole = _data["businessRole"];
            this.branchCode = _data["branchCode"];
        }
    }

    static fromJS(data: any): NoteUserIdentity_Public {
        data = typeof data === "object" ? data : {};
        let result = new NoteUserIdentity_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessRole"] = this.businessRole;
        data["branchCode"] = this.branchCode;
        return data;
    }
}

export interface INoteUserIdentity_Public {
    id?: number;
    firstName?: string;
    lastName?: string;
    businessRole?: NoteUserIdentity_PublicBusinessRole;
    branchCode?: string;

    [key: string]: any;
}

export class Dictionary_Public implements IDictionary_Public {
    id?: number;
    code?: string;
    description?: string;
    flexField1?: string;
    editable?: boolean;
    itemList?: DictionaryItem_Public[];

    [key: string]: any;

    constructor(data?: IDictionary_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.flexField1 = _data["flexField1"];
            this.editable = _data["editable"];
            if (Array.isArray(_data["itemList"])) {
                this.itemList = [] as any;
                for (let item of _data["itemList"]) this.itemList!.push(DictionaryItem_Public.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dictionary_Public {
        data = typeof data === "object" ? data : {};
        let result = new Dictionary_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["flexField1"] = this.flexField1;
        data["editable"] = this.editable;
        if (Array.isArray(this.itemList)) {
            data["itemList"] = [];
            for (let item of this.itemList) data["itemList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDictionary_Public {
    id?: number;
    code?: string;
    description?: string;
    flexField1?: string;
    editable?: boolean;
    itemList?: DictionaryItem_Public[];

    [key: string]: any;
}

export class DictionaryItemWithTranslationMap_Public implements IDictionaryItemWithTranslationMap_Public {
    id?: number;
    code!: string;
    deleted?: boolean;
    descriptionTranslationCode?: string;
    description?: string;
    flexField1?: string;
    flexFilter1?: string[];
    orderIndex?: number;
    translationMap?: { [key: string]: string };

    [key: string]: any;

    constructor(data?: IDictionaryItemWithTranslationMap_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.deleted = _data["deleted"];
            this.descriptionTranslationCode = _data["descriptionTranslationCode"];
            this.description = _data["description"];
            this.flexField1 = _data["flexField1"];
            if (Array.isArray(_data["flexFilter1"])) {
                this.flexFilter1 = [] as any;
                for (let item of _data["flexFilter1"]) this.flexFilter1!.push(item);
            }
            this.orderIndex = _data["orderIndex"];
            if (_data["translationMap"]) {
                this.translationMap = {} as any;
                for (let key in _data["translationMap"]) {
                    if (_data["translationMap"].hasOwnProperty(key))
                        (<any>this.translationMap)![key] = _data["translationMap"][key];
                }
            }
        }
    }

    static fromJS(data: any): DictionaryItemWithTranslationMap_Public {
        data = typeof data === "object" ? data : {};
        let result = new DictionaryItemWithTranslationMap_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["deleted"] = this.deleted;
        data["descriptionTranslationCode"] = this.descriptionTranslationCode;
        data["description"] = this.description;
        data["flexField1"] = this.flexField1;
        if (Array.isArray(this.flexFilter1)) {
            data["flexFilter1"] = [];
            for (let item of this.flexFilter1) data["flexFilter1"].push(item);
        }
        data["orderIndex"] = this.orderIndex;
        if (this.translationMap) {
            data["translationMap"] = {};
            for (let key in this.translationMap) {
                if (this.translationMap.hasOwnProperty(key))
                    (<any>data["translationMap"])[key] = (<any>this.translationMap)[key];
            }
        }
        return data;
    }
}

export interface IDictionaryItemWithTranslationMap_Public {
    id?: number;
    code: string;
    deleted?: boolean;
    descriptionTranslationCode?: string;
    description?: string;
    flexField1?: string;
    flexFilter1?: string[];
    orderIndex?: number;
    translationMap?: { [key: string]: string };

    [key: string]: any;
}

export class FrontendConfig implements IFrontendConfig {
    /** flag that represents production / non production environment (production when true) */
    production?: boolean;
    /** list of feature flags */
    featureFlags?: { [key: string]: boolean }[];
    /** azure user authentication url */
    azureAuthUrl?: string;

    [key: string]: any;

    constructor(data?: IFrontendConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.production = _data["production"];
            if (Array.isArray(_data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item of _data["featureFlags"]) this.featureFlags!.push(item);
            }
            this.azureAuthUrl = _data["azureAuthUrl"];
        }
    }

    static fromJS(data: any): FrontendConfig {
        data = typeof data === "object" ? data : {};
        let result = new FrontendConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["production"] = this.production;
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item of this.featureFlags) data["featureFlags"].push(item);
        }
        data["azureAuthUrl"] = this.azureAuthUrl;
        return data;
    }
}

export interface IFrontendConfig {
    /** flag that represents production / non production environment (production when true) */
    production?: boolean;
    /** list of feature flags */
    featureFlags?: { [key: string]: boolean }[];
    /** azure user authentication url */
    azureAuthUrl?: string;

    [key: string]: any;
}

export class ApiError_Public implements IApiError_Public {
    message?: string;

    [key: string]: any;

    constructor(data?: IApiError_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiError_Public {
        data = typeof data === "object" ? data : {};
        let result = new ApiError_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IApiError_Public {
    message?: string;

    [key: string]: any;
}

export class ApiValidationError_Public implements IApiValidationError_Public {
    field?: string;
    code?: string;
    description?: string;

    [key: string]: any;

    constructor(data?: IApiValidationError_Public) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property)) this[property] = _data[property];
            }
            this.field = _data["field"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ApiValidationError_Public {
        data = typeof data === "object" ? data : {};
        let result = new ApiValidationError_Public();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property)) data[property] = this[property];
        }
        data["field"] = this.field;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IApiValidationError_Public {
    field?: string;
    code?: string;
    description?: string;

    [key: string]: any;
}

/** order by column */
export enum OrderByField {
    FullName = "fullName",
    Status = "status",
    Position = "position",
    Id = "id",
    BranchCode = "branchCode",
}

/** order direction (asc, desc) */
export enum OrderIndex {
    Asc = "asc",
    Desc = "desc",
}

/** order by column */
export enum OrderByField2 {
    Code = "code",
    Name = "name",
}

/** order direction (asc, desc) */
export enum OrderIndex2 {
    Asc = "asc",
    Desc = "desc",
}

export enum PeriodType {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum EntityNote_PublicEntityType {
    INTERMEDIARY = "INTERMEDIARY",
    OFWCA = "OFWCA",
}

export enum OperationList {
    EDIT = "EDIT",
    REMOVE = "REMOVE",
}

export enum DashboardTaskAttribute_PublicType {
    STRING = "STRING",
    LONG = "LONG",
    DECIMAL = "DECIMAL",
    DATE = "DATE",
    DATETIME = "DATETIME",
    DICTIONARY_ITEM = "DICTIONARY_ITEM",
    CUSTOM = "CUSTOM",
}

export enum OperationList2 {
    ADD = "ADD",
    EDIT = "EDIT",
    DELETE = "DELETE",
}

/** list of available operations for the comment */
export enum OperationList3 {
    ADD = "ADD",
    EDIT = "EDIT",
    DELETE = "DELETE",
}

export enum OperationList4 {
    CLOSE = "CLOSE",
}

export enum SystemUserIdentity_PublicBusinessRole {
    HQ = "HQ",
    MS = "MS",
    DP = "DP",
    NONE = "NONE",
}

export enum ReportDefinition_PublicCode {
    SALESPERSON_MONTHLY_SALES = "SALESPERSON_MONTHLY_SALES",
    SALESPERSON_SALES_CUMULATIVE = "SALESPERSON_SALES_CUMULATIVE",
    SALESPERSON_SALES_STRUCTURE = "SALESPERSON_SALES_STRUCTURE",
    SALESPERSON_SALES = "SALESPERSON_SALES",
    SALESPERSON_ACTIVITY = "SALESPERSON_ACTIVITY",
    INTERMEDIARY_MONTHLY_SALES = "INTERMEDIARY_MONTHLY_SALES",
    INTERMEDIARY_SALES_CUMULATIVE = "INTERMEDIARY_SALES_CUMULATIVE",
    INTERMEDIARY_SALES_STRUCTURE = "INTERMEDIARY_SALES_STRUCTURE",
    INTERMEDIARY_SALES = "INTERMEDIARY_SALES",
    INTERMEDIARY_ACTIVITY = "INTERMEDIARY_ACTIVITY",
    INTERMEDIARY_CUSTOMER = "INTERMEDIARY_CUSTOMER",
    INTERMEDIARY_OTHER = "INTERMEDIARY_OTHER",
    INTERMEDIARY_CLAIM_RATIO = "INTERMEDIARY_CLAIM_RATIO",
    NOTE_COUNTER = "NOTE_COUNTER",
}

export enum ReportSeries_PublicUnitType {
    NUMERIC = "NUMERIC",
    STRING = "STRING",
    PERCENTAGE = "PERCENTAGE",
}

export enum ScorecardReportV3Filter_PublicLevel {
    HQ = "HQ",
    DP = "DP",
    MS = "MS",
}

export enum ScorecardGoalV3_PublicTenant {
    EHM = "EHM",
    EHZ = "EHZ",
}

export enum ScorecardGoalV3_PublicStatus {
    OK = "OK",
    NOK = "NOK",
}

export enum ScorecardGoalV3_PublicUnit {
    STRING = "STRING",
    NUMERIC = "NUMERIC",
    CURRENCY = "CURRENCY",
    PERCENTAGE = "PERCENTAGE",
}

export enum ScorecardV3ReportEntity_PublicScoreCardType {
    RETAIL = "RETAIL",
    CORPO = "CORPO",
}

export enum ScorecardV3Report_PublicPeriodType {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum RankingV3ReportFilter_PublicLevel {
    DP = "DP",
    MS = "MS",
}

export enum RankingV3ReportFilter_PublicPeriod {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum RankingV3Element_PublicTenant {
    EHM = "EHM",
    EHZ = "EHZ",
}

export enum RankingV3Element_PublicUnit {
    STRING = "STRING",
    NUMERIC = "NUMERIC",
    CURRENCY = "CURRENCY",
    PERCENTAGE = "PERCENTAGE",
}

export enum RankingV3ReportEntity_PublicRankingType {
    RETAIL = "RETAIL",
    CORPO = "CORPO",
}

export enum RankingV3ReportEntity_PublicLevel {
    DP = "DP",
    MS = "MS",
}

export enum SystemUser_PublicBusinessRole {
    HQ = "HQ",
    MS = "MS",
    DP = "DP",
    NONE = "NONE",
}

export enum EntityNoteHeader_PublicEntityType {
    INTERMEDIARY = "INTERMEDIARY",
    OFWCA = "OFWCA",
}

export enum PeriodDefinition_PublicSelectionMode {
    SINGLE = "SINGLE",
    MULTIPLE = "MULTIPLE",
}

export enum ReportConfig_PublicReport {
    SALESPERSON_MONTHLY_SALES = "SALESPERSON_MONTHLY_SALES",
    SALESPERSON_SALES_CUMULATIVE = "SALESPERSON_SALES_CUMULATIVE",
    SALESPERSON_SALES_STRUCTURE = "SALESPERSON_SALES_STRUCTURE",
    SALESPERSON_SALES = "SALESPERSON_SALES",
    SALESPERSON_ACTIVITY = "SALESPERSON_ACTIVITY",
    INTERMEDIARY_MONTHLY_SALES = "INTERMEDIARY_MONTHLY_SALES",
    INTERMEDIARY_SALES_CUMULATIVE = "INTERMEDIARY_SALES_CUMULATIVE",
    INTERMEDIARY_SALES_STRUCTURE = "INTERMEDIARY_SALES_STRUCTURE",
    INTERMEDIARY_SALES = "INTERMEDIARY_SALES",
    INTERMEDIARY_ACTIVITY = "INTERMEDIARY_ACTIVITY",
    INTERMEDIARY_CUSTOMER = "INTERMEDIARY_CUSTOMER",
    INTERMEDIARY_OTHER = "INTERMEDIARY_OTHER",
    INTERMEDIARY_CLAIM_RATIO = "INTERMEDIARY_CLAIM_RATIO",
    NOTE_COUNTER = "NOTE_COUNTER",
}

export enum ReportDateInformation_PublicCompanyCode {
    EHM = "EHM",
    EHZ = "EHZ",
}

export enum ReportTenantConfig_PublicCode {
    EHM = "EHM",
    EHZ = "EHZ",
}

export enum SegmentDefinition_PublicSelectionMode {
    SINGLE = "SINGLE",
    MULTIPLE = "MULTIPLE",
}

export enum AggregationGroupScoreInternal_PublicGroup {
    SEGMENT_CM = "SEGMENT_CM",
    SEGMENT_B = "SEGMENT_B",
    ERGO4 = "ERGO4",
    SIRIUS = "SIRIUS",
}

export enum AggregationGroupScoreInternal_PublicSalesNetworkType {
    CLASSIC = "CLASSIC",
    NATIONAL = "NATIONAL",
}

export enum AggregationGroupScoreInternal_PublicStatus {
    OK = "OK",
    NOK = "NOK",
}

export enum ScorecardEntityV3_PublicLevel {
    HQ = "HQ",
    DP = "DP",
    MS = "MS",
}

export enum ScorecardEntityV3_PublicScorecardType {
    RETAIL = "RETAIL",
    CORPO = "CORPO",
}

export enum ScorecardV3_PublicPeriodType {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum ScorecardV3_PublicStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
}

export enum RankingColumn_PublicGroup {
    SEGMENT_CM = "SEGMENT_CM",
    SEGMENT_B = "SEGMENT_B",
    ERGO4 = "ERGO4",
    SIRIUS = "SIRIUS",
}

export enum RankingColumn_PublicSalesNetworkType {
    CLASSIC = "CLASSIC",
    NATIONAL = "NATIONAL",
}

export enum RankingReport_PublicPeriodType {
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
}

export enum NoteUserIdentity_PublicBusinessRole {
    HQ = "HQ",
    MS = "MS",
    DP = "DP",
    NONE = "NONE",
}

function formatDate(d: Date) {
    return (
        d.getFullYear() +
        "-" +
        (d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
        "-" +
        (d.getDate() < 10 ? "0" + d.getDate() : d.getDate())
    );
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
